{
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "retry": "Erneut versuchen",
    "dismiss": "Schließen",
    "confirm": "Bestätigen",
    "delete": "Löschen",
    "deleting": "Wird gelöscht…",
    "creating": "Wird erstellt…",
    "edit": "Bearbeiten",
    "you": "Du",
    "signOut": "Abmelden",
    "backToHome": "Zurück zur Startseite",
    "pleaseTryAgain": "Bitte versuche es erneut.",
    "copy": "Kopieren",
    "noWorkspaceSelected": "Kein Workspace ausgewählt.",
    "color": "Farbe",
    "reset": "Zurücksetzen",
    "discard": "Verwerfen",
    "discardChangesTitle": "Änderungen verwerfen?",
    "discardChangesBody": "Du hast Änderungen, die du nicht gespeichert hast. Wenn du jetzt schließt, sind sie weg.",
    "saving": "Wird gespeichert",
    "diff": {
      "summary": "{removed} entfernt · {added} hinzugefügt"
    },
    "back": "Zurück",
    "next": "Weiter",
    "sortBy": "Sortieren nach",
    "sortAsc": "Aufsteigend sortiert",
    "sortDesc": "Absteigend sortiert",
    "table": {
      "range": "{from}-{to} von {total}",
      "pageSize": "Zeilen pro Seite",
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "selectRow": "Zeile auswählen",
      "empty": "Noch nichts zu zeigen"
    },
    "copyFailed": "Kopieren nicht möglich"
  },
  "errors": {
    "somethingWentWrong": "Etwas ist schiefgelaufen.",
    "offline": "Du bist offline. Prüfe deine Verbindung und versuche es erneut.",
    "rateLimited": "Zu viele Anfragen. Bitte warte einen Moment und versuche es erneut.",
    "sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    "notFoundTitle": "Seite nicht gefunden",
    "notFoundDescription": "Die gesuchte Seite existiert nicht.",
    "unknownError": "Ein unbekannter Fehler ist aufgetreten.",
    "planRun": {
      "enqueueFailed": "Raldo konnte den Plan nicht starten. Versuch es noch einmal.",
      "inProgress": "Ein Plan läuft schon. Warte, bis er fertig ist.",
      "failed": "Der Plan ist mit einem Fehler stehen geblieben. Versuch es noch einmal.",
      "domainUnknown": "Raldo kennt deine Website noch nicht. Trag sie zuerst ein.",
      "marketUndecided": "Wähl zuerst den Markt, in dem du verkaufst.",
      "siteUnreachable": "Raldo konnte deine Website nicht erreichen. Prüf, ob sie online ist.",
      "rawStoreFailed": "Raldo konnte die Ergebnisse nicht speichern. Versuch es noch einmal.",
      "stageDeadlineExceeded": "Ein Schritt hat zu lange gedauert. Versuch es noch einmal.",
      "vendorBudgetExhausted": "Suchdaten sind gerade nicht verfügbar. Versuch es später noch einmal.",
      "vendorNotConfigured": "Suchdaten sind noch nicht eingerichtet.",
      "vendorHttpError": "Der Dienst für Suchdaten hat nicht geantwortet. Versuch es später noch einmal.",
      "vendorEnvelopeError": "Der Dienst für Suchdaten hat eine fehlerhafte Antwort geschickt. Versuch es später noch einmal.",
      "contentFetchFailed": "Raldo konnte deine Seiten nicht lesen. Versuch es noch einmal.",
      "beliefsMissing": "Raldo braucht zuerst deine Argumente. Richte sie ein und versuch es noch einmal.",
      "brandFactsMissing": "Raldo braucht zuerst deine Markenfakten. Füll sie aus und versuch es noch einmal.",
      "discoveryNoSeeds": "Raldo hat keine Suchen zum Starten gefunden. Versuch es noch einmal.",
      "modelOutputInvalid": "Raldo hat eine Antwort erhalten, die er nicht nutzen konnte. Versuch es noch einmal.",
      "timedOut": "Der Plan hat zu lange gedauert. Versuch es noch einmal.",
      "relevanceNothingKept": "Keine Suche passte gut genug zu deinem Unternehmen. Prüfe deine Markenfakten und versuch es noch einmal.",
      "serpNoResults": "Raldo hat keine Suchergebnisse zurückbekommen. Versuch es später noch einmal.",
      "noPagesKept": "Jede Seite wurde ausgelassen. Prüfe deine Markenfakten und versuch es noch einmal.",
      "focusNothingNew": "Für dieses Thema wurden keine neuen Seiten gefunden."
    },
    "visibilityRun": {
      "enqueueFailed": "Raldo konnte die Messung nicht starten. Versuch es noch einmal.",
      "inProgress": "Eine Messung läuft schon. Warte, bis sie fertig ist.",
      "failed": "Die Messung ist mit einem Fehler stehen geblieben. Versuch es noch einmal.",
      "noPrompts": "Raldo hat keine Fragen zum Stellen gefunden. Prüf deinen Plan und versuch es noch einmal.",
      "noPlan": "Raldo braucht zuerst deinen Plan. Plane deine Seiten und versuch es noch einmal.",
      "costCap": "Die Messung wurde vorzeitig beendet, deshalb fehlen einige Antworten.",
      "marketUndecided": "Wähl zuerst den Markt, in dem du verkaufst.",
      "brandFactsMissing": "Raldo braucht zuerst deine Markenfakten. Füll sie aus und versuch es noch einmal.",
      "modelOutputInvalid": "Raldo hat eine Antwort erhalten, die er nicht nutzen konnte. Versuch es noch einmal.",
      "rawStoreFailed": "Raldo konnte die Ergebnisse nicht speichern. Versuch es noch einmal.",
      "stageDeadlineExceeded": "Ein Schritt hat zu lange gedauert. Versuch es noch einmal.",
      "vendorBudgetExhausted": "KI-Antworten sind gerade nicht verfügbar. Versuch es später noch einmal.",
      "vendorNotConfigured": "KI-Antworten sind noch nicht eingerichtet.",
      "vendorHttpError": "Der Dienst für KI-Antworten hat nicht geantwortet. Versuch es später noch einmal.",
      "vendorEnvelopeError": "Der Dienst für KI-Antworten hat eine fehlerhafte Antwort geschickt. Versuch es später noch einmal.",
      "contentFetchFailed": "Raldo konnte deine Seiten nicht lesen. Versuch es noch einmal.",
      "timedOut": "Die Messung hat zu lange gedauert. Versuch es noch einmal."
    },
    "articleRun": {
      "enqueueFailed": "Raldo konnte die Seite nicht starten. Versuch es noch einmal.",
      "inProgress": "Diese Seite wird schon geschrieben. Warte, bis sie fertig ist.",
      "failed": "Die Seite ist mit einem Fehler stehen geblieben. Versuch es noch einmal.",
      "rawStoreFailed": "Raldo konnte nicht speichern, was es gefunden hat. Versuch es noch einmal.",
      "stageDeadlineExceeded": "Ein Schritt hat zu lange gedauert. Versuch es noch einmal.",
      "pageUnknown": "Raldo kennt diese Seite nicht. Plane deine Seiten noch einmal.",
      "noPlanRun": "Raldo braucht zuerst einen fertigen Plan. Plane deine Seiten und versuch es noch einmal.",
      "noSources": "Raldo konnte keine Seite lesen, die für diese Frage rankt. Versuch es später noch einmal.",
      "noScope": "Raldo hat nichts gefunden, was die Seite abdecken sollte. Prüf die Frage und versuch es noch einmal.",
      "brandFactsMissing": "Raldo braucht zuerst deine Markenfakten. Trag sie ein und versuch es noch einmal.",
      "marketUndecided": "Wähle zuerst den Markt, in dem du verkaufst.",
      "modelOutputInvalid": "Raldo hat eine Antwort bekommen, die es nicht nutzen konnte. Versuch es noch einmal.",
      "vendorBudgetExhausted": "Die Recherche ist gerade nicht verfügbar. Versuch es später noch einmal.",
      "vendorNotConfigured": "Die Recherche ist noch nicht eingerichtet.",
      "vendorHttpError": "Der Recherchedienst hat nicht geantwortet. Versuch es später noch einmal.",
      "vendorEnvelopeError": "Der Recherchedienst hat eine fehlerhafte Antwort geschickt. Versuch es später noch einmal.",
      "contentFetchFailed": "Raldo konnte eine Seite nicht lesen. Versuch es noch einmal.",
      "timedOut": "Die Seite hat zu lange gedauert. Versuch es noch einmal."
    },
    "postRun": {
      "enqueueFailed": "Raldo konnte den Post nicht starten. Versuch es noch einmal.",
      "inProgress": "Ein Post wird gerade geschrieben. Warte, bis er fertig ist.",
      "failed": "Der Post ist mit einem Fehler stehen geblieben. Versuch es noch einmal.",
      "rawStoreFailed": "Raldo konnte seine Arbeit nicht speichern. Versuch es noch einmal.",
      "stageDeadlineExceeded": "Ein Schritt hat zu lange gedauert. Versuch es noch einmal.",
      "briefFailed": "Raldo konnte kein Briefing schreiben, das die Regeln einhält. Versuch es noch einmal.",
      "noBelief": "Deine Strategie hat noch kein Argument für diesen Post.",
      "topicNotLinked": "Dieses Argument ist noch mit keinem Thema verknüpft. Verknüpfe es zuerst mit einem Thema.",
      "beliefMapMissing": "Deine Strategie hat noch keine Argumente.",
      "brandFactsMissing": "Deine Markenfakten sind noch nicht bestätigt.",
      "marketUndecided": "Deine Marke hat noch keinen Markt.",
      "modelOutputInvalid": "Raldos Antwort hat die Regeln nicht eingehalten. Versuch es noch einmal.",
      "timedOut": "Der Post hat nichts mehr gemeldet und wurde beendet."
    }
  },
  "routes": {
    "chat": "Chat",
    "chats": "Frühere Chats",
    "document": "Dokument",
    "design": "Design",
    "competitor": "Wettbewerber",
    "signIn": "Anmelden",
    "checkYourEmail": "E-Mail prüfen",
    "signingIn": "Anmeldung läuft",
    "yourName": "Dein Name",
    "workspaceSetup": "Workspace einrichten",
    "setup": "Einrichtung",
    "knowledge": "Wissen",
    "publishingSchedule": "Veröffentlichungsplan"
  },
  "nav": {
    "chat": "Chat",
    "content": "Content",
    "media": "Medien",
    "account": "Konto",
    "description": {
      "content": "Deine Posts und Seiten, Woche für Woche.",
      "media": "Eine kleine Schublade für alles Visuelle.",
      "competitors": "Die anderen Namen, die deine Käufer in Betracht ziehen, und wie du abschneidest.",
      "arguments": "Dein Plädoyer, ein Argument nach dem anderen.",
      "chats": "Mach jedes Gespräch dort weiter, wo du aufgehört hast.",
      "documents": "Ein Regal voller Hintergrundlektüre für Raldo.",
      "look": "Die Farben und Schriften, an denen man dich erkennt.",
      "voice": "Deine Stimme, damit nichts je geliehen klingt.",
      "inbox": "Was dich braucht und was Raldo erledigt hat, während du weg warst.",
      "plan": "Dein Rhythmus.",
      "customer": "Der Mensch auf der anderen Seite jedes Beitrags.",
      "settings": "Alles hinter den Kulissen, an einem Ort.",
      "company": "Was Raldo über dich gelernt hat.",
      "visibility": "Finden dich Käufer? Schauen wir mal.",
      "pages": "Jede Seite deines Content-Plans, nach Thema, in der Reihenfolge, in der Raldo sie schreibt.",
      "posts": "Jeder Beitrag, mit Datum oder ohne."
    },
    "style": "Stil",
    "profile": "Profil",
    "strategy": "Strategie",
    "topics": "Themen",
    "arguments": "Argumente",
    "calendar": "Board",
    "voice": "Stimme",
    "look": "Visueller Stil",
    "brand": "Marke",
    "knowledge": "Wissen",
    "inbox": "Posteingang",
    "settings": "Einstellungen",
    "visibility": "Sichtbarkeit",
    "competitors": "Wettbewerber",
    "kind": {
      "argument": "Argument",
      "keyword": "Keyword",
      "prompt": "Prompt",
      "topic": "Thema",
      "rival": "Wettbewerber",
      "page": "Seite",
      "researchEntry": "Recherche-Eintrag",
      "post": "Beitrag"
    },
    "research": "Recherche",
    "pages": "Seiten",
    "posts": "Beiträge"
  },
  "shell": {
    "guestName": "Platzhalter",
    "guestEmail": "you{'@'}raldo.app",
    "brandPlaceholder": "Deine Marke",
    "sidebar": "Seitenleiste",
    "collapseSidebar": "Seitenleiste einklappen",
    "expandSidebar": "Seitenleiste ausklappen",
    "primaryNav": "Primär",
    "resizeSidebar": "Breite der Seitenleiste ändern",
    "resizeSidebarHint": "Ziehen zum Anpassen · Klicken zum Einklappen",
    "expandSidebarHint": "Klicken zum Ausklappen",
    "darkTheme": "Dunkles Design"
  },
  "auth": {
    "raldoHome": "Raldo-Startseite",
    "or": "oder",
    "continueWithGoogle": "Mit Google fortfahren",
    "openingGoogleSignIn": "Google-Anmeldung wird geöffnet",
    "continue": "Weiter",
    "email": "E-Mail",
    "emailPlaceholder": "deine{'@'}email.com",
    "termsOfService": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutzerklärung",
    "legal": "Mit der Anmeldung stimmst du unseren {terms} und unserer {privacy} zu",
    "signIn": {
      "title": "Los geht's",
      "subtitle": "Erstelle ein Konto oder melde dich an.",
      "emailError": "Gib eine gültige E-Mail-Adresse ein",
      "sendingLink": "Dein Anmeldelink wird gesendet"
    },
    "emailSent": {
      "resendCooldown": "Erneut senden in {seconds}s",
      "linkSent": "Link gesendet ✓",
      "resendLink": "Link erneut senden",
      "title": "Prüfe dein Postfach",
      "sentTo": "Wir haben einen Magic Link gesendet an",
      "expiry": "Klicke auf den Link in der E-Mail, um dich anzumelden. Der Link läuft in 30 Minuten ab.",
      "resending": "Dein Link wird erneut gesendet",
      "useDifferentEmail": "← Andere E-Mail-Adresse verwenden"
    },
    "fullName": {
      "required": "Bitte gib deinen Namen ein.",
      "title": "Wie heißt du?",
      "subtitle": "Damit personalisieren wir deinen Workspace.",
      "label": "Vollständiger Name",
      "placeholder": "Max Mustermann",
      "saving": "Dein Name wird gespeichert"
    },
    "workspaceSetup": {
      "workspaceNameRequired": "Gib einen Workspace-Namen ein.",
      "brandNameRequired": "Gib einen Markennamen ein.",
      "title": "Richte deinen Workspace ein",
      "subtitle": "Fast geschafft. Gib deinem Workspace einen Namen, um loszulegen.",
      "workspaceNameLabel": "Workspace-Name",
      "workspaceNamePlaceholder": "Acme GmbH",
      "brandNameLabel": "Markenname",
      "brandNamePlaceholder": "z. B. Acme",
      "sameAsWorkspace": "Wie Workspace",
      "submitting": "Wird eingerichtet…",
      "continueCta": "Weiter →"
    },
    "callback": {
      "signingIn": "Du wirst angemeldet…",
      "signingInLoading": "Du wirst angemeldet",
      "confirmTitle": "Bestätige deine E-Mail-Adresse, um fortzufahren",
      "confirmBody": "Es sieht so aus, als hättest du diesen Link auf einem anderen Gerät geöffnet. Gib deine E-Mail-Adresse ein, um die Anmeldung abzuschließen."
    },
    "toast": {
      "magicLinkFailed": "Anmeldelink konnte nicht gesendet werden",
      "googleSignInFailed": "Google-Anmeldung fehlgeschlagen",
      "resendFailed": "Link konnte nicht erneut gesendet werden",
      "saveNameFailed": "Dein Name konnte nicht gespeichert werden",
      "createWorkspaceFailed": "Dein Workspace konnte nicht erstellt werden",
      "signInFailed": "Anmeldung fehlgeschlagen",
      "linkExpired": "Der Link ist möglicherweise abgelaufen. Gib deine E-Mail-Adresse ein, um es erneut zu versuchen."
    },
    "errors": {
      "noEmailOnFile": "Keine E-Mail-Adresse hinterlegt, um die Anmeldung per Magic Link abzuschließen."
    }
  },
  "billing": {
    "yearly": "Jährlich",
    "monthly": "Monatlich",
    "billedOnceYear": "{price} einmal jährlich abgerechnet",
    "billedEveryMonth": "Monatlich abgerechnet",
    "perMonth": "/Monat",
    "perYear": "/Jahr",
    "planOptionAriaLabel": "{name}, {price} pro Monat, {note}",
    "billingTerm": "Abrechnungszeitraum",
    "headline": "Verpasse nie wieder einen Beitrag.",
    "chooseBilling": "Wähle deine Abrechnung",
    "vatNote": "Preise zzgl. MwSt. Anfallende Steuern werden beim Checkout berechnet.",
    "checkoutCta": "Raldo an die Arbeit schicken",
    "checkoutLoading": "Du wirst zum Checkout weitergeleitet",
    "secureCheckout": "Sicherer Checkout über Stripe · Jederzeit kündbar",
    "tagline": "Die agentische Marketing-Plattform",
    "checkoutError": "Beim Start des Checkouts ist etwas schiefgelaufen. Bitte versuche es erneut.",
    "title": "Abrechnung",
    "confirming": "Deine Zahlung wird bestätigt",
    "confirmingHeading": "Deine Zahlung wird bestätigt…",
    "confirmingBody": "Das dauert normalerweise nur ein bis zwei Sekunden.",
    "stillConfirming": "Deine Zahlung wird noch bestätigt",
    "stillConfirmingBody": "Deine Zahlung wird möglicherweise noch verarbeitet. Das kann gelegentlich etwas länger dauern als sonst - schau gleich noch einmal vorbei, oder melde dich bei uns, falls sich nichts tut.",
    "checkAgain": "Erneut prüfen",
    "contactSupport": "Support kontaktieren",
    "twoMonthsFree": "2 Monate gratis",
    "trialEnded": "Deine Testphase ist am {date} abgelaufen.",
    "accessCode": {
      "trigger": "Hast du einen Zugangscode?",
      "placeholder": "Zugangscode",
      "apply": "Einlösen",
      "ariaLabel": "Zugangscode",
      "invalid": "Dieser Zugangscode ist ungültig. Prüfe ihn und versuche es erneut.",
      "expired": "Dieser Zugangscode ist abgelaufen.",
      "exhausted": "Dieser Zugangscode ist bereits aufgebraucht.",
      "alreadyMember": "Dein Workspace hat bereits Zugriff.",
      "alreadyRedeemed": "Dieser Workspace hat bereits einen Zugangscode eingelöst.",
      "paymentRecovery": "Deine Mitgliedschaft hat ein Zahlungsproblem. Behebe es in der Abrechnungsverwaltung."
    },
    "benefits": {
      "unlimitedTitle": "Unbegrenzter Content",
      "unlimitedBody": "Entwirf, gestalte und plane so viel du willst. Keine Credits, keine Obergrenzen, keine Zählung.",
      "supportTitle": "Echter menschlicher Support, rund um die Uhr",
      "supportBody": "Echte Menschen, wann immer du sie brauchst. Antwortzeit unter 1 Stunde.",
      "guaranteeTitle": "{days} Tage Geld-zurück-Garantie",
      "guaranteeBody": "Ohne Wenn und Aber."
    }
  },
  "account": {
    "membership": "Raldo-Mitgliedschaft",
    "status": {
      "active": "Aktiv",
      "endsSoon": "Endet bald",
      "paymentIssue": "Zahlungsproblem",
      "cancelled": "Gekündigt",
      "pending": "Ausstehend"
    },
    "renewsOn": "Verlängert sich am {date}",
    "accessEndsOn": "Zugriff endet am {date}",
    "staysUsable": "Deine Mitgliedschaft bleibt bis dahin uneingeschränkt nutzbar.",
    "memberSince": "Mitglied seit {date}",
    "trial": {
      "badge": "Testphase · noch {count} Tag | Testphase · noch {count} Tage",
      "endsOn": "Testphase endet am {date}",
      "thenPrice": "nach der Testphase",
      "choosePlan": "Tarif wählen",
      "endTrial": "Testphase beenden",
      "endDialogTitle": "Testphase beenden?",
      "endDialogWithDate": "Du behältst vollen Zugriff bis {date}. Danach endet deine Testphase.",
      "endDialogWithoutDate": "Du behältst vollen Zugriff bis zum Ende deiner Testphase. Danach endet dein Zugriff."
    },
    "manageBilling": "Abrechnung verwalten",
    "cancelSubscription": "Abo kündigen",
    "resumeSubscription": "Abo fortsetzen",
    "market": {
      "title": "Suchmarkt",
      "description": "Wo Raldo Rankings, Keywords und Wettbewerber misst. Ein Land pro Inhaltssprache.",
      "current": "Aktueller Markt",
      "source": {
        "languageDefault": "Standard für {language}",
        "overview": "Danach gewählt, wo du rankst",
        "user": "Von dir festgelegt"
      },
      "decided": "festgelegt am {date}",
      "candidates": "Wo deine Website rankt",
      "candidateTraffic": "{traffic} Besuche/Monat",
      "candidateKeywords": "keine Keywords | 1 Keyword | {count} Keywords",
      "selectLabel": "Land",
      "rereadNote": "Wenn du den Markt änderst, liest Raldo deine Suchdaten bei der nächsten Messung neu ein.",
      "ownerOnly": "Nur Inhaber und Admins können den Markt ändern.",
      "saving": "Markt wird gespeichert",
      "emptyTitle": "Bestätige deine Markenfakten, um den Markt festzulegen",
      "toast": {
        "saved": "Suchmarkt aktualisiert"
      }
    },
    "profile": "Profil",
    "email": "E-Mail",
    "nameLabel": "Name",
    "namePlaceholder": "Dein Name",
    "toast": {
      "nameUpdated": "Name aktualisiert",
      "updateNameFailed": "Name konnte nicht aktualisiert werden",
      "cancelDialogTitle": "Abo kündigen?",
      "cancelDialogWithDate": "Du behältst vollen Zugriff bis {date}. Danach endet deine Mitgliedschaft.",
      "cancelDialogWithoutDate": "Du behältst vollen Zugriff bis zum Ende des aktuellen Abrechnungszeitraums. Danach endet deine Mitgliedschaft.",
      "membershipEndsOn": "Deine Mitgliedschaft endet am {date}.",
      "membershipCancelled": "Deine Mitgliedschaft wurde gekündigt.",
      "cancelFailed": "Abo konnte nicht gekündigt werden",
      "membershipRenews": "Deine Mitgliedschaft verlängert sich wie gewohnt.",
      "resumeFailed": "Abo konnte nicht fortgesetzt werden",
      "billingPortalFailed": "Abrechnungsportal konnte nicht geöffnet werden"
    }
  },
  "brand": {
    "connectedSince": "Verbunden seit {date}",
    "disconnect": "Trennen",
    "ownerOnly": "Nur Workspace-Inhaber:innen können Verbindungen verwalten.",
    "coreMessage": "Kernbotschaft",
    "opportunity": "Chance",
    "foundationNote": "Fundament: Jedes Thema gestützt durch Belege und Performance-Daten",
    "account": "Konto",
    "linkedinDescription": "Veröffentliche Beiträge und Karussells direkt auf deiner Unternehmensseite.",
    "connectCta": "{platform} verbinden",
    "toast": {
      "loadStatusFailed": "Verbindungsstatus konnte nicht geladen werden",
      "connectFailed": "{platform} konnte nicht verbunden werden",
      "disconnected": "{platform} getrennt",
      "disconnectFailed": "{platform} konnte nicht getrennt werden",
      "saveFailed": "Diese Änderung konnte nicht gespeichert werden",
      "viewerRoleMessage": "Deine Rolle darf diese Marke lesen, aber nicht ändern.",
      "markUploadFailed": "Diese Datei konnte nicht hochgeladen werden"
    },
    "dialog": {
      "disconnectTitle": "{platform} trennen?",
      "disconnectLinkedinBody": "Wenn du LinkedIn trennst, veröffentlicht Raldo nicht mehr auf deiner Unternehmensseite. Du kannst die Verbindung jederzeit wiederherstellen."
    },
    "generating": "Wird geschrieben…",
    "section": {
      "edit": "Bearbeiten",
      "editSection": "{section} bearbeiten",
      "saving": "Wird gespeichert"
    },
    "visualStyle": {
      "paletteTitle": "Palette",
      "paletteDescription": "Die erste Farbe ist die Primärfarbe. Raldo nutzt sie für Überschriften und tragende Formen.",
      "primaryColor": "Primär",
      "colorAt": "Farbe {index}",
      "noColors": "Noch keine Farben.",
      "removeColor": "{role} entfernen",
      "addColor": "Farbe hinzufügen",
      "typefaceTitle": "Schrift",
      "typefaceDescription": "Wird auf jedes Design angewendet, das Raldo für diese Marke baut.",
      "fontFamilyLabel": "Schriftfamilie",
      "marksTitle": "Zeichen",
      "marksDescription": "Raldo wählt das Monogramm, wenn ein Design klein oder quadratisch ist.",
      "logoMark": "Logo",
      "monogramMark": "Monogramm",
      "onLight": "Auf Hell",
      "onDark": "Auf Dunkel",
      "noMarks": "Noch keine Zeichen.",
      "replaceMark": "Ersetzen",
      "addMark": "{mark} hinzufügen",
      "removeMark": "{mark} entfernen",
      "uploadingMark": "Wird hochgeladen…",
      "errors": {
        "invalidFileType": "Dieser Dateityp wird nicht unterstützt. Lade ein PNG-, JPEG-, SVG- oder WebP-Bild hoch.",
        "fileTooLarge": "Diese Datei ist zu groß. Die maximale Größe beträgt 2 MB.",
        "uploadFailed": "Beim Hochladen dieser Datei ist etwas schiefgelaufen. Versuch es noch einmal."
      },
      "quickLook": {
        "file": "Datei",
        "dimensions": "Abmessungen",
        "groundAriaLabel": "Vorschau-Hintergrund",
        "openAria": "Vorschau von {mark} öffnen"
      },
      "removeMarkAction": "Entfernen"
    },
    "styleGuide": {
      "outlineLabel": "Teile dieses Leitfadens",
      "notSet": "Noch nicht geschrieben.",
      "sectionPlaceholder": "Wie diese Marke mit {section} umgeht",
      "termsDescription": "Raldo korrigiert diese, bevor ein Entwurf bei dir ankommt.",
      "preferencesDescription": "Raldo schreibt kein Wort aus der rechten Spalte.",
      "sampleCopyDescription": "Aus deinen eigenen Beiträgen. Der Beleg für die Abschnitte oben, so wie veröffentlicht.",
      "writtenWrongly": "Falsch geschrieben",
      "correctForm": "Richtige Form",
      "termPlaceholder": "z. B. meridian",
      "correctFormPlaceholder": "z. B. Meridian",
      "addTerm": "Begriff hinzufügen",
      "useInstead": "Nutze",
      "avoid": "Nie",
      "useInsteadPlaceholder": "z. B. benenne den Schritt, der wegfällt",
      "avoidPlaceholder": "z. B. nahtlos",
      "addWord": "Wort hinzufügen",
      "removeRule": "{rule} entfernen",
      "noRulesYet": "Raldo liest diese aus deinen veröffentlichten Beiträgen. Verbinde ein Konto, dann füllt sich das hier.",
      "connectAccounts": "Verbundene Konten",
      "viewOriginalPost": "Originalbeitrag ansehen",
      "noSampleCopy": "Noch keine Textbeispiele.",
      "parts": {
        "voiceAndPersonality": "Stimme und Persönlichkeit",
        "formalityAndAddress": "Anrede und Förmlichkeit",
        "referenceGrammarStandard": "Grammatikstandard",
        "numbersDatesCurrency": "Zahlen, Daten und Währung",
        "punctuationAndQuotes": "Zeichensetzung und Anführungszeichen",
        "capitalization": "Groß- und Kleinschreibung",
        "inclusiveLanguage": "Inklusive Sprache",
        "brandAndProductTerms": "Marken- und Produktbegriffe",
        "preferredAndAvoidedWords": "Bevorzugte und vermiedene Wörter",
        "sampleCopy": "Textbeispiele"
      },
      "outline": {
        "voice": "Stimme",
        "mechanics": "Mechanik",
        "rules": "Regeln",
        "evidence": "Belege"
      }
    },
    "discardTitle": "Änderungen verwerfen?",
    "discardBody": "Dieses Profil hat Änderungen, die du nicht gespeichert hast. Wenn du jetzt gehst, sind sie weg.",
    "discardConfirm": "Verwerfen",
    "artifacts": {
      "contentStrategy": "Content-Strategie",
      "look": "Visueller Stil",
      "voice": "Stimme",
      "beliefs": "Argumente"
    },
    "notWritten": {
      "title": "{artifact} wurde noch nicht geschrieben",
      "description": "Raldo schreibt das im Gespräch. Frag auf Home danach, dann erscheint es hier.",
      "action": "Raldo fragen",
      "askMessage": "Schreib mein {artifact}."
    },
    "connections": {
      "title": "Verbindungen",
      "description": "Hier veröffentlicht Raldo in deinem Namen."
    },
    "schedule": {
      "title": "Veröffentlichungsplan",
      "timeZoneLabel": "Zeitzone",
      "timeZoneHint": "Jede Zeit unten wird in dieser Zone gelesen.",
      "toggleDay": "Am {day} veröffentlichen",
      "timeFor": "Veröffentlichungszeit am {day}",
      "apply": "Anwenden",
      "days": {
        "monday": "Mo",
        "tuesday": "Di",
        "wednesday": "Mi",
        "thursday": "Do",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "So"
      },
      "setEveryDayTo": "Jeden Tag setzen auf",
      "everyDayTimeLabel": "Zeit für jeden Tag"
    },
    "telegram": {
      "name": "Telegram",
      "description": "Chatte unterwegs mit Raldo. Halte Notizen, Fotos und Sprachnachrichten fest.",
      "connectTitle": "Telegram verbinden",
      "connectBody": "Scanne den Code mit der Handykamera. Telegram öffnet sich und verbindet diese Marke automatisch.",
      "qrAlt": "QR-Code, der Raldo in Telegram öffnet",
      "codeExpires": "Dieser Code läuft in 15 Minuten ab und funktioniert einmal.",
      "emailLink": "Link per E-Mail schicken"
    },
    "beliefMap": {
      "untitled": "Unbenanntes Argument",
      "roofPlaceholder": "Formuliere es als Aussage, der man widersprechen könnte",
      "nameLabel": "Name",
      "namePlaceholder": "z. B. Die Kosten des stillen Profils",
      "claimLabel": "Was sie glauben müssen",
      "claimHint": "Ein bis zwei Sätze, formuliert als etwas, dem ein kritischer Leser widersprechen könnte.",
      "claimPlaceholder": "Beschreibe, was der Leser akzeptieren muss",
      "objectionLabel": "Was sie stattdessen glauben",
      "objectionHint": "Die Position, die dieses Argument entkräften muss - in ihren Worten und in ihrer stärksten Form. Ohne sie hat der Text nichts, wogegen er anschreiben kann.",
      "objectionPlaceholder": "z. B. Posten ist Eitelkeit - meine Abschlüsse kommen über Empfehlungen",
      "add": "Argument hinzufügen",
      "beliefCount": "keine Argumente | 1 Argument | {count} Argumente",
      "phaseLabel": "Phase der Buyer Journey",
      "notFoundTitle": "Dieses Argument gibt es nicht",
      "notFoundBody": "Sie wurde vielleicht gelöscht, oder der Link stimmt nicht.",
      "phases": {
        "awareness": {
          "name": "Bewusstsein",
          "question": "Ist das wirklich ein Problem, und betrifft es mich?",
          "empty": "Noch keine Argumente für den Leser, der das Problem noch nicht kennt."
        },
        "consideration": {
          "name": "Vergleich",
          "question": "Welche Optionen habe ich, und warum ist die naheliegende falsch?",
          "empty": "Noch keine Argumente für den Leser, der seine Optionen abwägt."
        },
        "decision": {
          "name": "Entscheidung",
          "question": "Kann ich ihnen vertrauen, und ist der Schritt sicher?",
          "empty": "Noch keine Argumente für den Leser, der sich entscheiden muss."
        }
      }
    },
    "templates": {
      "loading": "Deine Vorlagen werden geladen",
      "loadError": "Deine Vorlagen konnten nicht geladen werden",
      "emptyTitle": "Noch keine Vorlagen",
      "emptyDescription": "Fertige Layouts sammeln sich hier, damit ein Beitrag nach deiner Marke aussieht, ohne neu gezeichnet zu werden."
    },
    "competitors": {
      "runComparison": "Vergleich starten",
      "runStarted": "Raldo vergleicht dich erneut mit deinen Wettbewerbern. Das kann einige Minuten dauern.",
      "runFailed": "Der Vergleich konnte nicht laufen",
      "addRival": "Wettbewerber hinzufügen",
      "atLimitReason": "Du verfolgst bereits die maximalen {max} Wettbewerber. Entferne einen, um einen weiteren hinzuzufügen.",
      "loadRivalsError": "Deine verfolgten Wettbewerber konnten nicht geladen werden",
      "loadReportError": "Dein Wettbewerbsvergleich konnte nicht erstellt werden",
      "emptyNoRivals": {
        "title": "Noch keine Wettbewerber verfolgt",
        "description": "Verfolge die Domain eines Wettbewerbers, um zu sehen, wie du in der Suche und in KI-Antworten abschneidest."
      },
      "emptyNoReport": {
        "title": "Führe deinen ersten Vergleich durch",
        "description": "Raldo vergleicht deine verfolgten Wettbewerber mit deiner eigenen Domain anhand von Such- und KI-Daten. Das kann einige Minuten dauern."
      },
      "emptyDomainUnknown": {
        "title": "Raldo braucht zuerst deine Website",
        "description": "Der Vergleich mit Wettbewerbern beginnt bei deiner eigenen Domain, die Raldo von deiner Website liest. Trage sie in deinen Markenfakten ein.",
        "cta": "Zu den Markenfakten"
      },
      "status": {
        "notCompared": "Noch nicht verglichen",
        "failed": "Vergleich fehlgeschlagen"
      },
      "figures": {
        "share": "Dein Anteil an der Suche",
        "shareSub": "Von {count} Keyword, für das deine Wettbewerber ranken | Von {count} Keywords, für die deine Wettbewerber ranken",
        "aiShare": "In KI-Antworten genannt",
        "aiShareSub": "{named} von {answers} Antwort nennt dich | {named} von {answers} Antworten nennen dich",
        "keywords": "Keywords, für die du rankst",
        "keywordsSub": "{name} rankt für {count}",
        "gaps": "Lücken zu schließen",
        "gapsLink": "In der Suche ansehen",
        "gapsHint": "Keywords, für die ein Wettbewerber rankt und du nicht"
      },
      "table": {
        "title": "Du und deine Wettbewerber",
        "meta": "Verglichen am {date} · {count} von {max} verfolgt",
        "site": "Website",
        "share": "Anteil an der Suche",
        "keywords": "Keywords",
        "shared": "Gemeinsam",
        "googleAi": "Google-KI",
        "aiAnswers": "KI-Antworten",
        "ofCount": "{value} von {count}",
        "hints": {
          "share": "Nach Position gewichteter Anteil am Suchvolumen, um das du konkurrierst",
          "keywords": "Keywords, für die die Website bei Google rankt",
          "shared": "Keywords, für die ihr beide rankt",
          "googleAi": "Keywords, bei denen Googles AI Overview die Website zitiert",
          "aiAnswers": "Anteil der KI-Antworten, die eine verfolgte Marke nennen"
        }
      },
      "chart": {
        "title": "Anteil an der Suche im Zeitverlauf",
        "meta": "Bei jedem Vergleich",
        "aria": "Anteil an der Suche bei jedem Vergleich, du gegen deine Wettbewerber"
      },
      "addDialog": {
        "description": "Raldo vergleicht sie mit dir in der Suche und in KI-Antworten. Du verfolgst {count} von {max}.",
        "field": "Unternehmen oder Website",
        "placeholder": "Nach Namen suchen oder ihre Website einfügen",
        "confirm": "Wettbewerber verfolgen",
        "tracked": "Verfolgt",
        "added": "{name} wird verfolgt. Starte einen Vergleich, um ihn einzubeziehen."
      },
      "addField": {
        "label": "Wettbewerber hinzufügen",
        "placeholder": "Firmenname oder Website",
        "hint": "Firmenname oder Website eingeben. Mit Enter suchen.",
        "search": "Suchen",
        "searching": "Suche läuft",
        "noResults": "Keine Firma zu „{query}“ gefunden.",
        "tooLong": "Höchstens {max} Zeichen.",
        "failed": "Die Suche hat nicht geklappt. Bitte erneut versuchen.",
        "duplicate": "{name} steht schon auf der Liste.",
        "resultsLabel": "Gefundene Firmen"
      },
      "rival": {
        "trackedSince": "Verfolgt seit {date}",
        "positioning": "Ihre Positionierung",
        "openSite": "Website öffnen",
        "stopTracking": "Nicht mehr verfolgen",
        "stopTrackingAria": "{name} nicht mehr verfolgen",
        "stopTrackingTitle": "{name} nicht mehr verfolgen?",
        "stopTrackingBody": "Raldo verfolgt diesen Wettbewerber nicht mehr, und der nächste Vergleich schließt ihn nicht mehr ein. Du kannst ihn jederzeit wieder hinzufügen.",
        "stopTrackingFailed": "{name} konnte nicht entfernt werden",
        "notFoundTitle": "Wettbewerber nicht gefunden",
        "notFoundBody": "Er wurde vielleicht entfernt, oder der Link ist falsch.",
        "back": "Zurück zu Wettbewerbern",
        "notComparedTitle": "Noch nicht verglichen",
        "notComparedBody": "Raldo hat diesen Wettbewerber noch nicht verglichen. Starte einen Vergleich, um zu sehen, wo du stehst.",
        "failedTitle": "Dieser Wettbewerber konnte nicht verglichen werden",
        "failedBody": "Der letzte Vergleich ist für diese Website fehlgeschlagen. Starte ihn erneut; wenn er weiter fehlschlägt, prüfe die Website-Adresse.",
        "figures": {
          "share": "Ihr Anteil an der Suche",
          "yours": "Deiner liegt bei {value}",
          "visits": "Besuche pro Monat über Google",
          "visitsSub": "Geschätzt",
          "keywords": "Keywords, für die sie ranken",
          "keywordsSub": "Du rankst für {count}",
          "aiShare": "Ihr Anteil an KI-Antworten"
        },
        "overlap": {
          "title": "Wo sich eure Keywords überschneiden",
          "meta": "{count} Keyword insgesamt | {count} Keywords insgesamt",
          "aria": "{ours} nur du rankst dafür, {shared} ihr beide rankt dafür, {theirs} nur sie ranken dafür",
          "ours": "nur du rankst dafür",
          "shared": "ihr beide rankt dafür",
          "theirs": "nur sie ranken dafür"
        },
        "winnable": {
          "title": "Keywords, die du ihnen abnehmen kannst",
          "meta": "Sie ranken, und es ist nicht schwer zu gewinnen",
          "rank": "Ihr Rang",
          "inPlan": "Auf einer Seite deines Plans",
          "notInPlan": "Noch nicht in deinem Plan",
          "emptyTitle": "Noch kein Keyword, das du ihnen abnehmen kannst"
        },
        "topics": {
          "title": "Stand pro Thema",
          "meta": "Durchschnittlicher Rang bei Google, niedriger ist besser",
          "topic": "Thema",
          "theirKeywords": "Ihre Keywords",
          "theirRank": "Ihr Ø-Rang",
          "yourKeywords": "Deine Keywords",
          "yourRank": "Dein Ø-Rang",
          "rank": "#{rank}",
          "emptyTitle": "Noch kein Stand pro Thema"
        },
        "pages": {
          "title": "Ihre besten Seiten",
          "meta": "Nach geschätzten Besuchen über Google",
          "page": "Seite",
          "visits": "Besuche/Monat",
          "keywords": "Keywords",
          "emptyTitle": "Noch keine Seite mit Besuchen über Google"
        },
        "prompts": {
          "title": "Prompts, bei denen die KI {name} nennt",
          "seeAll": "Alle Prompts ansehen",
          "emptyTitle": "Keine KI-Antwort nennt sie",
          "emptyBody": "Keiner der Prompts dieses Monats hat ChatGPT oder Perplexity dazu gebracht, sie zu nennen.",
          "prompt": "Prompt",
          "namedBy": "Genannt von"
        },
        "aiTopics": {
          "title": "{name} in KI-Antworten nach Thema",
          "meta": "Prompts, die {name} nennen, bleiben außen vor · {period}",
          "topic": "Thema"
        }
      }
    },
    "company": {
      "loading": "Dein Unternehmensprofil wird geladen",
      "loadError": "Dein Unternehmensprofil konnte nicht geladen werden",
      "emptyTitle": "Dein Unternehmensprofil ist noch nicht bereit",
      "emptyDescription": "Schließe das Setup ab, dann füllt Raldo diese Übersicht.",
      "editLinksAction": "Links bearbeiten"
    },
    "customer": {
      "loading": "Dein Kundenprofil wird geladen",
      "loadError": "Dein Kundenprofil konnte nicht geladen werden",
      "emptyTitle": "Noch kein Kundenprofil",
      "emptyDescription": "Raldo schreibt es während des Setups. Es ist noch nicht da."
    },
    "publishing": {
      "title": "Veröffentlichung",
      "helper": "Die Autorin oder der Autor zeichnet jede Seite, und die Testseite ist das Ziel, auf das eine Seite Leser schickt, die bereit sind.",
      "notSet": "Noch nicht festgelegt",
      "notSetAction": "Zum Ergänzen klicken",
      "urlError": "Gib eine Webadresse ein, zum Beispiel raldo.ai/trial.",
      "fields": {
        "name": {
          "label": "Name der Autorin oder des Autors",
          "hint": "Zeichnet jede Seite.",
          "editTitle": "Autorennamen bearbeiten",
          "placeholder": "Dana Whitfield"
        },
        "role": {
          "label": "Rolle",
          "hint": "Steht unter dem Namen.",
          "editTitle": "Rolle bearbeiten",
          "placeholder": "Head of Growth"
        },
        "bio": {
          "label": "Kurzbio in einer Zeile",
          "hint": "Eine Zeile darüber, wer sie oder er ist.",
          "editTitle": "Kurzbio bearbeiten",
          "placeholder": "Schreibt darüber, wie Software ohne Drama ausgeliefert wird."
        },
        "profileUrl": {
          "label": "Profil-URL",
          "hint": "Wo Leser die Autorin oder den Autor finden.",
          "editTitle": "Profil-URL bearbeiten",
          "placeholder": "linkedin.com/in/dana-whitfield"
        },
        "trialUrl": {
          "label": "Test- oder Demoseite",
          "hint": "Wohin eine Seite Leser schickt, die bereit sind.",
          "editTitle": "Test- oder Demoseite bearbeiten",
          "placeholder": "raldo.ai/trial"
        }
      }
    }
  },
  "media": {
    "formatSquare": "Quadratisch (1:1)",
    "designOfPost": "Beitrag · {title}",
    "freeDesign": "Freies Design",
    "formatPortrait": "Hochformat (4:5)",
    "formatStory": "Story (9:16)",
    "uploads": "Uploads",
    "designs": "Designs",
    "newDesignTitle": "Neues Design",
    "newDesignDescription": "Wähle ein Format und starte auf einer leeren Fläche.",
    "newUploadTitle": "Medien hochladen",
    "newUploadDescription": "Hol Bilder von deinem Gerät herein.",
    "templates": "Vorlagen",
    "templatesEmptyTitle": "Noch kein Markenstil",
    "templatesEmptyDescription": "Öffne ein Design und wähle „Markenstil erstellen“, um daraus die 16 Layouts deiner Marke zu machen.",
    "upload": "Hochladen",
    "create": "Erstellen",
    "typeAriaLabel": "Medientyp",
    "loading": "Deine Medienbibliothek wird geladen",
    "loadError": "Deine Medienbibliothek konnte nicht geladen werden",
    "emptyTitle": "Deine Medienbibliothek ist leer",
    "emptyDescription": "Hochgeladene Bilder und gespeicherte Vorlagen sammeln sich hier.",
    "designsLoading": "Deine Designs werden geladen",
    "designsLoadError": "Deine Designs konnten nicht geladen werden",
    "designsEmptyTitle": "Noch keine Designs",
    "designsEmptyDescription": "Raldo erstellt Designs im Chat - frag dort nach einem, und es erscheint hier.",
    "designsEmptyAction": "Chat öffnen",
    "deleteUploadTitle": "{filename} löschen?",
    "deleteUploadBody": "Dadurch wird die Datei endgültig aus deiner Bibliothek entfernt.",
    "deleteDesignTitle": "{name} löschen?",
    "deleteDesignBody": "Dadurch werden das Design und seine Seiten endgültig entfernt.",
    "createFromTemplateTitle": "Ein Design aus \"{name}\" erstellen?",
    "createFromTemplateBody": "Dadurch wird deiner Marke ein neues Design hinzugefügt, ausgehend von dieser Vorlage.",
    "createDesignCta": "Design erstellen",
    "draftingToast": "Raldo entwirft deinen Beitrag.",
    "untitledDesignName": "Unbenanntes Design",
    "toast": {
      "createDesignFailed": "Dieses Design konnte nicht erstellt werden",
      "renameDesignFailed": "Dieses Design konnte nicht umbenannt werden",
      "duplicateDesignFailed": "Dieses Design konnte nicht dupliziert werden",
      "deleteDesignFailed": "Dieses Design konnte nicht gelöscht werden",
      "saveDesignFailed": "Dieses Design konnte nicht gespeichert werden",
      "uploadFailed": "Diese Datei konnte nicht hochgeladen werden",
      "deleteFileFailed": "Diese Datei konnte nicht gelöscht werden"
    },
    "uploadError": {
      "contentTypeNotAllowed": "Dieser Dateityp wird nicht unterstützt. Lade ein JPEG-, PNG-, GIF- oder WebP-Bild hoch.",
      "fileTooLarge": "Diese Datei ist zu groß. Die maximale Größe beträgt 8 MB.",
      "storageQuotaExceeded": "Diese Marke hat ihr Speicherlimit erreicht.",
      "unreadableImage": "Wir konnten dieses Bild nicht lesen. Versuche es mit einer anderen Datei.",
      "uploadNotFound": "Dieser Upload konnte nicht gefunden werden. Versuche es erneut.",
      "fallback": "Beim Hochladen dieser Datei ist etwas schiefgelaufen. Versuche es erneut."
    },
    "quickLook": {
      "dimensions": "Abmessungen",
      "pixels": "{width} x {height} px",
      "size": "Dateigröße",
      "type": "Typ",
      "added": "Hinzugefügt",
      "useInDesign": "In einem Design verwenden"
    },
    "brandStyle": {
      "title": "Markenstil",
      "inUse": "In Verwendung",
      "fromDesign": "Aus {design}",
      "newTitle": "Neuer Markenstil",
      "building": "Die 16 Layouts werden erstellt · {done} von {total}",
      "ready": "Bereit zur Prüfung",
      "loading": "Dein Markenstil wird geladen",
      "loadError": "Dein Markenstil konnte nicht geladen werden"
    },
    "designMaking": "Raldo erstellt dieses Design",
    "designMakingTitle": "Dieses Design entsteht noch",
    "designMakingBody": "Raldo erstellt dieses Design noch. Du kannst es öffnen, sobald es fertig ist. Du bekommst eine Nachricht im Posteingang.",
    "designMakingConfirm": "Verstanden"
  },
  "content": {
    "status": {
      "draft": "Entwurf",
      "pendingHandoff": "Wartet auf Design",
      "scheduled": "Geplant",
      "published": "Veröffentlicht",
      "failed": "Fehlgeschlagen",
      "pendingHandoffCaption": "Wartet auf das Design, bevor es rausgeht."
    },
    "seeFullPost": "Ganzen Beitrag ansehen",
    "minimize": "Minimieren",
    "setDateTime": "Datum & Uhrzeit festlegen",
    "notScheduled": "Nicht geplant",
    "noDateYet": "Noch kein Datum",
    "untitledPost": "Unbenannter Beitrag",
    "schedule": "Planen",
    "reschedule": "Termin ändern",
    "unschedule": "Planung aufheben",
    "cancel": "Abbrechen",
    "publishNow": "Jetzt veröffentlichen",
    "duplicate": "Duplizieren",
    "tryAgain": "Erneut versuchen",
    "correct": "Korrigieren",
    "removeAttachment": "Entfernen",
    "replace": "Ersetzen",
    "openOnLinkedIn": "Auf LinkedIn öffnen",
    "actionForTitleAria": "{action}: {title}",
    "canvasLabel": "Canvas",
    "createDesign": "Design erstellen",
    "templateBadge": "Vorlage",
    "brandBadge": "Marke",
    "editAttachment": "Anhang bearbeiten",
    "resultsLabel": "Ergebnisse",
    "copyLabel": "Text",
    "writePostCopyPlaceholder": "Schreibe den Beitragstext…",
    "frame": {
      "selectAria": "{title} auswählen",
      "plannedDateAria": "Geplantes Datum und Uhrzeit festlegen"
    },
    "peek": {
      "closeDetails": "Details schließen",
      "editCopyAria": "Text für {title} bearbeiten"
    },
    "write": {
      "saving": "Speichert…",
      "saved": "Gespeichert",
      "scheduleEmptyHint": "Schreib zuerst etwas, bevor du diesen Beitrag planst.",
      "schedule": {
        "nextSlot": "Nächster freier Slot: {date}",
        "noCadence": "Für diese Marke ist noch kein Posting-Rhythmus eingerichtet, Raldo kann daher keinen Slot vorschlagen.",
        "noOpenSlot": "Alle Slots im Posting-Rhythmus sind bereits vergeben.",
        "pickAnotherDate": "Anderes Datum wählen",
        "loadingAria": "Nächster freier Slot wird gesucht"
      },
      "readability": {
        "tooltip": {
          "title": "Lesbarkeitsskala",
          "veryEasy": "9-10 · sehr leicht - Kinderbücher",
          "easy": "7-8 · leicht - Belletristik, starke Marketingtexte",
          "standard": "5-6 · Standard - Zeitungen",
          "dense": "3-4 · dicht - offizielle Dokumente",
          "difficult": "1-2 · schwierig - Fachliteratur",
          "footnote": "Etwa jeder fünfte Erwachsene liest auf dem niedrigsten Alphabetisierungsniveau. Ab 6/10 bleibt ein Text für fast alle lesbar."
        }
      }
    },
    "post": {
      "unscheduled": "Nicht geplant",
      "mediaLabel": "Medien",
      "noMediaAttached": "Keine Medien angehängt",
      "askPlaceholder": "Sag Raldo, was sich ändern soll…",
      "attachDesign": "Design anhängen",
      "designHint": "Raldo kann die Medien aus den Slides des Posts gestalten, oder du hängst ein Design an, das du schon hast.",
      "openDesign": "Design öffnen",
      "designMedia": "Medien gestalten",
      "designMediaFailed": "Das Design konnte nicht starten",
      "designMediaRefused": {
        "noMedia": "Dieser Post hat noch keine Slides zum Gestalten.",
        "notDesignable": "Nur ein Entwurf oder ein fehlgeschlagener Post ohne Design kann ein neues bekommen.",
        "running": "Raldo gestaltet dieses Design gerade.",
        "editorRole": "Nur Bearbeiter können die Medien gestalten."
      },
      "run": {
        "working": "Raldo schreibt einen Post.",
        "stages": {
          "brief": "Raldo wählt das Argument, das Thema und die Punkte.",
          "write": "Raldo schreibt die Caption und die Slides.",
          "check": "Raldo prüft den Post."
        },
        "completed": "Der Post ist geschrieben.",
        "partial": "Der Post ist geschrieben, aber ein Schritt ist nicht fertig geworden.",
        "cancelled": "Du hast den Post gestoppt.",
        "failed": "Der Post ist stehen geblieben"
      },
      "slides": "Slides",
      "slide": "Slide {n}",
      "score": "Bewertung {score} von 100",
      "needsPerson": "Braucht eine Person",
      "ready": "Bereit",
      "readability": "Lesbarkeit",
      "fromPage": "Aus der Seite",
      "madeFrom": "Erstellt aus",
      "addDesign": "Design hinzufügen",
      "editDesign": "Design bearbeiten",
      "viewDesign": "Design ansehen",
      "letRaldoDesign": "Lass Raldo es gestalten",
      "needsSlides": "Braucht Slides. Dieser Post hat noch keine.",
      "start": {
        "title": "Start",
        "letRaldoWrite": "Lass Raldo ihn schreiben",
        "orWrite": "Oder schreib ihn selbst. Der Post wird beim ersten Wort gespeichert.",
        "whichArgument": "Welches Argument soll der Post vertreten?",
        "letRaldoChoose": "Lass Raldo wählen",
        "fromBeliefMap": "Aus deiner Überzeugungskarte und Recherche"
      }
    },
    "artwork": {
      "groupAria": "Beitragsgrafik",
      "loading": "Grafik wird geladen",
      "loadError": "Diese Seite konnte nicht geladen werden",
      "pageAlt": "Seite {page}",
      "previousPage": "Vorherige Seite",
      "nextPage": "Nächste Seite",
      "goToPage": "Zu Seite {page}",
      "pageStatus": "Seite {page} von {count}"
    },
    "designPicker": {
      "title": "Design anhängen",
      "description": "Wähle ein fertiges Design als Grafik für diesen Beitrag.",
      "loading": "Deine Designs werden geladen",
      "emptyTitle": "Noch kein Design bereit",
      "emptyDescription": "Raldo erstellt Designs im Chat - frag dort nach einem, und es erscheint hier, sobald es fertig ist."
    },
    "workspace": {
      "defaultAuthorName": "Deine Marke",
      "linkedinPublicMeta": "LinkedIn · Öffentlich",
      "weekOf": "Woche vom {date}",
      "unscheduledColumn": "Nicht geplant",
      "scheduleReadyCount": "1 Beitrag planen | {count} Beiträge planen",
      "canvasEmptyTitle": "Noch nichts zu prüfen",
      "canvasEmptyDescription": "Sobald es Entwürfe oder geplante Beiträge gibt, erscheinen sie hier zur Durchsicht nebeneinander.",
      "untitledArticle": "Unbenannte Seite",
      "articlePlanning": "Raldo plant diese Seite…",
      "articleWriting": "Raldo schreibt diese Seite…",
      "scheduleGenerating": "Raldo schreibt…"
    },
    "previousPeriod": "Vorheriger Zeitraum",
    "nextPeriod": "Nächster Zeitraum",
    "calendar": {
      "week": "Woche",
      "month": "Monat",
      "today": "Heute",
      "viewAria": "Kalenderansicht",
      "articlesLane": "Seiten",
      "articleBadge": "Seite",
      "articleOpen": "Seite öffnen",
      "articleQuestion": "Beantwortet · {question}",
      "articleTopic": "Thema · {name}",
      "articleWords": "1 Wort | {count} Wörter",
      "articleSections": "1 Abschnitt | {count} Abschnitte",
      "articleStats": "{words} · {sections}",
      "kindAll": "Alle",
      "kindArticles": "Seiten",
      "kindPosts": "Beiträge",
      "kindAria": "Nach Art filtern"
    },
    "metrics": {
      "clicks": "Klicks",
      "engagement": "Engagement"
    },
    "results": {
      "noneYet": "Es wurde noch nichts erfasst.",
      "notLive": "Die Ergebnisse erscheinen hier, sobald der Beitrag auf LinkedIn live ist."
    },
    "deleteAssetAria": "Asset löschen",
    "postMediaAria": "Beitragsmedien",
    "preview": {
      "mediaError": "Dieses Design konnte nicht geladen werden",
      "croppedByFeed": "Der Feed schneidet dieses Design zu",
      "device": {
        "ariaLabel": "Vorschaugerät",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Mobil"
      }
    },
    "loadingPlan": "Dein Content-Plan wird geladen",
    "loadPlanError": "Dein Content-Plan konnte nicht geladen werden",
    "talkToRaldo": "Mit Raldo sprechen",
    "deleteDialog": {
      "title": "Diesen Beitrag löschen?",
      "description": "Dadurch werden der Beitrag und sein gesamter Versionsverlauf endgültig gelöscht. Das kann nicht rückgängig gemacht werden."
    },
    "publishDialog": {
      "title": "Diesen Beitrag jetzt veröffentlichen?",
      "description": "Dadurch wird der Beitrag sofort auf LinkedIn veröffentlicht und kann über Raldo nicht rückgängig gemacht werden. Der einzige Weg zurück ist, ihn zu löschen - das entfernt den Beitrag und alle bisherigen Interaktionen unwiderruflich."
    },
    "scheduleReadyDialog": {
      "title": "Alles Fertige planen?",
      "description": "Damit wird 1 Beitrag zur Veröffentlichung geplant. | Damit werden {count} Beiträge zur Veröffentlichung geplant."
    },
    "removeArtworkDialog": {
      "title": "Dieses Artwork entfernen?",
      "description": "Der Beitrag behält seinen Text und seine Planung; das Design selbst wird nicht gelöscht."
    },
    "toast": {
      "saveEditFailed": "Diese Änderung konnte nicht gespeichert werden",
      "restoreFailed": "Diese Version konnte nicht wiederhergestellt werden",
      "scheduleFailed": "Dieser Beitrag konnte nicht geplant werden",
      "publishFailed": "Dieser Beitrag konnte nicht veröffentlicht werden",
      "rescheduleFailed": "Dieser Beitrag konnte nicht umgeplant werden",
      "setPublishAtFailed": "Das Datum dieses Beitrags konnte nicht geändert werden",
      "cancelScheduleFailed": "Diese Planung konnte nicht storniert werden",
      "deleteFailed": "Dieser Beitrag konnte nicht gelöscht werden",
      "schedulePeriodFailed": "Diese Beiträge konnten nicht geplant werden",
      "createFailed": "Dieser Beitrag konnte nicht erstellt werden",
      "attachDesignFailed": "Dieses Design konnte nicht angehängt werden",
      "nextSlotFailed": "Der nächste freie Slot konnte nicht gefunden werden",
      "editArticleMetaFailed": "Diese Änderung konnte nicht gespeichert werden",
      "attachPublishedUrlFailed": "Diese Adresse konnte nicht gespeichert werden",
      "promoteArticleFailed": "Seite konnte nicht befördert werden",
      "promoteArticleNotVerified": "Die Adresse dieser Seite ist noch nicht bestätigt. Sie kann befördert werden, sobald ihre Live-URL bestätigt ist.",
      "recheckArticleHealthFailed": "Die Live-Seite konnte nicht geprüft werden",
      "exportArticleFailed": "Seite konnte nicht exportiert werden",
      "writePostFailed": "Der Post konnte nicht gestartet werden"
    },
    "renderGate": {
      "preparing": "Artwork für „{post}“ wird vorbereitet - {current} von {total}",
      "preparingBulk": "Artwork wird vorbereitet - {current} von {total} Beiträgen",
      "failedTitle": "Artwork konnte nicht vorbereitet werden",
      "failedDescription": "Das Design von „{post}“ konnte nicht gerendert werden. Versuch es noch mal.",
      "missingRenderMessage": "Das Artwork dieses Beitrags war noch nicht bereit. Versuch es noch mal, dann bereitet Raldo es zuerst vor."
    },
    "draftConflict": {
      "message": "Raldo hat diesen Beitrag neu geschrieben. Du hast hier ungespeicherte Änderungen - wähle, welche Version bleiben soll.",
      "compare": "Vergleichen",
      "hideCompare": "Vergleich ausblenden",
      "keepMine": "Meine behalten",
      "useRaldos": "Raldos übernehmen"
    },
    "shapeFilter": {
      "all": "Alle",
      "posts": "Beiträge",
      "articles": "Seiten",
      "aria": "Nach Art filtern"
    },
    "create": {
      "button": "Inhalt erstellen",
      "page": {
        "title": "Welche Seite soll er schreiben?",
        "description": "Wähle eine geplante Seite. Raldo entwirft den Text, der ihre Frage beantwortet.",
        "confirm": "Schreiben",
        "label": "Seite",
        "placeholder": "Geplante Seiten durchsuchen",
        "next": "Als Nächstes",
        "emptyTitle": "Keine Seite mehr zu schreiben",
        "emptyBody": "Jede geplante Seite hat einen Entwurf, oder der Plan ist noch nicht gelaufen."
      },
      "newPost": "Neuer Post",
      "newPage": "Neue Seite"
    },
    "topics": {
      "removeTitle": "Dieses Thema entfernen?",
      "removeBody": "Das entfernt das Thema endgültig.",
      "add": "Thema hinzufügen",
      "covers": "Was es abdeckt",
      "remove": "Thema entfernen",
      "untitled": "Thema ohne Titel",
      "newTopic": "Neues Thema",
      "editTitle": "Thema bearbeiten"
    },
    "keywords": {
      "cells": {
        "notMeasured": "Nicht gemessen",
        "notRanking": "Nicht platziert"
      }
    },
    "inspector": {
      "reasons": {
        "link": "Enthält einen Link",
        "unsupportedFigure": "Eine Zahl hat keine Quelle",
        "hookLength": "Der Einstieg ist zu lang",
        "bodyLength": "Der Haupttext ist zu lang",
        "captionLength": "Der Post ist zu lang",
        "ctaLines": "Der Call-to-Action ist länger als eine Zeile",
        "slideLayout": "Das Folienlayout stimmt nicht",
        "slideTextLength": "Ein Folientext ist zu lang",
        "slideParts": "Einer Folie fehlen Teile oder sie hat zu viele",
        "slideFigure": "Eine Zahl auf einer Folie stimmt nicht",
        "slideQuote": "Ein Zitat passt nicht zur Quelle",
        "slideHighlight": "Eine Hervorhebung stimmt nicht",
        "slideImages": "Zu viele Bildideen",
        "avoidedWord": "Nutzt ein Wort, das du meiden willst",
        "termForm": "Ein Name ist falsch geschrieben",
        "aiTell": "Klingt nach KI",
        "bannedStructure": "Nutzt eine verbotene Formulierung",
        "markdown": "Enthält Markdown-Zeichen",
        "hashtags": "Falsche Anzahl an Hashtags",
        "proof": "Kein Beleg für die Kernaussage",
        "phase": "Falsche Käuferphase",
        "beliefLink": "Argumentiert den Punkt nicht",
        "generic": "Raldo hat eine Regel markiert"
      },
      "beforePublish": "Vor dem Veröffentlichen",
      "history": "Verlauf",
      "argues": "Argumentiert",
      "stage": "Phase · {name}",
      "topic": "Thema",
      "standsOn": "Stützt sich auf",
      "sources": "{count} Quelle | {count} Quellen",
      "asksReaders": "Fordert Leser auf zu",
      "changedAfterCheck": "Du hast den Text nach Raldos Prüfung geändert.",
      "notChecked": "Raldo hat diesen Beitrag nicht geprüft.",
      "argument": "Argument",
      "argumentLine": "Das Argument, das dieser Beitrag vertritt.",
      "claim": "Aussage",
      "openArgument": "Argument öffnen",
      "standsOnLine": "Die Fakten im Beitrag und wer sie genannt hat.",
      "cta": {
        "toMedia": "Die Folien ansehen",
        "comment": "Kommentieren",
        "save": "Den Beitrag speichern",
        "article": "Den Artikel lesen",
        "demo": "Eine Demo buchen"
      },
      "bar": {
        "words": "{count} Wörter",
        "hashtags": "{count} Hashtags",
        "characters": "{count} / {limit} Zeichen",
        "readability": "Lesbarkeit {score}/10",
        "lengthAria": "Zur Länge",
        "lengthTitle": "Länge",
        "lengthOptimal": "Optimal sind etwa {count} Wörter für {channel}",
        "lengthVisible": "Die ersten {count} Zeichen erscheinen vor „mehr anzeigen“",
        "lengthNote": "Ein Richtwert, keine Grenze."
      },
      "brief": "Briefing"
    },
    "newPost": "Neuer Post"
  },
  "strategy": {
    "keyword": {
      "standing": {
        "page1": "Seite 1 bei Google · #{rank}",
        "below": "Unter Seite 1 bei Google · #{rank}",
        "rank": "#{rank}",
        "notRanking": "Kein Ranking bei Google"
      },
      "figures": {
        "searches": "Suchen im Monat",
        "onGoogle": "Bei Google",
        "notMeasured": "Noch nicht gemessen",
        "competition": "Schwierigkeit",
        "competitionScore": "{score} von 100",
        "firstRank": "#{rank} am {date}",
        "rank": "Dein Rang bei Google",
        "page1": "Seite 1",
        "below": "Unter Seite 1",
        "notRankingYet": "Noch kein Ranking",
        "ai": "Google AI Overview",
        "notChecked": "Noch nicht geprüft",
        "noAnswer": "Dafür gibt es keine KI-Antwort",
        "rivalCited": "Ein Konkurrent wird zitiert",
        "citesOthers": "Die Antwort zitiert andere",
        "rivalsToo": "Auch ein Konkurrent wird zitiert | Auch {count} Konkurrenten werden zitiert",
        "noRival": "Und kein Konkurrent",
        "cited": "Zitiert",
        "notCited": "Nicht zitiert"
      },
      "stats": {
        "published": "veröffentlicht",
        "drafting": "im Entwurf",
        "noContent": "noch ohne Content",
        "page1": "auf Seite 1",
        "below": "unter Seite 1",
        "rankRest": "kein Ranking oder noch nicht gemessen",
        "citeYou": "zitieren dich",
        "withoutYou": "antworten ohne dich",
        "aiRest": "ohne KI-Antwort",
        "covered": "Keywords, für die du Content hast",
        "ranking": "Keywords, bei denen du auf Seite 1 von Google rankst",
        "cited": "Keywords, bei denen KI-Antworten dich zitieren"
      },
      "citations": {
        "cited": "Zitiert",
        "notCited": "Nicht zitiert",
        "columns": {
          "site": "Website",
          "answer": "In der Antwort"
        }
      },
      "rankHistory": {
        "aria": "Suchrang der letzten {count} Wochen, von #{from} auf #{to}",
        "threshold": "Seite 1"
      },
      "difficultyScore": {
        "low": "Geringe Schwierigkeit, {score} von 100",
        "medium": "Mittlere Schwierigkeit, {score} von 100",
        "high": "Hohe Schwierigkeit, {score} von 100"
      },
      "difficulty": {
        "low": "Niedrig",
        "medium": "Mittel",
        "high": "Hoch"
      },
      "rankings": {
        "visits": "{visits} Besuch/Monat | {visits} Besuche/Monat",
        "none": "Weder du noch ein verfolgter Rivale rankt dafür.",
        "columns": {
          "rank": "Rang",
          "site": "Website",
          "page": "Seite, die rankt",
          "visits": "Besuche im Monat"
        }
      },
      "volumeHistory": {
        "aria": "Suchen im Monat, {from} bis {to}: von {first} auf {last}"
      },
      "site": {
        "you": "Du"
      }
    },
    "keywords": {
      "columns": {
        "keyword": "Keyword",
        "stage": "Phase",
        "volume": "Volumen/Monat",
        "difficulty": "Schwierigkeit",
        "searchRank": "Suchrang",
        "aiOverview": "Zitiert in AI Overview"
      }
    },
    "schedule": {
      "days": "Tage",
      "off": "Aus",
      "maxDays": "Höchstens {count} Tage pro Woche",
      "unsavedChanges": "Dein Posting-Plan hat ungespeicherte Änderungen."
    },
    "coreMessage": {
      "caption": "Deine Kernbotschaft",
      "editTitle": "Kernbotschaft bearbeiten"
    },
    "argument": {
      "open": "Argument öffnen: {subject}"
    },
    "noContent": "Noch kein Content",
    "pieces": {
      "count": "{count} Inhalte | {count} Inhalt | {count} Inhalte",
      "list": "{title}: {count} Inhalte | {title}: {count} Inhalt | {title}: {count} Inhalte",
      "seeAll": "Alle {count} Inhalte ansehen",
      "seeAllCount": "Alle {count} ansehen",
      "linkedinPost": "LinkedIn-Beitrag",
      "published": "Veröffentlicht am {date}",
      "scheduled": "Geplant für {date}",
      "draft": "Entwurf"
    },
    "journeyStage": "Reisephase",
    "addArgument": "Argument hinzufügen",
    "balance": {
      "caption": "Verteilung der Inhalte nach Phase der Kaufreise",
      "window": "Letzte 90 Tage",
      "aria": "Anteil der Inhalte je Reisephase"
    },
    "argumentPage": {
      "editTitle": "Argument bearbeiten",
      "crumb": "Argument: {stage}",
      "back": "Zurück zur Strategie",
      "remove": "Argument entfernen",
      "removeTitle": "Dieses Argument entfernen?",
      "removeBody": "Damit wird das Argument endgültig entfernt.",
      "content": "Inhalte",
      "posts": "{count} Beiträge | {count} Beitrag | {count} Beiträge",
      "articles": "{count} Seiten | {count} Seite | {count} Seiten",
      "postsAndArticles": "{posts} und {articles}",
      "groups": {
        "published": "Veröffentlicht",
        "scheduled": "Geplant",
        "drafts": "Entwürfe"
      },
      "noContentTitle": "Noch keine Inhalte zu diesem Argument",
      "noContentBody": "Plane eine Seite oder einen Post, und Raldo entwirft den Text aus diesem Argument."
    },
    "topicPage": {
      "distributionAria": "Anteil der Inhalte dieses Themas je Reisephase",
      "stageArguments": "Argumente in der Phase {stage}",
      "argumentCount": "{count} Argumente | {count} Argument | {count} Argumente",
      "noneCarried": "Noch keine Argumente in Inhalten",
      "nothingAtStage": "In diesem Thema argumentiert noch nichts in der Phase {stage}.",
      "piecesInTopic": "{count} Inhalte in diesem Thema | {count} Inhalt in diesem Thema | {count} Inhalte in diesem Thema",
      "notFoundTitle": "Dieses Thema gibt es nicht",
      "notFoundBody": "Es wurde vielleicht gelöscht, oder der Link stimmt nicht.",
      "missing": "Dieses Thema gibt es nicht mehr.",
      "tabsAria": "Bereiche des Themas"
    },
    "pages": {
      "groups": {
        "explainer": "Erklärseite",
        "offer": "Produktseiten",
        "comparison": "Vergleichsseiten",
        "use-case": "Anwendungsfallseiten",
        "supporting": "Begleitseiten"
      },
      "types": {
        "explainer": "Erklärseite",
        "offer": "Produktseite",
        "comparison": "Vergleichsseite",
        "use-case": "Anwendungsfallseite",
        "supporting": "Begleitseite"
      }
    },
    "citations": {
      "none": "Keine",
      "ownCited": "Du, zitiert",
      "ownNamed": "Nennt dich, ohne Link",
      "rivalCited": "{name}, zitiert"
    },
    "stageField": {
      "notPlaced": "Noch keiner Phase zugeordnet",
      "notPlacedHint": "Bearbeite es, um die Phase zu wählen."
    },
    "plan": {
      "start": "Seiten planen",
      "emptyTitle": "Noch kein Plan",
      "emptyBody": "Raldo listet jede Seite deiner Website auf und prüft, wie jede in der Suche rankt.",
      "stale": {
        "title": "Die Strategie hat sich nach diesem Plan geändert",
        "body": "Plane die Seiten neu, damit der Plan deiner aktuellen Strategie folgt."
      },
      "proposal": {
        "summary": {
          "nothing": "Der neue Plan ändert nichts an deinem aktuellen Plan.",
          "pagesAdded": "{count} Seite hinzugefügt | {count} Seiten hinzugefügt",
          "pagesRemoved": "{count} Seite entfernt | {count} Seiten entfernt",
          "pagesChanged": "{count} Seite geändert | {count} Seiten geändert",
          "pagesKept": "{count} geschriebene Seite bleibt | {count} geschriebene Seiten bleiben",
          "topicsAdded": "{count} Thema hinzugefügt | {count} Themen hinzugefügt",
          "topicsRemoved": "{count} Thema entfernt | {count} Themen entfernt",
          "topicsRenamed": "{count} Thema umbenannt | {count} Themen umbenannt"
        },
        "accept": "Übernehmen",
        "startBlocked": "Übernimm oder verwirf zuerst den neuen Plan.",
        "discardConfirm": {
          "title": "Neuen Plan verwerfen?",
          "body": "Dein aktueller Plan bleibt, wie er ist. Du kannst die Seiten später neu planen."
        },
        "refusals": {
          "ownerAdminRequired": "Nur Inhaber oder Admins können den Plan ändern.",
          "gateMissing": "Dieser Schritt wartet nicht mehr auf dich.",
          "answerInvalid": "Die Themen, die du behalten hast, passen nicht mehr zum Vorschlag. Lade neu und versuch es noch einmal."
        }
      },
      "run": {
        "working": "Raldo plant deine Seiten.",
        "waiting": "Der neue Plan wartet auf deine Prüfung.",
        "stages": {
          "inventory": "Raldo listet die Seiten deiner Website auf.",
          "content": "Raldo liest deine Seiten.",
          "research": "Raldo findet die Namen, die deine Käufer verwenden.",
          "competitors": "Raldo liest, wofür deine Wettbewerber ranken.",
          "demand": "Raldo misst, wie oft jeder Begriff gesucht wird.",
          "relevance": "Raldo bewertet die Suchen für dein Unternehmen.",
          "topic-candidates": "Raldo schlägt die Themen vor.",
          "review-topics": "Die Themen warten auf deine Prüfung.",
          "fill": "Raldo recherchiert das Thema, das du hinzugefügt hast.",
          "serp": "Raldo liest die Suchergebnisse zu jeder Suche.",
          "grouping": "Raldo fasst die Suchen zu Seiten zusammen.",
          "type-stage": "Raldo entscheidet, wofür jede Seite da ist.",
          "placement": "Raldo ordnet jede Seite einem Thema zu.",
          "decision-pages": "Raldo ergänzt die Seiten, die Käufer vor der Entscheidung lesen.",
          "site-match": "Raldo gleicht den Plan mit den Seiten deiner Website ab.",
          "review-plan": "Der Plan wartet auf deine Prüfung.",
          "commit": "Raldo schreibt den Plan."
        },
        "completed": "Der Plan ist fertig.",
        "partial": "Der Plan ist fertig, aber einige Schritte wurden nicht abgeschlossen.",
        "cancelled": "Du hast den Plan abgebrochen.",
        "failed": "Der Plan ist stehen geblieben",
        "startDescription": "Raldo plant zuerst deine Themen, dann die Seiten. Du prüfst beides.",
        "direction": "Richtung",
        "directionHint": "Eine Zeile, an die Raldo beim Planen denkt.",
        "directionPlaceholder": "Zum Beispiel: Fokus auf Antwortmaschinen",
        "market": "Markt",
        "planWithDirection": "Mit einer Richtung planen"
      },
      "figures": {
        "notMeasured": "Noch nicht gemessen"
      },
      "topics": {
        "pages": "Seiten",
        "writingOrder": "In Schreibreihenfolge",
        "pageCount": "{count} Seite | {count} Seiten",
        "progress": "{count} von {total} Seiten geschrieben, live oder auf deiner Website",
        "pagesDone": "{count} von {total} Seiten",
        "statusCounts": {
          "planned": "{count} geplant",
          "writing": "{count} in Arbeit",
          "live": "{count} live",
          "site": "{count} auf deiner Website"
        }
      },
      "page": {
        "hub": "Hub-Seite",
        "searchesAMonth": "{volume} Suchen im Monat",
        "writeNext": "Als Nächstes schreiben",
        "comparesWith": "Vergleicht mit {name}",
        "searches": "Suchen, die sie beantwortet",
        "columns": {
          "search": "Suche",
          "role": "Rolle",
          "volume": "Suchen im Monat"
        },
        "roles": {
          "main": "Hauptsuche",
          "secondary": "Nebensuche"
        },
        "updates": "Aktualisiert eine Seite auf deiner Website",
        "noArticleTitle": "Noch kein Entwurf",
        "noArticleBody": "Raldo entwirft den Text, der diese Frage beantwortet, aus deinen Argumenten und Quellen.",
        "notFoundTitle": "Diese Seite gibt es nicht",
        "notFoundBody": "Vielleicht wurde sie gelöscht, oder der Link ist falsch.",
        "write": "Seite schreiben",
        "run": {
          "working": "Raldo schreibt diese Seite.",
          "stages": {
            "sources": "Raldo liest die Seiten, die für diese Frage ranken.",
            "scope": "Raldo ordnet, was die Seiten sagen, den Themen dieser Seite zu.",
            "trace": "Raldo verfolgt jeden Fakt bis zu seiner Originalquelle.",
            "evidence": "Raldo liest deine eigenen Seiten nach dem, was du aus erster Hand zeigen kannst.",
            "gain": "Raldo sucht, was diese Seite hinzufügen kann.",
            "argument": "Raldo wählt das Argument dieser Seite.",
            "plan": "Raldo plant die Seite.",
            "draft": "Raldo entwirft die Seite.",
            "edit": "Raldo überarbeitet die Seite.",
            "check": "Raldo prüft die Seite.",
            "handoff": "Raldo bereitet die Seite für deine Website vor."
          },
          "completed": "Die Seite ist geschrieben.",
          "partial": "Die Seite ist geschrieben, aber einige Schritte sind nicht fertig geworden.",
          "cancelled": "Du hast die Seite abgebrochen.",
          "failed": "Die Seite ist stehen geblieben",
          "waiting": "Raldo hat Fragen an dich. Beantworte oder überspringe sie, dann geht die Seite weiter."
        },
        "research": {
          "title": "Recherche",
          "sources": "{read} von {found} Seiten gelesen",
          "statements": "Aussagen der Seiten",
          "items": "{items} Themen",
          "points": "Punkte, Format {format}",
          "noFormat": "nicht gesetzt",
          "facts": "{facts} Fakten",
          "traced": "bis zur Quelle verfolgt, {waiting} warten",
          "ownPages": "{pages} deiner eigenen Seiten",
          "evidence": "Belege, {items} Themen mit Belegen"
        },
        "argumentCarriedBy": "Getragen von {item}",
        "gains": {
          "kinds": {
            "disagreement": "Quellen widersprechen sich",
            "gap": "Lücke",
            "ai-answers": "KI-Antworten",
            "brand": "Von dir"
          }
        },
        "questions": {
          "title": "Fragen an dich",
          "open": "{count} offen | {count} offen",
          "hint": "Was hilft: {hint}",
          "without": "Ohne sie: {without}",
          "placeholder": "Gib hier deine Antwort ein",
          "answer": "Antworten",
          "skip": "Überspringen",
          "skipped": "Übersprungen"
        },
        "hubOf": "Hub von {topic}",
        "fault": {
          "title": "Raldo konnte die Live-Seite nicht lesen",
          "body": "Raldo hat {address} am {date} geprüft. Die Seite gilt als live, sobald eine Prüfung besteht.",
          "bodyUndated": "Raldo hat {address} geprüft. Die Seite gilt als live, sobald eine Prüfung besteht."
        },
        "noArticleRunning": "Raldo entwirft ihn, sobald die Recherche fertig ist.",
        "noArticleSite": "Diese Seite ist schon auf deiner Website.",
        "noSearchesTitle": "Keine Suchanfragen für diese Seite",
        "noSearchesBody": "Diese Seite trägt ein Argument, keine Suchanfrage. Ihre Reichweite siehst du unter Sichtbarkeit, KI-Antworten."
      },
      "status": {
        "planned": "Geplant",
        "writing": "In Arbeit",
        "live": "Live",
        "site": "Auf deiner Website"
      },
      "argument": {
        "underTopic": "Vertreten im Thema",
        "pages": "Seiten, die es vertreten",
        "pageCount": "{count} Seite | {count} Seiten"
      },
      "overview": {
        "pagesByStage": "{count} Seite | {count} Seiten",
        "caption": "Geplante Seiten nach Phase der Kaufreise",
        "ariaLabel": "Anteil der geplanten Seiten je Reisephase"
      },
      "setup": {
        "title": "Dein Plan",
        "startsWith": "Beginnt mit: {question}"
      },
      "stops": {
        "aria": "Schritte des Planlaufs",
        "titles": {
          "find-topics": "Themen finden",
          "review-topics": "Themen prüfen",
          "plan-pages": "Seiten planen",
          "review-plan": "Plan prüfen"
        },
        "stepOf": "Schritt {n} von {total}",
        "done": "Fertig",
        "waitsForYou": "Wartet auf dich",
        "yourReview": "Deine Prüfung",
        "steps": "{count} Schritt | {count} Schritte"
      },
      "step": {
        "titles": {
          "inventory": "Seiten der Website",
          "content": "Seiteninhalt",
          "research": "Recherche",
          "competitors": "Wettbewerber",
          "demand": "Nachfrage",
          "relevance": "Relevanz",
          "topic-candidates": "Themenvorschläge",
          "review-topics": "Themen prüfen",
          "fill": "Neue Themen füllen",
          "serp": "Suchergebnisse",
          "grouping": "Seiten",
          "type-stage": "Seitentypen",
          "placement": "Zuordnung",
          "decision-pages": "Entscheidungsseiten",
          "site-match": "Abgleich mit der Website",
          "review-plan": "Plan prüfen",
          "commit": "Plan schreiben"
        },
        "summaries": {
          "inventory": "{count} Seite auf deiner Website | {count} Seiten auf deiner Website",
          "content": "{count} Seite gelesen | {count} Seiten gelesen",
          "research": "{terms} Begriffe für {coverage} Bereiche",
          "competitors": "{competitors} Wettbewerber · {searches} Suchen",
          "demand": "{count} Suche gemessen | {count} Suchen gemessen",
          "relevance": "{kept} von {units} Suchen behalten",
          "topic-candidates": "{count} Thema vorgeschlagen | {count} Themen vorgeschlagen",
          "review-topics": "{count} Thema angenommen | {count} Themen angenommen",
          "fill": "Kein Thema zu recherchieren | {count} Thema recherchiert | {count} Themen recherchiert",
          "serp": "{count} Suche gelesen | {count} Suchen gelesen",
          "grouping": "{pages} Seiten aus {keywords} Suchen",
          "type-stage": "{kept} von {pages} Seiten behalten",
          "placement": "{pages} Seiten unter {topics} Themen",
          "decision-pages": "{count} Entscheidungsseite | {count} Entscheidungsseiten",
          "site-match": "{planned} Seiten · {update} aktualisieren eine Seite deiner Website",
          "review-plan": "Keine Seite entfernt | {count} Seite entfernt | {count} Seiten entfernt",
          "commit": "{pages} Seiten in {topics} Themen"
        },
        "counts": {
          "keywords": "Suchen",
          "ordered": "Angefragte Suchen",
          "received": "Erhaltene Ergebnisse",
          "missing": "Fehlende Ergebnisse",
          "clusters": "Gruppen",
          "pages": "Seiten",
          "topics": "Themen",
          "dropped": "Ausgelassene Themen",
          "objectives": "Argumente",
          "planned": "Geplante Seiten",
          "existing": "Seiten auf deiner Website",
          "excluded": "Ausgelassene Seiten",
          "byRanking": "Über das Ranking zugeordnet",
          "byModel": "Über das Lesen zugeordnet",
          "update": "Zu aktualisierende Seiten"
        },
        "finished": "Fertig {time}",
        "durationSeconds": "{count} s",
        "durationMinutes": "{count} Min.",
        "back": "Zurück zum Lauf",
        "rerun": "Ab hier neu starten",
        "rerunBlocked": "Warte, bis der Lauf bei einer Prüfung hält, und starte dann neu.",
        "rerunConfirm": {
          "title": "Ab {step} neu starten?",
          "body": "Die Schritte davor behalten ihre Ergebnisse. Raldo führt den Rest erneut aus und hält bei deinen Prüfungen.",
          "confirm": "Neu starten"
        },
        "coverage": "Bereiche",
        "coverageMeta": "Wonach Raldo gesucht hat",
        "terms": "Begriffe",
        "kept": "Behalten",
        "dropped": "Verworfen",
        "removedByYou": "Von dir entfernt",
        "editsNote": "Deine Änderungen liegen neben Raldos Ergebnis. Raldo kann beides zeigen.",
        "score": "{score} von 5",
        "notScored": "Noch nicht bewertet",
        "columns": {
          "term": "Begriff",
          "coverage": "Bereich",
          "search": "Suche",
          "volume": "Suchen im Monat",
          "score": "Relevanz",
          "kept": "Behalten",
          "reason": "Warum",
          "actions": "Aktionen"
        },
        "research": {
          "figures": {
            "coverage": "Bereiche",
            "terms": "Gefundene Begriffe",
            "kept": "Nach Relevanz behalten",
            "changed": "Von dir geändert"
          },
          "termCount": "{count} Begriff | {count} Begriffe",
          "addTerm": "Begriff hinzufügen",
          "termPlaceholder": "Nenne den Begriff",
          "notPlaced": "Noch keinem Bereich zugeordnet"
        },
        "competitors": {
          "caption": "{searches} Suche · {website} | {searches} Suchen · {website}"
        },
        "demand": {
          "figures": {
            "measured": "Gemessene Suchen",
            "units": "Gefundene Suchen"
          },
          "measuredOf": "{measured} von {terms} gemessen"
        },
        "relevance": {
          "figures": {
            "kept": "Behaltene Suchen",
            "dropped": "Verworfene Suchen"
          }
        }
      },
      "review": {
        "topicsTitle": "Prüfe die Themen",
        "topicsBody": "Raldo schlägt {count} Thema vor. Behalte es, benenne es um oder füge eigene hinzu, dann plant Raldo die Seiten. | Raldo schlägt {count} Themen vor. Behalte die, die du besetzen willst, benenne den Rest um oder entferne ihn, füge eigene hinzu, dann plant Raldo die Seiten.",
        "topicCounts": "Angenommen: {kept} · Entfernt: {removed}",
        "keepOne": "Behalte mindestens ein Thema.",
        "addTopic": "Thema hinzufügen",
        "namePlaceholder": "Benenne das Thema",
        "add": "Hinzufügen",
        "rename": "Umbenennen",
        "remove": "Entfernen",
        "keep": "Behalten",
        "removed": "Entfernt",
        "renamed": "Umbenannt",
        "moveUp": "Nach oben",
        "moveDown": "Nach unten",
        "addedByYou": "Von dir hinzugefügt",
        "addedCaption": "Raldo recherchiert dieses Thema, wenn es die Seiten plant.",
        "argues": "Vertritt {names}",
        "difficulty": {
          "easy": "Leicht für deine Website",
          "medium": "Braucht etwas Arbeit",
          "hard": "Schwer für deine Website"
        },
        "topicsNote": "Raldo plant nur Seiten für die angenommenen Themen. Die Themen, die du hinzugefügt hast, recherchiert es zuerst.",
        "planTitle": "Prüfe den Plan",
        "planHint": "Öffne ein Thema, entferne Seiten, die du nicht willst, und nimm den Plan dann an.",
        "hub": "Hub: {question}",
        "decisionPage": "Entscheidungsseite"
      }
    },
    "research": {
      "title": "Recherche",
      "emptyTitle": "Noch keine Recherche",
      "emptyBody": "Schreibe eine Seite dieses Themas, und Raldo verfolgt jeden Fakt bis zu seiner Originalquelle.",
      "readyAndWaiting": "{ready} bereit · {waiting} warten auf eine Quelle",
      "entryCount": "{count} Eintrag | {count} Einträge",
      "usedBy": "Genutzt von {count} Seite | Genutzt von {count} Seiten",
      "notUsed": "Noch nicht genutzt",
      "foundOn": "Gefunden auf {pages}",
      "waitingTitle": "Warten auf eine Quelle",
      "waitingCount": "{count} Eintrag | {count} Einträge",
      "waitingNote": "Ein Lauf hat diese gefunden, aber keine Originalquelle erreicht. Sie sind noch nicht nutzbar.",
      "columns": {
        "research": "Recherche",
        "foundOn": "Gefunden auf",
        "why": "Warum sie wartet"
      },
      "forPage": "Für {page}",
      "statesItAs": "{source} sagt es so",
      "checked": "Geprüft am {date}",
      "checkAgain": "Erneut prüfen",
      "dueForCheck": "{count} Eintrag zuletzt vor über {days} Tagen geprüft | {count} Einträge zuletzt vor über {days} Tagen geprüft",
      "checkedToast": "{count} Eintrag geprüft | {count} Einträge geprüft",
      "changedCount": "{count} geändert",
      "failedCount": "{count} nicht prüfbar",
      "failedToast": "{count} Eintrag konnte nicht geprüft werden | {count} Einträge konnten nicht geprüft werden",
      "nothingDue": "Kein Eintrag war zur Prüfung fällig",
      "retrievedFrom": "Abgerufen von",
      "originalSource": "Originalquelle",
      "foundOnSource": "Gefunden auf: {title}",
      "relevantTo": "Relevant für",
      "outlineItem": "Gliederungspunkt „{item}“",
      "usedByTitle": "Genutzt von",
      "sectionCount": "{count} Abschnitt | {count} Abschnitte",
      "section": "Abschnitt „{heading}“",
      "noMatch": "Kein Gliederungspunkt passt dazu.",
      "noUse": "Noch kein Seitenabschnitt nennt es als Quelle.",
      "notFoundTitle": "Diesen Recherche-Eintrag gibt es nicht",
      "notFoundBody": "Ein neuerer Lauf hat ihn vielleicht ersetzt, oder der Link stimmt nicht.",
      "trace": {
        "traced": "Über den Link verfolgt",
        "tracedBySearch": "Über die Suche verfolgt",
        "originNotReached": "Andere Seiten wiederholen es. Das Original wurde nicht erreicht.",
        "originNotReachedNamed": "Andere Seiten wiederholen es und nennen {source}. Das Original wurde nicht erreicht.",
        "doesNotStateIt": "Die verlinkte Quelle sagt es nicht.",
        "noSourceGiven": "Keine Quelle angegeben, und die Suche hat keine gefunden.",
        "sentenceNotVerified": "Die Quellseite sagt es nicht wörtlich.",
        "notJudged": "Der Lauf hat sein Limit erreicht, bevor er es prüfen konnte.",
        "originIsRival": "Der Ursprung ist eine rankende Seite oder die eines Rivalen."
      },
      "quoted": "„{quote}“"
    },
    "addPage": {
      "action": "Seite hinzufügen",
      "title": "Seite hinzufügen",
      "description": "Raldo setzt die Seite ans Ende der Schreibreihenfolge dieses Themas. Das kann bis zu zwei Minuten dauern.",
      "questionLabel": "Frage",
      "questionPlaceholder": "Welche Frage beantwortet die Seite?",
      "keywordLabel": "Keyword",
      "keywordHint": "Raldo misst, wie oft danach gesucht wird.",
      "tooLong": "Verwende höchstens {max} Zeichen.",
      "confirm": "Seite hinzufügen",
      "adding": "Fügt die Seite hinzu",
      "refusals": {
        "editorRequired": "Deine Rolle darf diese Marke lesen, aber nicht ändern.",
        "pageExists": "Der Plan hat schon eine Seite für diese Frage oder dieses Keyword.",
        "notFit": "Raldo konnte diese Seite nicht in deinen Plan einfügen. Versuche eine andere Frage."
      }
    },
    "findMorePages": {
      "action": "Mehr Seiten finden",
      "needsPlan": "Erstelle zuerst einen Plan. Raldo fügt die neuen Seiten dort hinzu."
    }
  },
  "article": {
    "document": {
      "askAboutPassage": "Raldo fragen"
    },
    "preview": {
      "heading": "So sieht es im Suchergebnis aus",
      "titleLabel": "Ergebnistitel",
      "summaryLabel": "Ergebniszusammenfassung",
      "hint": "Klicke auf eine der Zeilen, um sie zu bearbeiten.",
      "address": "… › {slug}",
      "addressWithDomain": "{domain} › {slug}",
      "cutHint": "Google schneidet den eingefärbten Teil ab.",
      "emptyTitle": "Titel hinzufügen",
      "emptySummary": "Google schreibt eine eigene Zusammenfassung, wenn dieses Feld leer ist."
    },
    "todo": {
      "askRaldo": "Raldo fragen"
    },
    "details": {
      "todo": "Zu tun",
      "links": {
        "missingLive": "Nicht auf der Live-Seite",
        "missingLiveTitle": "Die Live-Seite enthält keinen Link auf „{title}“",
        "missingLiveBody": "Raldo hat {page} am {date} gelesen. Der Entwurf verlinkt auf diese Seite, die veröffentlichte Fassung nicht. Veröffentliche den Export erneut.",
        "missingLiveBodyUndated": "Raldo hat {page} gelesen. Der Entwurf verlinkt auf diese Seite, die veröffentlichte Fassung nicht. Veröffentliche den Export erneut.",
        "checkAgain": "Erneut prüfen"
      },
      "basedOn": {
        "nothing": "Nichts über den Konsens hinaus."
      }
    },
    "panel": {
      "label": "Ansicht des Bereichs",
      "content": "Inhalt",
      "search": "Suche",
      "sections": "Abschnitte"
    },
    "status": {
      "draft": "Entwurf"
    },
    "header": {
      "publishedUrlPlaceholder": "https://deinedomain.de/blog/...",
      "publishedUrlError": "Gib eine Webadresse ein, wie raldo.ai/blog/mein-beitrag.",
      "attachUrlConfirm": "Speichern",
      "openPublished": "Seite öffnen",
      "markPublished": "Als veröffentlicht markieren",
      "promote": "Zu einem Beitrag befördern",
      "export": "Exportieren",
      "exportNotReady": "Exportieren, sobald die Seite geschrieben ist."
    },
    "inspector": {
      "groups": {
        "blockers": "Vor der Veröffentlichung",
        "search": "Suchübersicht"
      },
      "showMe": "Zeig es mir",
      "blockers": {
        "claims": "Ein Satz hat keinen Beleg | {count} Sätze haben keinen Beleg",
        "termForm": "Namen falsch geschrieben",
        "termFormCaption": "{spellings} · {count} Stelle | {spellings} · {count} Stellen",
        "readability": "Schwer zu lesen",
        "readabilityCaption": "Leseniveau {score}, das Limit ist {limit}",
        "placeholders": "Noch auszufüllen"
      },
      "claims": {
        "text": "Nichts in deinem Material stützt diese Sätze.",
        "quote": "„{sentence}“"
      },
      "termForm": {
        "text": "Ein Name braucht seine eigene Schreibweise.",
        "hit": "\"{from}\" wird \"{to}\" geschrieben",
        "places": "{count} Stelle | {count} Stellen"
      },
      "readability": {
        "hardestFirst": "Am schwersten zuerst"
      },
      "placeholders": {
        "text": "Diese Stellen im Text sind noch leer."
      },
      "metric": {
        "grade": "Lesestufe {count}",
        "filler": "Keine Füllwörter | {count} Füllwort | {count} Füllwörter",
        "gain": "{count} % der Wörter bringen etwas Neues",
        "copies": "{count} Satz kopiert | {count} Sätze kopieren",
        "noCopies": "Kein Satz kopiert",
        "companyOk": "Alle geplanten Fakten genannt",
        "companyMissing": "Ein geplanter Firmenfakt fehlt",
        "tablesOk": "Keine Tabelle ohne Quelle",
        "tablesMissing": "{count} Tabellenzeile ohne Quelle | {count} Tabellenzeilen ohne Quelle"
      },
      "basedOn": {
        "answers": "Deine Antworten",
        "answersText": "Was du Raldo gesagt hast und wo der Autor es genutzt hat.",
        "yourAnswer": "Deine Antwort",
        "brand": "Deine Marke",
        "brandText": "Fakten deiner Marke, die den Text geprägt haben.",
        "sources": "Zitierte Quellen",
        "sourcesText": "Jeder Fakt, den der Text von einer anderen Seite übernimmt.",
        "pages": "Seiten, die der Autor gelesen hat",
        "pagesText": "Die Seiten im Ranking, die Raldo vor dem Schreiben gelesen hat. Nicht zitiert.",
        "pageSections": "{count} Abschnitt | {count} Abschnitte",
        "adds": "Was diese Seite ergänzt",
        "addsText": "Was die Seiten im Ranking nicht sagen."
      },
      "gain": {
        "ai-answers": "KI-Antworten",
        "brand": "Deine Marke",
        "disagreement": "Widerspruch"
      },
      "publishing": {
        "faq": "FAQ-Schema",
        "faqText": "Die Fragen, die das CMS als strukturierte Daten erhält.",
        "links": "Links zu deinen Seiten",
        "linksText": "Seiten des Themas, auf die diese Seite verlinkt, mit ihrer aktuellen Adresse. Eine Seite, die noch nicht veröffentlicht ist, geht später live.",
        "notLive": "Geht später live"
      }
    },
    "sources": {
      "title": "Quellen"
    },
    "look": {
      "title": "Einen Blick wert",
      "headingCase": "Überschrift in Title Case",
      "headingCaseText": "Überschriften lesen sich besser ohne Title Case.",
      "keywordHeading": "Keyword fehlt in Überschriften",
      "keywordHeadingText": "Keine Abschnittsüberschrift enthält das Haupt-Keyword.",
      "rule": "Schreibregel",
      "noNearCopy": {
        "title": "Kopiert eine Rankingseite",
        "caption": "{count} Satz | {count} Sätze",
        "text": "Diese Sätze teilen sich eine lange Wortfolge mit einer Seite, die rankt.",
        "ask": "Raldo bitten, sie umzuformulieren",
        "askMessage": "Formuliere die Sätze um, die Rankingseiten kopieren."
      },
      "noFiller": {
        "title": "Füllmaterial",
        "caption": "{count} Abschnitt | {count} Abschnitte",
        "text": "Sätze, die nur da sind, um Platz zu füllen."
      },
      "statesGain": {
        "title": "Sagt nichts Neues",
        "caption": "{count} Abschnitt | {count} Abschnitte",
        "text": "Der Abschnitt sagt nur, was Rankingseiten schon sagen."
      }
    },
    "top": {
      "words": "{count} Wort | {count} Wörter",
      "faqs": "{count} FAQ | {count} FAQs",
      "links": "{count} Link | {count} Links"
    }
  },
  "notes": {
    "toast": {
      "addEntryFailed": "Dieser Eintrag konnte nicht hinzugefügt werden",
      "saveEditFailed": "Diese Änderung konnte nicht gespeichert werden",
      "deleteEntryFailed": "Dieser Eintrag konnte nicht gelöscht werden"
    },
    "deleteEntryTitle": "Diesen Eintrag löschen?",
    "deleteEntryBody": "Dadurch wird es aus deinen Notizen entfernt. Das kann von hier aus nicht rückgängig gemacht werden.",
    "removeLink": "Link entfernen",
    "composerPlaceholder": "Was sollte Raldo wissen?"
  },
  "insights": {
    "impressionsLabel": "Impressionen",
    "reachLabel": "Reichweite"
  },
  "chat": {
    "untitledChat": "Unbenannter Chat",
    "conversationLabel": "Unterhaltung",
    "scrollToBottom": "Nach unten scrollen",
    "backToWhereIWas": "Zurück zu meiner letzten Stelle",
    "removeContextItem": "{label} entfernen",
    "context": {
      "passage": "„{text}“"
    },
    "closedThreadMessage": "Dieser Chat ist geschlossen. Starte einen neuen Chat, um weiterzumachen.",
    "deleteDialog": {
      "title": "\"{name}\" löschen?",
      "description": "Diese Unterhaltung und alle Nachrichten darin werden endgültig gelöscht. Das kann nicht rückgängig gemacht werden."
    },
    "errors": {
      "rateLimited": "Du hast das Nachrichtenlimit erreicht. Bitte warte einen Moment und versuche es erneut.",
      "notYours": "Diese Unterhaltung gehört jemand anderem.",
      "deleteFailed": "Diese Unterhaltung konnte nicht gelöscht werden",
      "loadThreadsFailed": "Deine Unterhaltungen konnten nicht geladen werden",
      "loadThreadFailed": "Diese Unterhaltung konnte nicht geladen werden"
    },
    "dock": {
      "close": "Chat schließen",
      "label": "Kontextchat",
      "askRaldo": "Raldo fragen",
      "resize": "Bereich in der Breite ändern"
    },
    "composer": {
      "placeholder": "Schreib etwas",
      "send": "Senden",
      "stop": "Stopp",
      "attach": "Bild anhängen",
      "attachedImage": "Angehängtes Bild",
      "removeImage": "Bild entfernen",
      "uploadingImage": "Bild wird hochgeladen",
      "retry": "Erneut versuchen",
      "tabKey": "Tab",
      "dropToAttach": "Zum Anhängen loslassen",
      "keyHint": "Enter sendet · Umschalt und Enter macht eine neue Zeile"
    },
    "agentPulse": "Raldo arbeitet",
    "badge": {
      "closed": "Geschlossen"
    },
    "nav": {
      "chats": "Chats",
      "newChat": "Neuer Chat",
      "seeAll": "Alle Chats ansehen"
    },
    "archive": {
      "messageCount": "1 Nachricht | {count} Nachrichten",
      "actionsFor": "Aktionen für {title}"
    },
    "chatsView": {
      "loading": "Deine Unterhaltungen werden geladen",
      "tryAgain": "Erneut versuchen",
      "emptyTitle": "Noch keine Unterhaltungen",
      "emptyDescription": "Jeder Chat, den du mit Raldo startest, wird hier gesammelt, neueste zuerst.",
      "listAria": "Unterhaltungen",
      "showingRange": "{start} bis {end} werden angezeigt",
      "previous": "Zurück",
      "next": "Weiter"
    },
    "activity": {
      "thinking": "Denkt nach…",
      "webSearch": "Websuche läuft…",
      "research": "Wettbewerber wird recherchiert…",
      "drafting": "Briefing wird entworfen…",
      "editing": "Text wird bearbeitet…",
      "generating": "Wird generiert…",
      "navigating": "Wird geöffnet…",
      "failed": "fehlgeschlagen",
      "notOpened": "Nicht geöffnet",
      "inProgress": "in Bearbeitung",
      "done": "fertig",
      "pending": "ausstehend",
      "opener": "Denkt nach",
      "workedSummary": "Hat {seconds}s gearbeitet · {count} Schritt | Hat {seconds}s gearbeitet · {count} Schritte",
      "workedSummaryUnknownDuration": "Hat {count} Schritt bearbeitet | Hat {count} Schritte bearbeitet",
      "summaryWithFailures": "{summary} · {failed}",
      "failedCount": "{count} fehlgeschlagen",
      "moreSources": "+{count} weitere",
      "searchingWebFor": "Durchsucht das Web nach „{query}“",
      "searchGroup": "Durchsucht das Web · {count} Suche | Durchsucht das Web · {count} Suchen",
      "resultCount": "{count} Ergebnis | {count} Ergebnisse",
      "searching": "Suche läuft…",
      "label": {
        "fallback": {
          "thinking": "Denkt nach",
          "webSearch": "Durchsucht das Web",
          "research": "Sucht etwas heraus",
          "drafting": "Entwirft",
          "editing": "Nimmt eine Änderung vor",
          "generating": "Generiert",
          "navigating": "Öffnet einen Bildschirm"
        },
        "question": {
          "asking": "Stellt eine Frage"
        },
        "documents": {
          "listing": "Prüft verfügbare Dokumente",
          "reading": "Liest ein Dokument"
        },
        "knowledge": {
          "listing": "Prüft dein Wissen",
          "readingPage": "Liest eine Wissensseite",
          "organizing": "Ordnet dein Wissen"
        },
        "inbox": {
          "checking": "Prüft den Posteingang"
        },
        "memoryCandidate": {
          "noting": "Merkt sich etwas"
        },
        "memory": {
          "checking": "Prüft das Markengedächtnis",
          "readingPage": "Liest eine Gedächtnisseite",
          "followingLink": "Folgt einem Gedächtnislink"
        },
        "socialConnect": {
          "offeringLinkedIn": "Bietet an, LinkedIn zu verbinden",
          "checkingLinkedIn": "Prüft die LinkedIn-Verbindung"
        },
        "research": {
          "checkingAnalytics": "Prüft die Analysen",
          "checkingTrackedCompetitors": "Prüft die verfolgten Wettbewerber",
          "checkingCompetitorReport": "Prüft den Wettbewerbsbericht",
          "checkingRecentContent": "Prüft aktuelle Inhalte",
          "readingPost": "Liest den Beitrag",
          "searchingWeb": "Durchsucht das Web",
          "readingWebPage": "Liest eine Webseite",
          "checkingSimilarCompanies": "Prüft ähnliche Unternehmen",
          "readingLinkedInPage": "Liest die LinkedIn-Seite",
          "checkingPostHistory": "Prüft den Beitragsverlauf",
          "checkingDesigns": "Prüft deine Designs",
          "readingPrompts": "Liest deine Prompts für KI-Antworten",
          "readingPlan": "Liest den Plan",
          "readingResearch": "Liest die Recherche eines Themas"
        },
        "competitor": {
          "adding": "Fügt einen Wettbewerber hinzu"
        },
        "competitors": {
          "analyzing": "Analysiert Wettbewerber"
        },
        "design": {
          "starting": "Design wird gestartet",
          "checkingRun": "Design-Lauf wird geprüft",
          "attachingToPost": "Design wird am Beitrag angehängt",
          "addingReference": "Referenzbild wird hinzugefügt",
          "checkingReferences": "Referenzbilder werden geprüft",
          "editing": "Das Design wird geändert",
          "checkingEdit": "Die Design-Änderung wird geprüft"
        },
        "styleGuide": {
          "readingPosts": "Liest die Beiträge der Marke"
        },
        "visualStyle": {
          "checking": "Prüft den visuellen Stil",
          "writing": "Schreibt den visuellen Stil"
        },
        "onboarding": {
          "completing": "Schließt das Onboarding ab"
        },
        "post": {
          "editing": "Bearbeitet den Beitrag",
          "publishingNow": "Veröffentlicht den Beitrag jetzt",
          "scheduling": "Plant den Beitrag",
          "writing": "Schreibt einen Post"
        },
        "note": {
          "logging": "Erfasst eine Notiz"
        },
        "companyProfile": {
          "readingWebsite": "Liest die Unternehmenswebsite"
        },
        "brandFoundation": {
          "drafting": "Entwirft das Markenfundament"
        },
        "knowledgePage": {
          "writing": "Schreibt eine Wissensseite"
        },
        "document": {
          "writingNamed": "Schreibt dein {name}",
          "writingGeneric": "Schreibt in ein Dokument",
          "approvingNamed": "Genehmigt dein {name}",
          "approvingGeneric": "Genehmigt ein Dokument"
        },
        "stage": {
          "openingScreen": "Öffnet {screen}",
          "openingGeneric": "Öffnet einen Bildschirm"
        },
        "workspace": {
          "listingFiles": "Workspace-Dateien werden aufgelistet",
          "readingFile": "Workspace-Datei wird gelesen",
          "writingFile": "Workspace-Datei wird geschrieben",
          "editingFile": "Workspace-Datei wird bearbeitet",
          "deletingFile": "Workspace-Datei wird gelöscht",
          "renderingPage": "Seite wird gerendert",
          "listingReferences": "Referenzbilder werden aufgelistet",
          "readingReference": "Referenzbild wird gelesen",
          "importingImage": "Importiert ein Bild"
        },
        "page": {
          "writing": "Schreibt die Seite",
          "adding": "Fügt eine Seite hinzu"
        },
        "topic": {
          "adding": "Fügt ein Thema hinzu"
        }
      },
      "outcome": {
        "documentUpdated": "{name} aktualisiert",
        "documentApproved": "{name} genehmigt",
        "styleGuideBuilt": "Aus {sampleCount} Beiträgen erstellt",
        "visualStyleSaved": "Visueller Stil gespeichert",
        "companyProfileSaved": "Unternehmensprofil gespeichert",
        "competitorAdded": "{name} hinzugefügt",
        "competitorsAnalyzed": "{count} Wettbewerber analysiert",
        "designRunStarted": "Design gestartet: {designName}",
        "designAttachedToPost": "Design am Beitrag angehängt",
        "designReferenceAdded": "{name} hinzugefügt",
        "postScheduled": "Beitrag geplant",
        "postPublished": "Beitrag veröffentlicht",
        "postEdited": "Beitrag aktualisiert",
        "noteLogged": "Notiz erfasst",
        "knowledgePageWritten": "{title} gespeichert",
        "knowledgeOrganized": "Wissen geordnet",
        "artifactLinked": "{name} ansehen",
        "pageWriteStarted": "Seite gestartet: {title}",
        "postWriteStarted": "Post gestartet",
        "pageAdded": "Seite hinzugefügt: {title}",
        "designEditStarted": "Design-Änderung gestartet",
        "topicAdded": "Thema hinzugefügt: {title}"
      }
    },
    "agentAsk": {
      "action": {
        "allow": "Erlauben",
        "notNow": "Nicht jetzt",
        "done": "Erledigt.",
        "declined": "Du hast Nein gesagt.",
        "expired": "Das ist abgelaufen. Frag Raldo erneut, falls du es noch möchtest.",
        "cannotUndo": "Das kann nicht rückgängig gemacht werden.",
        "failedNote": "Du hast das erlaubt, aber es hat nicht geklappt: {reason}",
        "settled": "Diese Anfrage ist abgeschlossen."
      },
      "question": {
        "typeAnswer": "Antwort eingeben",
        "answered": "Beantwortet.",
        "expired": "Das ist abgelaufen. Frag Raldo erneut, falls du es noch möchtest.",
        "settled": "Diese Frage ist abgeschlossen."
      },
      "connect": {
        "caption": "Veröffentliche und plane Beiträge direkt aus Raldo heraus.",
        "connect": "{platform} verbinden",
        "skip": "Später",
        "connected": "{platform} verbunden.",
        "expired": "Das ist abgelaufen. Frag Raldo erneut, falls du dich noch verbinden möchtest.",
        "settled": "Diese Verbindungsanfrage ist abgeschlossen."
      }
    },
    "sources": {
      "count": "1 Quelle | {count} Quellen",
      "yourKnowledge": "Dein Wissen"
    },
    "designSuggestions": {
      "label": "Vorgeschlagene Änderungen",
      "bigger": "Mach das größer",
      "dropRow": "Eine Zeile entfernen",
      "accent": "Die Akzentfarbe verwenden",
      "moveUp": "Ein Stück nach oben schieben",
      "fit": "Mach, dass es passt"
    }
  },
  "home": {
    "yourBrandFallback": "deine Marke",
    "conversationStarted": "Unterhaltung gestartet.",
    "composerPlaceholders": [
      "Einen Wettbewerber recherchieren",
      "Einen Beitrag für LinkedIn entwerfen",
      "Die Performance von {name} im letzten Monat auswerten",
      "Content für die kommende Woche planen"
    ],
    "demo": {
      "searchedCompetitorPricing": "6 Preisseiten von Wettbewerbern nach nutzungsbasierten Tarifen durchsucht.",
      "comparedCompetitorFraming": "Verglichen, wie Konkurrent X Mehrverbrauchsgebühren im Vergleich zu festen Nutzungsstufen darstellt.",
      "answerMarkdown": "So würde ich das positionieren: Führe mit **planbarem Wachstum statt Strafgebühren** -\nKonkurrent X rahmt Nutzungspreise weiterhin über Straftarife, was eher nach\nAngst als nach Mehrwert klingt.\n\n- Die Überschrift auf den Wert der Kostenkontrolle ausrichten, nicht auf den Verbrauch\n- Ein Nebeneinander von „bezahle, was kaputtgeht\" und „bezahle, was wächst\" zeigen\n- Mit einem Kundenzitat zu Expansionsumsatz abschließen, nicht mit Verlängerungsangst\n\nSoll ich daraus ein vollständiges One-Pager für das Sales-Team machen?"
    }
  },
  "setup": {
    "stepList": "Einrichtungsfortschritt",
    "stepOf": "Schritt {number} von {total}",
    "stepDone": "Fertig",
    "founderLetter": {
      "title": "Die Reise beginnt",
      "greeting": "Hallo {name},",
      "greetingAnonymous": "Hallo,",
      "intro": "ich bin {name}, der Gründer von Raldo. {thanks}",
      "thanks": "Schön, dass Sie da sind. Danke.",
      "story": "Ich habe Raldo gebaut, um mein eigenes Problem zu lösen: jede Woche relevante Inhalte veröffentlichen, die neue Kunden bringen, ohne auszubrennen. Heute schreibt Raldo alle unsere Inhalte. Wenn Sie uns gefunden haben, hat es mindestens einmal funktioniert.",
      "plan": "Jetzt sind Sie dran. Bevor Raldo etwas für Sie tun kann, muss es Ihr Unternehmen und Ihre Branche verstehen. Dazu gehören Fakten über Ihre Marke, Ihre Wettbewerber und Ihre Kunden. {time} Raldo übernimmt die schwere Arbeit. Ihre Aufgabe ist das Urteil: Sagen Sie ihm, was falsch ist und was besser sein könnte. {care} Alles, was Raldo für Sie erstellt, baut auf diesem Fundament auf.",
      "time": "Planen Sie etwa 15 Minuten ein.",
      "care": "Bitte nehmen Sie sich dafür Zeit.",
      "closing": "Nochmals danke, und los geht's.",
      "ps": "{label} Wenn etwas nicht stimmt oder Sie einfach Hallo sagen möchten, schreiben Sie mir an {email}. Raldo ist KI, mein Postfach nicht. Ich lese und beantworte jede E-Mail selbst.",
      "psLabel": "PS",
      "start": "Einrichtung starten"
    },
    "steps": {
      "brandFacts": {
        "title": "Marken-Fakten",
        "heading": "Fakten über Ihre Marke",
        "description": "Was Ihr Unternehmen macht und für wen"
      },
      "competitors": {
        "title": "Wettbewerber",
        "description": "Die Firmen, mit denen Ihre Kunden Sie vergleichen"
      },
      "customerProfile": {
        "title": "Kundenprofil",
        "description": "Wer Ihre Kunden sind"
      },
      "strategy": {
        "title": "Content-Strategie",
        "description": "Der Plan hinter Ihren Inhalten"
      },
      "visualStyle": {
        "title": "Visueller Stil",
        "description": "Wie Ihre Beiträge aussehen"
      }
    },
    "common": {
      "retry": "Erneut versuchen",
      "edit": "Bearbeiten",
      "edited": "Bearbeitet",
      "sources": {
        "pages": "{count} Seite | {count} Seiten",
        "readFrom": "Raldo hat das gelesen auf"
      },
      "runErrors": {
        "generic": "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
        "timedOut": "Das Lesen hat zu lange gedauert. Versuchen Sie es erneut."
      },
      "saved": "Gespeichert"
    },
    "errors": {
      "startFailed": "Wir konnten das Lesen nicht starten",
      "confirmFailed": "Wir konnten diesen Schritt nicht speichern"
    },
    "locked": {
      "change": "Ändern",
      "laterStepRunning": "Raldo arbeitet noch an einem späteren Schritt. Versuchen Sie es noch einmal, wenn er fertig ist.",
      "brandFacts": {
        "title": "Sie haben Ihre Marken-Fakten bestätigt",
        "body": "Raldo hat damit Ihre Wettbewerber gefunden und Ihr Kundenprofil und Ihre Content-Strategie erstellt.",
        "alertTitle": "Marken-Fakten ändern?",
        "alertBody": "Raldo sucht Ihre Wettbewerber noch einmal mit den Fakten, die Sie bestätigen. Danach erstellt Raldo Ihr Kundenprofil und Ihre Content-Strategie neu. Die neuen Fassungen ersetzen die gespeicherten, und Ihre Änderungen in diesen Schritten gehen verloren. Danach bestätigen Sie Ihren visuellen Stil erneut.",
        "alertConfirm": "Marken-Fakten ändern"
      },
      "competitors": {
        "title": "Sie haben diese Wettbewerber bestätigt",
        "body": "Raldo hat sie für Ihr Kundenprofil und Ihre Content-Strategie genutzt.",
        "alertTitle": "Wettbewerber ändern?",
        "alertBody": "Raldo liest die Unternehmen, die Sie auswählen. Danach erstellt Raldo Ihr Kundenprofil und Ihre Content-Strategie neu. Die neuen Fassungen ersetzen die gespeicherten, und Ihre Änderungen in diesen Schritten gehen verloren. Danach bestätigen Sie Ihren visuellen Stil erneut.",
        "alertConfirm": "Wettbewerber ändern"
      },
      "customerProfile": {
        "title": "Sie haben Ihr Kundenprofil bestätigt",
        "body": "Raldo hat es für Ihre Content-Strategie genutzt.",
        "alertTitle": "Kundenprofil ändern?",
        "alertBody": "Raldo erstellt Ihre Content-Strategie neu aus dem Profil, das Sie bestätigen. Die neue Fassung ersetzt die gespeicherte, und Ihre Änderungen dort gehen verloren. Danach bestätigen Sie Ihren visuellen Stil erneut.",
        "alertConfirm": "Kundenprofil ändern"
      },
      "strategy": {
        "title": "Sie haben Ihre Content-Strategie bestätigt",
        "body": "Raldo nutzt sie für alles, was es für Sie schreibt.",
        "alertTitle": "Ihre Content-Strategie ändern?",
        "alertBody": "Nachdem Sie die neue Strategie bestätigt haben, bestätigen Sie Ihren visuellen Stil erneut.",
        "alertConfirm": "Content-Strategie ändern"
      },
      "visualStyle": {
        "title": "Sie haben Ihren visuellen Stil bestätigt",
        "body": "Raldo nutzt ihn für das Aussehen Ihrer Beiträge."
      }
    },
    "loadFailed": {
      "title": "Wir konnten Ihre Einrichtung nicht laden",
      "line": "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut."
    },
    "ring": {
      "progress": "{done} von {total} Seiten gelesen"
    },
    "brandFacts": {
      "links": {
        "subtitle": "Fangen wir ganz vorne an.",
        "website": {
          "label": "Website",
          "hint": "Geben Sie die Startseite Ihres Unternehmens für Kunden ein.",
          "placeholder": "https://ihrefirma.de"
        },
        "linkedIn": {
          "label": "LinkedIn-Unternehmensseite",
          "hint": "Der Link oben auf der LinkedIn-Seite Ihres Unternehmens, wenn Sie \"Als Mitglied anzeigen\" wählen. Nur Unternehmensseiten funktionieren.",
          "placeholder": "https://linkedin.com/company/ihrefirma"
        },
        "submit": "Meine Seiten lesen",
        "next": "Weiter",
        "websiteError": "Geben Sie eine Webadresse ein, wie ihrefirma.de.",
        "linkedInAddressError": "Geben Sie eine Webadresse ein, wie linkedin.com/company/ihrefirma.",
        "linkedInError": "Das ist ein persönliches Profil. Geben Sie Ihre Unternehmensseite ein. Sie beginnt mit linkedin.com/company/.",
        "editTitle": "Links bearbeiten",
        "editHint": "Raldo liest deine Seiten erneut und aktualisiert die Übersicht."
      },
      "reading": {
        "title": "Ihre Seiten werden gelesen",
        "ghost": "Wird gelesen",
        "stages": {
          "website": "Deine Website wird gelesen",
          "look": "Ihr Logo und Ihr Schreibstil werden gelesen",
          "extract": "Die Fakten werden geschrieben"
        },
        "failedTitle": "Wir konnten Ihre Seiten nicht lesen",
        "errors": {
          "websiteReadFailed": "Wir konnten deine Website nicht lesen. Prüf den Link und versuch es noch einmal.",
          "noPages": "Wir haben keine Seiten gefunden. Prüfen Sie Ihren Website-Link.",
          "extractionFailed": "Wir konnten die Fakten nicht schreiben. Versuchen Sie es erneut.",
          "enqueueFailed": "Wir konnten nicht starten. Versuchen Sie es erneut.",
          "readFailed": "Prüfen Sie Ihre beiden Links und versuchen Sie es erneut."
        }
      },
      "sheet": {
        "readAgain": "Erneut lesen",
        "confirm": "Bestätigen",
        "ghost": {
          "region": "Land oder Region hinzufügen",
          "people": "Person hinzufügen",
          "text": "Nicht auf Ihren Seiten.",
          "textAction": "In einem Satz schreiben"
        },
        "regionCountries": "{count} Land | {count} Länder",
        "moreCountries": "und {count} weitere"
      },
      "summary": {
        "colours": "Markenfarben",
        "dialogTitle": "Zusammenfassung bearbeiten",
        "lookTitle": "Logo, Farben und Schrift",
        "changeLater": "Sie können das später unter {section}, {page} ändern.",
        "voiceTitle": "Ihr Schreibstil",
        "openPage": "{page} öffnen",
        "voiceMissing": "Raldo konnte das nicht von Ihrer Website lesen. Bitten Sie Raldo unter {section}, {page}, es erneut zu versuchen."
      },
      "dialog": {
        "addPerson": "Person hinzufügen",
        "remove": "Entfernen",
        "name": "Name",
        "role": "Rolle",
        "regionLabel": "Region",
        "regionHint": "Geben Sie ein Land oder eine Region ein. Eine Region zählt als jedes Land darin.",
        "regionPlaceholder": "Land oder Region eingeben",
        "regionEmpty": "Kein Land und keine Region passt dazu.",
        "regions": "Regionen",
        "countries": "Länder",
        "inRegion": "in {region}",
        "nameRequired": "Geben Sie einen Namen ein."
      },
      "runInProgress": "Raldo liest Ihre Seiten bereits. Warten Sie, bis der Vorgang endet.",
      "rows": {
        "brandInCategory": {
          "name": "Marke in der Kategorie",
          "hint": "Was du bist, in einem Satz. Raldo übernimmt ihn Wort für Wort.",
          "editTitle": "Marke in der Kategorie bearbeiten"
        },
        "category": {
          "name": "Kategorie",
          "hint": "Die Worte, die Kunden bei der Suche nutzen",
          "editTitle": "Kategorie bearbeiten"
        },
        "problemItSolves": {
          "name": "Gelöstes Problem",
          "hint": "Das Problem, das Ihre Website nennt",
          "editTitle": "Gelöstes Problem bearbeiten"
        },
        "targetCustomer": {
          "name": "Zielkunde",
          "hint": "Die Kundentypen, die Ihre Website nennt",
          "editTitle": "Zielkunde bearbeiten"
        },
        "categoryDefinition": {
          "name": "Definition der Kategorie",
          "hint": "Der Satz, der deine Kategorie definiert",
          "editTitle": "Definition der Kategorie bearbeiten"
        },
        "approach": {
          "name": "Vorgehen",
          "hint": "Wie du es machst, und die Idee hinter diesem Weg",
          "editTitle": "Vorgehen bearbeiten"
        },
        "region": {
          "name": "Region",
          "hint": "Die Länder, die Sie bedienen",
          "editTitle": "Region bearbeiten"
        },
        "people": {
          "name": "Personen",
          "hint": "Gründer und Teammitglieder auf Ihren Seiten",
          "editTitle": "Personen bearbeiten"
        }
      },
      "noRole": "Noch keine Rolle"
    },
    "competitors": {
      "known": {
        "subtitle": "Gegen wen trittst du an?",
        "lead": "Als Nächstes sucht Raldo deine Wettbewerber. Fallen dir ein oder zwei Namen ein? Oder lass Raldo suchen.",
        "namedTitle": "Ich kenne ein paar",
        "namedCaption": "Füge ein oder zwei hinzu. Raldo sucht weitere wie sie.",
        "searchTitle": "Raldo suchen lassen",
        "searchCaption": "Raldo startet mit deinen Markenfakten. Du musst nichts vorbereiten."
      },
      "name": {
        "addLabel": "Wer fällt dir ein?",
        "addHint": "Ein oder zwei reichen.",
        "start": "Weitere wie diese finden"
      },
      "finding": {
        "errors": {
          "enqueueFailed": "Wir konnten die Suche nicht starten. Versuchen Sie es erneut.",
          "discoveryFailed": "Wir konnten keine ähnlichen Firmen finden. Versuchen Sie es erneut.",
          "timedOut": "Die Suche hat zu lange gedauert. Versuchen Sie es erneut.",
          "startFailed": "Wir konnten die Suche nicht starten. Versuchen Sie es erneut."
        },
        "title": "Wir suchen Ihre Wettbewerber",
        "failedTitle": "Wir konnten Ihre Wettbewerber nicht finden",
        "stages": {
          "snapshot": "Wir lesen, wofür du bereits rankst",
          "similar": "Wir sehen uns ähnliche Firmen an",
          "search": "Wir durchsuchen Ihre Branche",
          "rank": "Wir sortieren die Ergebnisse"
        },
        "lists": {
          "similar": "Ähnliche Firmen",
          "samePages": "Websites wie Ihre",
          "comparisonPages": "Vergleichsseiten",
          "searchRivals": "Konkurrenz in der Suche",
          "namedRivals": "Konkurrenz Ihrer genannten Firmen"
        },
        "found": "Noch keine Firmen gefunden | {count} Firma gefunden | {count} Firmen gefunden"
      },
      "review": {
        "title": "Deine Wettbewerber",
        "lead": "Wir haben {count} Firmen gefunden und danach sortiert, wie nah sie dir sind. Die {max} nächsten haben wir angehakt. Wähle bis zu {max}.",
        "leadNamed": "Wir haben {count} Firmen gefunden und danach sortiert, wie nah sie dir sind. Die {named}, die du genannt hast, haben wir angehakt. Wähle bis zu {max}.",
        "groups": {
          "direct": {
            "title": "Nächste Wettbewerber",
            "description": "Sie verkaufen dasselbe an dieselben Kunden."
          },
          "alternative": {
            "title": "Andere Wege",
            "description": "Deine Kunden können damit dieselbe Aufgabe auf andere Art lösen."
          },
          "notRelevant": {
            "title": "Auch gefunden",
            "description": "Wir halten diese Firmen nicht für Wettbewerber. Öffne die Liste, wenn wir uns irren."
          }
        },
        "pickName": "{name} wählen",
        "picked": "{count} von {max} gewählt",
        "picks": {
          "title": "Deine Auswahl",
          "empty": "Hake oben Firmen an oder füge unten eine hinzu.",
          "full": "Du hast {max} von {max} gewählt. Entferne oben eine, um eine andere hinzuzufügen.",
          "remove": "{name} entfernen"
        },
        "added": "{name} hinzugefügt und gewählt.",
        "ticked": "{name} stand schon unter „{group}“. Sie ist jetzt gewählt.",
        "addLabel": "Fehlt eine Firma? Füge sie hinzu",
        "addHint": "Eine Firma, die du hinzufügst, wird für dich angehakt.",
        "empty": "Keine Firmen gefunden. Füge unten mindestens eine hinzu.",
        "confirm": "Bestätigen",
        "sharesKeywords": "Rankt für {count} deiner Keywords"
      }
    },
    "customerProfile": {
      "reading": {
        "title": "Wir schreiben Ihr Kundenprofil",
        "failedTitle": "Wir konnten Ihr Kundenprofil nicht schreiben",
        "detail": "Aus Ihren Markenfakten und Wettbewerbern",
        "ghost": "Wird geschrieben",
        "errors": {
          "enqueueFailed": "Wir konnten das Profil nicht starten. Versuchen Sie es erneut.",
          "draftFailed": "Wir konnten Ihr Kundenprofil nicht schreiben. Versuchen Sie es erneut.",
          "factsMissing": "Wir brauchen zuerst Ihre Markenfakten und Wettbewerber. Prüfen Sie sie und versuchen Sie es erneut.",
          "timedOut": "Das Profil hat zu lange gedauert. Versuchen Sie es erneut.",
          "startFailed": "Wir konnten das Profil nicht starten. Versuchen Sie es erneut."
        }
      },
      "profile": {
        "title": "Ihr Kunde",
        "subtitle": "Die eine Person, die das Problem spürt und die Kaufentscheidung trifft",
        "writeAgain": "Neu schreiben",
        "confirm": "Bestätigen",
        "editSummary": "Zusammenfassung bearbeiten",
        "untitled": "Ihr Kunde"
      },
      "job": {
        "title": "Die Aufgabe, für die sie Hilfe suchen",
        "progress": "Was sie wollen",
        "goal": "Ihr Ziel",
        "stories": "Wann es zählt",
        "when": "Wenn",
        "want": "wollen sie",
        "soThat": "damit",
        "editStory": "Diese Geschichte bearbeiten"
      },
      "cards": {
        "tried": {
          "title": "Was sie heute nutzen",
          "hint": "Was Kunden vorher genutzt haben",
          "editTitle": "Bearbeiten, was sie versucht haben"
        },
        "blockers": {
          "title": "Was sie zurückhält",
          "hint": "Was Kunden Sorgen macht oder zögern lässt",
          "editTitle": "Bearbeiten, was sie fürchten"
        }
      },
      "card": {
        "lines": "Zeilen",
        "addLine": "Zeile hinzufügen",
        "add": "Hinzufügen",
        "removeLine": "{label} entfernen",
        "lineTooLong": "Eine Zeile ist zu lang. Entfernen Sie sie und fügen Sie eine kürzere hinzu."
      },
      "summaryDialog": {
        "title": "Zusammenfassung bearbeiten",
        "hint": "Der Titel, die Unternehmensgröße und die Zusammenfassung",
        "titleLabel": "Titel",
        "companySizeLabel": "Unternehmensgröße",
        "summaryLabel": "Zusammenfassung",
        "writeAgain": "Neu schreiben"
      },
      "companySize": {
        "solo": "Nur ich",
        "upTo10": "2 bis 10 Personen",
        "upTo50": "11 bis 50 Personen",
        "upTo200": "51 bis 200 Personen",
        "upTo1000": "201 bis 1.000 Personen",
        "over1000": "Über 1.000 Personen"
      },
      "errors": {
        "writeSummaryFailed": "Wir konnten keine neue Zusammenfassung schreiben"
      },
      "limits": {
        "tooLong": "Höchstens {max} Zeichen."
      },
      "refusals": {
        "labelTooLong": "Eine Zeile ist zu lang. Kürzen Sie sie.",
        "labelRequired": "Eine Zeile ist leer. Schreiben Sie etwas hinein oder entfernen Sie sie.",
        "triedTooMany": "Was sie heute nutzen hat höchstens 4 Zeilen. Entfernen Sie zuerst eine.",
        "titleTooLong": "Der Titel ist zu lang. Kürzen Sie ihn.",
        "summaryTooLong": "Die Zusammenfassung ist zu lang. Kürzen Sie sie.",
        "rowsEmpty": "Alle Karten sind leer. Fügen Sie zuerst einer Karte eine Zeile hinzu.",
        "runInProgress": "Raldo schreibt noch Ihr Kundenprofil. Warten Sie, bis es fertig ist.",
        "factsMissing": "Bestätigen Sie zuerst Ihre Markenfakten.",
        "competitorsMissing": "Fügen Sie zuerst Ihre Wettbewerber hinzu.",
        "ownerAdminRequired": "Nur Inhaber oder Admins können das tun.",
        "editorRequired": "Ihre Rolle darf diese Marke lesen, aber nicht ändern."
      }
    },
    "contentStrategy": {
      "reading": {
        "title": "Raldo schreibt deine Content-Strategie",
        "failedTitle": "Raldo konnte deine Content-Strategie nicht schreiben",
        "questions": "{done} von {total} Fragen",
        "writing": "Raldo schreibt",
        "stages": {
          "awareness": "Raldo schreibt, was sie über das Problem glauben müssen",
          "consideration": "Raldo schreibt, was sie über ihre Optionen glauben müssen",
          "decision": "Raldo schreibt, was sie über dich glauben müssen",
          "core": "Raldo schreibt deine Kernbotschaft"
        },
        "chips": {
          "awareness": "Das Problem",
          "consideration": "Die Optionen",
          "decision": "Warum du",
          "core": "Kernbotschaft"
        },
        "errors": {
          "enqueueFailed": "Raldo konnte nicht mit dem Schreiben beginnen. Versuch es erneut.",
          "draftFailed": "Raldo konnte deine Content-Strategie nicht schreiben. Versuch es erneut.",
          "profileMissing": "Bestätige zuerst dein Kundenprofil. Versuch es dann erneut.",
          "factsMissing": "Bestätige zuerst deine Markenfakten. Versuch es dann erneut.",
          "timedOut": "Das Schreiben hat zu lange gedauert. Versuch es erneut.",
          "startFailed": "Raldo konnte nicht mit dem Schreiben beginnen. Versuch es erneut."
        }
      },
      "refusals": {
        "runInProgress": "Raldo schreibt deine Content-Strategie noch. Warte, bis Raldo fertig ist.",
        "profileMissing": "Bestätige zuerst dein Kundenprofil.",
        "beliefMapMissing": "Raldo hat deine Ziele noch nicht geschrieben.",
        "coreMessageMissing": "Schreib zuerst deine Kernbotschaft.",
        "strategyMissing": "Raldo hat deine Content-Strategie noch nicht geschrieben.",
        "replacesTooLong": "Was sie heute denken, darf höchstens 500 Zeichen haben.",
        "ownerAdminRequired": "Nur Inhaber oder Admins können das tun.",
        "editorRequired": "Deine Rolle darf diese Marke lesen, aber nicht ändern."
      },
      "writeAgain": {
        "title": "Noch einmal schreiben?",
        "body": "Raldo schreibt deine Content-Strategie noch einmal. Der neue Text ersetzt den Text, den du nicht geändert hast.",
        "confirm": "Noch einmal schreiben"
      },
      "page": {
        "title": "Deine Content-Strategie",
        "writeAgain": "Noch einmal schreiben",
        "confirm": "Bestätigen",
        "info": {
          "title": "Deine Content-Strategie legt das Ziel jedes Inhalts fest, den Raldo entwirft.",
          "body": "Bevor Käufer dich wählen, müssen sie einige Dinge glauben: dass ihr Problem echt ist, dass die üblichen Lösungen nicht reichen und dass die Wahl für dich sicher ist. Raldo macht aus jedem dieser Punkte ein Argument und gibt jedem Inhalt ein Argument. Jeder Inhalt spricht einen Leser an: deinen Zielkunden, in einer Phase seines Wegs, vom ersten Bemerken des Problems bis zur Entscheidung."
        }
      },
      "coreMessage": {
        "title": "Die Kernbotschaft hinter deinem Content",
        "caption": "Was Interessenten glauben müssen, um bei dir zu kaufen",
        "edit": "Kernbotschaft bearbeiten",
        "empty": "Raldo konnte deine Kernbotschaft noch nicht schreiben.",
        "write": "Schreib sie",
        "yours": "Deine Kernbotschaft"
      },
      "stages": {
        "awareness": {
          "objective": "Hilf ihnen, das Problem zu verstehen",
          "note": "Dein Content erklärt das Problem in ihren Worten und warum es wichtig ist, ohne zu verkaufen."
        },
        "consideration": {
          "objective": "Hilf ihnen, ihre Optionen abzuwägen",
          "note": "Dein Content hilft ihnen, ihre Optionen zu vergleichen und zu sehen, wo dein Ansatz passt."
        },
        "decision": {
          "objective": "Hilf ihnen, sicher zu wählen",
          "note": "Dein Content erklärt, wie du arbeitest, was sie bekommen und was nach dem Kauf passiert."
        }
      },
      "stage": {
        "heading": "{phase} · {objective}",
        "asks": "Sie fragen: {question} {note}",
        "compareWith": "Sie vergleichen dich mit"
      },
      "formats": {
        "howTo": "Anleitung",
        "research": "Studien und Daten",
        "pointOfView": "Standpunkt",
        "comparison": "Vergleich",
        "customerStory": "Kundengeschichte",
        "productExplainer": "Produkterklärung",
        "objection": "Antwort auf Einwand",
        "pricing": "Preise erklärt",
        "ourStory": "Unsere Geschichte"
      },
      "subjects": {
        "problem": "Das Problem",
        "prevalence": "Wie verbreitet es ist",
        "cost": "Warum es wichtig ist",
        "options": "Die anderen Optionen",
        "ourOption": "Dein Weg",
        "fit": "Passt es zu ihnen",
        "brand": "Dein Unternehmen",
        "offer": "Dein Angebot",
        "afterPurchase": "Nach dem Kauf"
      },
      "ledger": {
        "thinks": "Was sie heute denken",
        "tells": "Was dein Content ihnen sagt",
        "quoted": "„{quote}“",
        "edit": "Dieses Ziel bearbeiten: {subject}"
      },
      "end": {
        "title": "Bereit zu entscheiden",
        "body": "Sie haben alles, um dich in Betracht zu ziehen"
      },
      "objectiveDialog": {
        "title": "Dieses Ziel bearbeiten",
        "eyebrow": "{phase} · {subject}"
      },
      "coreMessageDialog": {
        "title": "Kernbotschaft bearbeiten",
        "description": "Ein Satz, den ein Käufer glauben muss, bevor er dich wählt. Nenn dein Unternehmen einmal, höchstens {max} Wörter.",
        "words": "{count} / {max} Wörter"
      }
    },
    "visualStyle": {
      "choice": {
        "title": "Visueller Stil",
        "lead": "Jetzt legen Sie das Aussehen Ihrer Marke für Social-Media-Beiträge fest. Haben Sie Designs, an denen man Sie erkennt? Oder wählen Sie eine Vorlage aus der Bibliothek von Raldo.",
        "ownTitle": "Ich habe eigene Designs",
        "ownCaption": "Laden Sie ein paar Bilder hoch. Raldo macht daraus ein Design für alle Inhalte.",
        "templatesTitle": "Vorlagen zeigen",
        "templatesCaption": "Wählen Sie eine Vorlage und passen Sie sie an Ihren Stil an."
      },
      "templates": {
        "title": "Vorlage wählen",
        "lead": "Jede Vorlage ist ein vollständiger Satz Folien für Ihre Karussells. Wir zeigen sie in Ihren Farben, mit Ihrem Logo.",
        "kitLabel": "Ihr Marken-Kit",
        "kit": {
          "logo": "Logo",
          "logoMark": "Bildmarke",
          "colours": "Farben",
          "font": "Schrift",
          "fontNotSet": "Nicht festgelegt",
          "editLogo": "Logo bearbeiten",
          "editLogoMark": "Bildmarke bearbeiten",
          "editColours": "Farben bearbeiten",
          "editFont": "Schrift bearbeiten"
        },
        "colourMode": "Gezeigte Farben",
        "modeBrand": "Ihre Farben",
        "modeTemplate": "Farben der Vorlage",
        "filterLabel": "Vorlagen filtern",
        "filterAll": "Alle",
        "filterLight": "Hell",
        "filterDark": "Dunkel",
        "ownTitle": "Ihre eigenen Designs",
        "ownCaption": "Ziehen Sie ein paar Beiträge hierher oder klicken Sie zum Hochladen",
        "cover": "Vorlage {name}",
        "failed": "Raldo konnte die Vorlagen nicht laden. Versuchen Sie es erneut."
      },
      "template": {
        "accent": "Akzentfarbe",
        "accentFirst": "Ihre erste Farbe",
        "fonts": "Schriften",
        "fontsLabel": "Schriften der Vorlage",
        "later": "Sie können die Vorlage später unter Stil ändern.",
        "allTemplates": "Alle Vorlagen",
        "use": "Diese Vorlage nutzen"
      },
      "own": {
        "title": "Ihre eigenen Designs",
        "lead": "Fügen Sie Beiträge oder Folien hinzu, die Ihnen gefallen. Raldo baut daraus eine Vorlage mit jedem Folientyp, den Ihre Beiträge brauchen.",
        "uploadTitle": "Ihre Designs",
        "uploadCount": "{count} hinzugefügt",
        "add": "Hinzufügen",
        "design": "Design {n}",
        "noticeTitle": "Raldo baut Ihre Vorlage nach der Einrichtung",
        "notice": "Wir sagen Ihnen Bescheid, wenn sie fertig ist.",
        "back": "Zurück",
        "finish": "Einrichtung abschließen"
      },
      "errors": {
        "strategyMissing": "Bestätigen Sie zuerst Ihre Content-Strategie.",
        "designsMissing": "Einige Ihrer Designs sind nicht mehr in Ihrer Mediathek. Fügen Sie sie erneut hinzu.",
        "roleRequired": "Nur ein Owner oder Admin kann diesen Schritt bestätigen."
      }
    }
  },
  "tour": {
    "basics": {
      "composer": {
        "title": "Frag nach der Arbeit, nicht nach dem Tool",
        "body": "Sag \"plane nächste Woche\" oder \"recherchiere einen Wettbewerber\", und ich mache es. Ich schreibe selbst in dein Board, deine Designs und deine Marke."
      },
      "nav": {
        "title": "Wo meine Arbeit landet",
        "body": "In Chat, Posteingang, Board und Sichtbarkeit arbeitest du. Unter Content findest du deine Seiten, Beiträge, Strategie und Medien. Marke ist, was ich über dich weiß: Profil, Stil, Wettbewerber und Wissen. Daraus schreibe ich alles."
      },
      "dock": {
        "title": "Ich lese den Bildschirm, auf dem du bist",
        "body": "Öffne mich überall mit Cmd oder Strg und J. Ich sehe den Beitrag oder das Diagramm vor dir, \"schreib das um\" reicht also."
      },
      "hub": {
        "title": "Mehr davon, wenn du magst",
        "body": "Jede Tour liegt hier bereit, und du kannst die Tipps ganz abschalten."
      }
    },
    "content": {
      "board": {
        "title": "Rechtsklick ist die Abkürzung",
        "body": "Planen, sofort veröffentlichen, duplizieren und löschen stehen in diesem Menü. Ein einfacher Klick öffnet den Beitrag nur kurz neben mir."
      },
      "plan": {
        "title": "Ich fülle den ganzen Zeitraum",
        "body": "Gib mir einen Zeitraum, und ich plane für jeden deiner Posting-Tage einen Beitrag aus deinen Argumenten und Themen und schreibe dann die Entwürfe. Der Canvas öffnet sich, damit du sie nebeneinander ankommen siehst."
      }
    },
    "brand": {
      "foundation": {
        "title": "Woraus ich schreibe",
        "body": "Unter Profil stehen deine Marken-Fakten und der Kunde, für den du schreibst. Änderst du eines davon, folgt alles, was ich danach schreibe."
      },
      "style": {
        "title": "Wie es klingt und aussieht",
        "body": "Stimme bestimmt, wie deine Beiträge klingen, Visueller Stil, wie deine Designs aussehen. Beides lese ich beim Einrichten von deiner Website, und jeder Entwurf folgt ihnen."
      }
    },
    "controls": {
      "next": "Weiter",
      "back": "Zurück",
      "skip": "Überspringen",
      "done": "Fertig",
      "gotIt": "Alles klar",
      "close": "Tipp schließen",
      "step": "Schritt {index} von {total}"
    },
    "handoff": {
      "title": "Lust auf eine kurze Tour?",
      "body": "Vier kurze Stopps: das Eingabefeld, die Navigation, das Chat-Dock und dieser Hub.",
      "accept": "Zeig es mir",
      "decline": "Nicht jetzt"
    },
    "hub": {
      "label": "Zeig es mir",
      "title": "{done} von {total} Touren gesehen",
      "replay": "Wiederholen",
      "start": "Starten",
      "turnOff": "Tipps ausschalten",
      "turnOn": "Tipps einschalten",
      "allSeen": "Du hast alle Touren gesehen.",
      "tours": {
        "basics": "Die Grundlagen",
        "content": "Content",
        "brand": "Marke"
      }
    }
  },
  "editor": {
    "shell": {
      "closeEditor": "Editor schließen",
      "designName": "Designname",
      "save": "Speichern",
      "saving": "Wird gespeichert",
      "exportPng": "PNG exportieren"
    },
    "canvas": {
      "region": "Canvas",
      "zoomOut": "Verkleinern",
      "zoomIn": "Vergrößern",
      "zoomToFit": "An Ansicht anpassen",
      "resetZoom": "Zoom auf 100 Prozent zurücksetzen",
      "selectNamed": "{name} auswählen",
      "selectItem": "Element auswählen"
    },
    "export": {
      "exporting": "Wird exportiert…"
    },
    "border": {
      "title": "Rahmen",
      "selectShape": "Wähle eine Form oder einen Text aus, um einen Rahmen hinzuzufügen.",
      "add": "Rahmen hinzufügen",
      "color": "Rahmenfarbe",
      "width": "Rahmenbreite",
      "remove": "Rahmen entfernen"
    },
    "color": {
      "fill": "Füllfarbe",
      "fillOpacity": "Deckkraft der Fläche",
      "text": "Textfarbe",
      "background": "Hintergrundfarbe",
      "noColor": "Diese Ebene hat keine Farbe zum Bearbeiten.",
      "none": "Keine Farbe",
      "custom": "Eigene",
      "customAria": "Eigene Farbe",
      "back": "Zurück",
      "inThisDesign": "In diesem Design",
      "colorPalette": "Farbpalette",
      "defaultColors": "Standardfarben",
      "defaultGradients": "Standard-Verläufe",
      "seeAll": "Alle ansehen",
      "solid": "Volltonfarbe",
      "gradient": "Verlauf",
      "paintType": "Farbart",
      "gradientColors": "Verlaufsfarben",
      "style": "Stil",
      "addColor": "Farbe hinzufügen",
      "removeColor": "Farbe {number} entfernen",
      "colorNumber": "Farbe {number}",
      "styleLinear90": "90°",
      "styleLinear180": "180°",
      "styleLinear135": "135°",
      "styleRadialCenter": "Mitte",
      "styleRadialCorner": "Ecke",
      "groupCool": "Kühle Töne",
      "groupWarm": "Warme Töne",
      "groupMonochromatic": "Monochrom",
      "groupAll": "Alle Verläufe",
      "applyGradient": "Verlauf {number}"
    },
    "common": {
      "advanced": "Erweitert"
    },
    "editImage": {
      "title": "Bild bearbeiten",
      "selectImage": "Wähle ein Bild aus",
      "selectImageHint": "Anpassungen, Formmaske und Zuschnitt gelten für ein ausgewähltes Bild.",
      "replace": "Ersetzen",
      "replaceWith": "Ersetzen durch",
      "sectionsAria": "Bereiche zur Bildbearbeitung",
      "tabAdjust": "Anpassen",
      "tabFrame": "Formmaske",
      "adjustments": "Anpassungen",
      "brightness": "Helligkeit",
      "contrast": "Kontrast",
      "frame": "Formmaske",
      "frameShapeAria": "Formmaske",
      "frameNone": "Kein Rahmen",
      "frameCircle": "Kreis",
      "frameRounded": "Abgerundet",
      "frameTriangle": "Dreieck",
      "crop": "Zuschneiden",
      "cropAspectRatioAria": "Seitenverhältnis des Zuschnitts",
      "cropTo": "Auf {preset} zuschneiden"
    },
    "library": {
      "heading": "Deine Bibliothek",
      "uploadImage": "Bild hochladen",
      "upload": "Hochladen",
      "loading": "Deine Bibliothek wird geladen",
      "empty": "Noch keine Bilder"
    },
    "action": {
      "cut": "Ausschneiden",
      "copy": "Kopieren",
      "paste": "Einfügen",
      "duplicate": "Duplizieren",
      "duplicateShortcut": "Duplizieren (⌘D)",
      "deleteShortcut": "Löschen (⌫)",
      "bringToFront": "In den Vordergrund",
      "bringForward": "Eine Ebene nach vorne",
      "sendBackward": "Eine Ebene nach hinten",
      "sendToBack": "In den Hintergrund",
      "group": "Gruppieren",
      "ungroup": "Gruppierung aufheben",
      "layerActionsAria": "Ebenenaktionen"
    },
    "toolbar": {
      "askRaldo": "Raldo dazu fragen",
      "title": "Editor-Werkzeuge",
      "layerSelected": "Eine Ebene ist ausgewählt",
      "noSelection": "Keine Auswahl",
      "undo": "Rückgängig",
      "undoShortcut": "Rückgängig (⌘Z)",
      "redo": "Wiederholen",
      "redoShortcut": "Wiederholen (⇧⌘Z)",
      "addImage": "Bild hinzufügen",
      "addText": "Text hinzufügen",
      "addShape": "Form hinzufügen",
      "addFrame": "Rahmen hinzufügen",
      "rectangle": "Rechteck",
      "ellipse": "Ellipse",
      "add": "Hinzufügen",
      "lock": "Sperren",
      "unlock": "Entsperren",
      "transparency": "Transparenz",
      "label": "Label",
      "transparentGround": "Keine Füllung",
      "clipContents": "Inhalt beschneiden"
    },
    "layout": {
      "title": "Auto-Layout",
      "selectFrame": "Wähle einen Rahmen, um seinen Inhalt anzuordnen.",
      "explainer": "Ein Rahmen mit Auto-Layout ordnet seinen Inhalt selbst an. Längerer Text schiebt das Folgende nach unten, statt darunter zu laufen.",
      "enable": "Auto-Layout hinzufügen",
      "disable": "Auto-Layout entfernen",
      "direction": "Richtung",
      "column": "Spalte",
      "row": "Reihe",
      "align": "Ausrichtung",
      "alignStart": "Anfang",
      "alignCenter": "Mitte",
      "alignEnd": "Ende",
      "gap": "Abstand",
      "padding": "Innenabstand",
      "paddingTop": "Oben",
      "paddingRight": "Rechts",
      "paddingBottom": "Unten",
      "paddingLeft": "Links",
      "linkPadding": "Alle Seiten verknüpfen",
      "unlinkPadding": "Jede Seite einzeln festlegen",
      "justify": "Verteilung",
      "justifyStart": "Anfang",
      "justifyCenter": "Mitte",
      "justifyEnd": "Ende",
      "justifySpaceBetween": "Zwischenraum",
      "justifySpaceAround": "Außenraum",
      "justifySpaceEvenly": "Gleichmäßig",
      "wrap": "Umbruch",
      "positionOwnedByLayout": "Das Auto-Layout, das diese Ebene enthält, bestimmt ihre Position.",
      "sizingWidth": "Breite",
      "sizingHeight": "Höhe",
      "sizingFixed": "Fest",
      "sizingHug": "Anpassen",
      "sizingFill": "Ausfüllen",
      "escapeLayout": "Aus Layout nehmen",
      "escapeLayoutHint": "Nimm diese Ebene aus dem darüberliegenden Auto-Layout heraus. Sie behält ihre eigene Position, und das Layout ordnet sich an, als wäre sie nicht da.",
      "returnToLayoutHint": "Gib diese Ebene an das darüberliegende Auto-Layout zurück."
    },
    "properties": {
      "title": "Designeigenschaften",
      "show": "Eigenschaften anzeigen",
      "hide": "Eigenschaften ausblenden",
      "close": "Eigenschaften schließen",
      "contextText": "Text",
      "contextImage": "Bild",
      "contextShape": "Form",
      "contextFrame": "Rahmen",
      "contextPage": "Seite",
      "contextSelection": "Auswahl",
      "format": "Format",
      "artboardFormat": "Artboard-Format",
      "fontSize": "Schriftgröße",
      "bold": "Fett",
      "italic": "Kursiv",
      "fontFamily": "Schriftart",
      "alignLeft": "Linksbündig",
      "alignCenter": "Zentriert",
      "alignRight": "Rechtsbündig",
      "hugContents": "An Text anpassen",
      "textEffects": "Texteffekte",
      "effects": "Effekte",
      "labelForRaldo": "Label für Raldo",
      "cornerRounding": "Eckenrundung",
      "position": "Position",
      "opacity": "Deckkraft",
      "editingShared": "Du bearbeitest die gemeinsamen Eigenschaften von 1 Ebene. | Du bearbeitest die gemeinsamen Eigenschaften von {count} Ebenen."
    },
    "position": {
      "sectionAria": "Abschnitt des Positionspanels",
      "arrange": "Anordnen",
      "layers": "Ebenen",
      "forward": "Nach vorne",
      "backward": "Nach hinten",
      "toFront": "Ganz nach vorne",
      "toBack": "Ganz nach hinten",
      "alignToPage": "An Seite ausrichten",
      "top": "Oben",
      "left": "Links",
      "middle": "Mitte",
      "center": "Zentriert",
      "bottom": "Unten",
      "right": "Rechts",
      "sizeAndPosition": "Größe und Position",
      "w": "B",
      "h": "H",
      "x": "X",
      "y": "Y",
      "width": "Breite",
      "height": "Höhe",
      "positionX": "Position X",
      "positionY": "Position Y",
      "rotate": "Drehen",
      "rotationDegrees": "Drehung in Grad",
      "lockRatio": "Seitenverhältnis sperren",
      "unlockRatio": "Seitenverhältnis entsperren",
      "selectionBoundsHint": "Grenzen der Auswahl. Verwende \"Ausrichten & Verteilen\", um mehrere Ebenen zu positionieren.",
      "selectLayerHint": "Wähle eine Ebene aus, um ihre Größe und Position zu bearbeiten.",
      "group": "Gruppieren",
      "distribute": "Verteilen",
      "horizontal": "Horizontal",
      "vertical": "Vertikal",
      "noLayers": "Noch keine Ebenen",
      "renameLayer": "Ebene umbenennen",
      "moveForward": "Ebene nach vorne verschieben",
      "moveBackward": "Ebene nach hinten verschieben",
      "toggleVisibility": "Sichtbarkeit der Ebene umschalten",
      "toggleLock": "Sperre der Ebene umschalten",
      "collapseLayer": "Ebene einklappen",
      "expandLayer": "Ebene ausklappen"
    },
    "opacity": {
      "selectLayer": "Wähle eine Ebene aus, um ihre Deckkraft anzupassen."
    },
    "page": {
      "sectionAria": "Abschnitt des Seitenpanels",
      "forRaldo": "Für Raldo",
      "textRaldoWrites": "Text, den Raldo schreibt",
      "picturesRaldoAsksFor": "Bilder, nach denen Raldo fragt",
      "notLabelled": "Ohne Label",
      "noSlots": "Auf dieser Seite ist noch nichts für Raldo gelabelt. Wähle eine Text- oder Bildebene aus und gib ihr ein Label.",
      "emptySlot": "Leer",
      "charLimit": "Limit: {count} Zeichen",
      "add": "Seite hinzufügen",
      "delete": "Seite löschen",
      "duplicate": "Seite duplizieren",
      "moveLeft": "Seite nach links",
      "moveRight": "Seite nach rechts"
    },
    "text": {
      "uppercase": "Großbuchstaben",
      "spacing": "Abstände",
      "letterSpacing": "Zeichenabstand",
      "lineSpacing": "Zeilenabstand",
      "anchor": "Textfeld verankern",
      "anchorTop": "Nach unten wachsen",
      "anchorMiddle": "Aus der Mitte wachsen",
      "anchorBottom": "Nach oben wachsen",
      "anchorHint": "Welche Kante bleibt, wenn der Text länger oder kürzer wird.",
      "selectText": "Wähle eine Textebene aus, um ihre Abstände zu setzen."
    },
    "background": {
      "title": "Hintergrund",
      "detach": "Lösen",
      "remove": "Hintergrund entfernen"
    },
    "panel": {
      "collapse": "Bereich einklappen",
      "expand": "Bereich ausklappen"
    },
    "textEffects": {
      "selectLayer": "Wähle eine Textebene aus",
      "selectLayerHint": "Texteffekte gelten für eine ausgewählte Textebene.",
      "addBackground": "Texthintergrund hinzufügen",
      "background": "Texthintergrund",
      "removeBackground": "Texthintergrund entfernen",
      "backgroundColor": "Hintergrundfarbe",
      "backgroundRoundness": "Rundung des Hintergrunds",
      "padding": "Innenabstand",
      "backgroundOpacity": "Deckkraft des Hintergrunds",
      "none": "Keine",
      "backgroundTile": "Hintergrund",
      "specimen": "Ag",
      "roundness": "Rundung",
      "opacity": "Deckkraft"
    },
    "nodeEffects": {
      "selectLayer": "Wähle eine Ebene",
      "selectLayerHint": "Effekte gelten für die ausgewählte Ebene.",
      "none": "Keiner",
      "shadowTile": "Schatten",
      "shadow": "Schatten",
      "distance": "Abstand",
      "direction": "Richtung",
      "softness": "Weichheit",
      "spread": "Ausbreitung",
      "shadowColor": "Schattenfarbe",
      "shadowOpacity": "Deckkraft des Schattens"
    },
    "insert": {
      "title": "Einfügen",
      "back": "Zurück",
      "tabsAria": "Was du einfügst",
      "scrollTabsPrev": "Nach links scrollen",
      "scrollTabsNext": "Nach rechts scrollen",
      "tabTemplates": "Vorlagen",
      "tabElements": "Elemente",
      "tabImages": "Bilder",
      "tabText": "Text",
      "tabShapes": "Formen",
      "kind": {
        "background": "Hintergründe",
        "shape": "Formen",
        "separator": "Trennlinien",
        "decoration": "Deko"
      },
      "noTemplates": "Noch keine Vorlagen.",
      "noElements": "Noch keine Elemente.",
      "applyTemplate": "Vorlage {name} auf diese Seite anwenden",
      "appendTemplate": "Vorlage {name} als neue Seite hinzufügen",
      "openTemplate": "Vorlage {name} öffnen",
      "applyAllPages": "Alle {count} Seiten anwenden",
      "applyTemplatePage": "Seite {number} auf diese Seite anwenden",
      "templateMeta": "{width} × {height} px · {count} Seiten",
      "templatePages": "{count} Seiten",
      "placeElement": "Element {name} hinzufügen",
      "addHeading": "Überschrift hinzufügen",
      "addSubheading": "Unterüberschrift hinzufügen",
      "shapesHint": "Ein Rahmen gruppiert, was du hineinlegst, und kann es für dich anordnen.",
      "elementSaved": "Als Element gespeichert.",
      "elementSaveFailed": "Das Element konnte nicht gespeichert werden.",
      "elementRenameFailed": "Das Element konnte nicht umbenannt werden.",
      "elementDeleteFailed": "Das Element konnte nicht gelöscht werden.",
      "saveAsElement": "Als Element speichern",
      "saveElementBody": "Sichere diese Auswahl, damit du sie in jedes Design ziehen kannst.",
      "elementName": "Name",
      "elementNamePlaceholder": "Blauer Schein",
      "elementKind": "Gruppe",
      "elementBleed": "Die ganze Seite füllen",
      "elementBleedHint": "Ein füllendes Element skaliert auf die Seite und landet hinter allem, was schon da ist."
    },
    "cornerRadius": {
      "selectLayer": "Wähle eine Form, ein Bild oder einen Rahmen aus, um die Eckenrundung anzupassen.",
      "value": "Wert der Eckenrundung"
    },
    "slotLabel": {
      "selectLayer": "Wähle eine Text- oder Bildebene aus",
      "selectLayerHint": "Labels sagen Raldo, wofür ein Feld steht und wie es befüllt werden soll.",
      "addLabel": "Label hinzufügen",
      "removeLabel": "Label entfernen",
      "role": "Rolle",
      "roleHint": "Kurzer Name in Kebab-Case, z. B. page-title",
      "limitLength": "Länge begrenzen",
      "maxLength": "Maximale Länge"
    },
    "generating": {
      "drafting": "Wird entworfen"
    },
    "conflict": {
      "title": "Dieses Design wurde anderswo geändert",
      "description": "Jemand anderes hat Änderungen an diesem Design gespeichert, nachdem du es geöffnet hast. Deine lokalen Änderungen sind noch da, aber erneutes Speichern schlägt weiter fehl, bis du neu lädst. Lade neu, um die aktuelle Version zu laden, oder arbeite weiter und lade neu, bevor du erneut speicherst.",
      "keepEditing": "Weiter bearbeiten",
      "reload": "Neu laden"
    },
    "view": {
      "loading": "Dieses Design wird geladen",
      "notFound": "Design nicht gefunden",
      "backToMedia": "Zurück zu Medien",
      "draftingToast": "Raldo entwirft deinen Beitrag.",
      "discardTitle": "Ungespeicherte Änderungen verwerfen?",
      "discardDescription": "Dieses Design enthält nicht gespeicherte Änderungen. Wenn du jetzt gehst, gehen sie verloren.",
      "unsavedChanges": "Dieses Design hat ungespeicherte Änderungen."
    },
    "defaults": {
      "text": "Text",
      "image": "Bild",
      "frame": "Rahmen",
      "ellipse": "Ellipse",
      "rectangle": "Rechteck",
      "artboard": "Artboard",
      "pageNumber": "Seite {number}"
    },
    "format": {
      "square": "Quadrat",
      "portrait": "Hochformat",
      "story": "Story"
    },
    "crop": {
      "presetOriginal": "Original",
      "preset1x1": "1:1",
      "preset4x5": "4:5",
      "preset16x9": "16:9",
      "preset9x16": "9:16"
    }
  },
  "primitives": {
    "loading": "Wird geladen",
    "breadcrumb": {
      "ariaLabel": "Breadcrumb",
      "moreAriaLabel": "Ordner dazwischen anzeigen"
    },
    "dateTimePicker": {
      "setDateTime": "Datum & Uhrzeit festlegen",
      "setDates": "Zeitraum festlegen",
      "previousMonth": "Vorheriger Monat",
      "nextMonth": "Nächster Monat",
      "time": "Uhrzeit",
      "hour": "Stunde",
      "minute": "Minute",
      "set": "Übernehmen"
    },
    "dropzone": {
      "dragDropTitle": "Dateien per Drag & Drop hierher ziehen",
      "clickToBrowse": "oder klicken zum Durchsuchen",
      "triggerAriaLabel": "{title}. {subtitle}",
      "filesSelected": "1 Datei ausgewählt | {count} Dateien ausgewählt",
      "filesSelectedWithIgnored": "1 Datei ausgewählt, {ignored} ignoriert (Dateityp nicht unterstützt) | {count} Dateien ausgewählt, {ignored} ignoriert (Dateityp nicht unterstützt)"
    },
    "expandableText": {
      "showMore": "Mehr anzeigen",
      "showLess": "Weniger anzeigen"
    },
    "field": {
      "required": "(Erforderlich)",
      "optional": "(Optional)"
    },
    "keyboard": {
      "controlKey": "Strg"
    },
    "languageSelect": {
      "ariaLabel": "Sprache: {language}"
    },
    "markdownEditor": {
      "editorLabel": "Markdown-Editor",
      "askRaldo": "Raldo fragen",
      "bold": "Fett",
      "italic": "Kursiv",
      "strikethrough": "Durchgestrichen",
      "heading": "Überschrift",
      "bulletList": "Aufzählungsliste",
      "numberedList": "Nummerierte Liste",
      "quote": "Zitat",
      "link": "Link",
      "linkText": "Linktext",
      "url": "URL",
      "toggleTask": "Aufgabe umschalten",
      "textFormatting": "Textformatierung",
      "selectionFormatting": "Formatierung der Auswahl",
      "insertBlock": "Block einfügen",
      "hookBoundaryLabel": "Die ersten {count} Zeichen sichtbar im Feed"
    },
    "numberInput": {
      "decrement": "Verringern",
      "increment": "Erhöhen"
    },
    "toast": {
      "close": "Schließen"
    },
    "toaster": {
      "notifications": "Benachrichtigungen"
    },
    "chart": {
      "noData": "Keine Daten für diesen Zeitraum",
      "labelValue": "{label}: {value}",
      "valueCaption": "{value} · {caption}",
      "fractionSr": "{value} von {total} {label}",
      "rank": "#{rank}",
      "axisRangeSr": "Horizontale Achse von {xLow} bis {xHigh}, vertikale Achse von {yLow} bis {yHigh}",
      "pointSr": "{label} - horizontal {x} von 100, vertikal {y} von 100",
      "bubbleSr": "{label}: {xLabel} {x}, {yLabel} {y}",
      "bubbleAxesSummary": "{xLabel} {x}, {yLabel} {y}",
      "seriesLabelValue": "{series}, {label}: {value}",
      "seriesValues": "{series}: {values}"
    },
    "delta": {
      "percent": "{value} %",
      "points": "{value} Pkt.",
      "absolute": "{value}",
      "unchanged": "unverändert"
    },
    "colorInput": {
      "brandColor": "Markenfarbe",
      "hexValue": "Hex-Wert von {label}"
    },
    "colorPicker": {
      "square": "Sättigung und Helligkeit",
      "hue": "Farbton",
      "opacity": "Deckkraft",
      "hex": "Hex-Farbe"
    },
    "aiEngine": {
      "chatgpt": "ChatGPT",
      "perplexity": "Perplexity",
      "google": "Google KI-Übersicht"
    }
  },
  "revisionHistory": {
    "loading": "Der Verlauf wird geladen",
    "generated": "{author} hat diese Version generiert.",
    "edited": "{author} hat sie bearbeitet.",
    "rewritten": "{author} hat sie umgeschrieben.",
    "restored": "{author} hat eine frühere Version wiederhergestellt.",
    "instructionAsked": "Du hast gefragt: \"{instruction}\"",
    "current": "Aktuell",
    "restore": "Wiederherstellen",
    "restoreAria": "Die Version vom {date} wiederherstellen"
  },
  "knowledge": {
    "searchPlaceholder": "Wissen durchsuchen",
    "noMatches": "Keine Seite passt dazu.",
    "newPage": "Neue Seite",
    "loading": "Dein Wissen wird geladen",
    "loadError": "Dein Wissen konnte nicht geladen werden",
    "emptyTitle": "Noch nichts festgehalten",
    "emptyBody": "Wissensseiten halten fest, was über dein Produkt stimmt: was es kann, was es kostet, wer es kauft. Raldo schreibt bei jedem Entwurf daraus.",
    "askRaldo": "Raldo bitten, deine Website zu lesen",
    "askRaldoToRead": "Lies meine Website und halte fest, was mein Produkt kann, was es kostet und wer es kauft.",
    "titleLabel": "Seitentitel",
    "titlePlaceholder": "Worum geht es auf dieser Seite?",
    "bodyLabel": "Seiteninhalt",
    "bodyPlaceholder": "Schreib auf, was über dein Produkt stimmt.",
    "outlineLabel": "Seitenübersicht",
    "writtenFrom": "Geschrieben aus",
    "historyLabel": "Verlauf",
    "notFoundTitle": "Diese Seite gibt es nicht",
    "notFoundBody": "Sie wurde vielleicht gelöscht, oder der Link stimmt nicht.",
    "backToLibrary": "Zurück zu Wissen",
    "deleteTitle": "Diese Seite löschen?",
    "deleteBody": "Die Seite und ihr ganzer Verlauf sind endgültig weg, und Raldo schreibt nicht mehr daraus.",
    "reading": "{site} wird gelesen",
    "readingBatch": "Paket {done} von {total}",
    "readingPages": "{selected} von {found} Seiten, ausgewählt nach dem, was du auf deiner Startseite verlinkst.",
    "bucket": {
      "productsAndServices": "Produkte und Leistungen",
      "pricing": "Preise",
      "customersAndBuyers": "Kundinnen und Käufer",
      "howItWorks": "So funktioniert es"
    },
    "foldersHeading": "Ordner",
    "pagesHeading": "Seiten",
    "newFolder": "Neuer Ordner",
    "newFolderTitle": "Neuer Ordner",
    "renameFolder": "Umbenennen",
    "renameFolderTitle": "Ordner umbenennen",
    "folderNameLabel": "Ordnername",
    "folderNamePlaceholder": "Was kommt hier hinein?",
    "folderNameTaken": "Ein Ordner hier heißt schon so.",
    "folderNameTooLong": "Halte den Namen bei höchstens {count} Zeichen.",
    "folderCreate": "Anlegen",
    "folderCount": "1 Ordner | {count} Ordner",
    "pageCount": "1 Seite | {count} Seiten",
    "folderEmpty": "Leer",
    "folderEmptyTitle": "In diesem Ordner ist noch nichts",
    "folderEmptyBody": "Schreib hier eine Seite, oder zieh eine von woanders hinein.",
    "moveAction": "In Ordner verschieben…",
    "moveTitle": "In Ordner verschieben",
    "moveBody": "Wähle, wohin das gehört.",
    "moveConfirm": "Verschieben",
    "itemActions": "Aktionen für {name}",
    "itemActionsMenu": "Aktionen",
    "deleteFolderTitle": "Diesen Ordner löschen?",
    "deleteFolderBody": "Der Ordner verschwindet. Alles darin rückt in den Ordner darüber, es geht also nichts verloren.",
    "slugTakenTitle": "Eine Seite mit diesem Titel gibt es schon.",
    "slugTakenAction": "Öffnen",
    "toast": {
      "saveFailed": "Die Seite konnte nicht gespeichert werden",
      "restoreFailed": "Diese Version konnte nicht wiederhergestellt werden",
      "deleteFailed": "Die Seite konnte nicht gelöscht werden",
      "folderCreateFailed": "Der Ordner konnte nicht angelegt werden",
      "folderRenameFailed": "Der Ordner konnte nicht umbenannt werden",
      "folderDeleteFailed": "Der Ordner konnte nicht gelöscht werden",
      "moveFailed": "Das konnte nicht verschoben werden"
    },
    "openFullPage": "Ganze Seite öffnen",
    "morePages": "1 weitere | {count} weitere",
    "preview": {
      "openFull": "Ganze Seite öffnen",
      "close": "Vorschau schließen",
      "askPlaceholder": "Frag Raldo zu dieser Seite"
    },
    "unsavedChanges": "Diese Seite hat ungespeicherte Änderungen."
  },
  "quickLook": {
    "loading": "Vorschau wird geladen",
    "unavailable": "Dieses Bild konnte nicht geladen werden",
    "previous": "Vorheriges Element",
    "next": "Nächstes Element",
    "position": "{index} von {count}",
    "close": "Vorschau schließen"
  },
  "design": {
    "view": {
      "loading": "Design wird geladen",
      "notFoundTitle": "Design nicht gefunden",
      "notFoundDescription": "Dieses Design wurde möglicherweise gelöscht.",
      "attachAction": "An Beitrag anhängen",
      "backToPost": "Zurück zum Beitrag",
      "documentError": "Die Design-Datei konnte nicht gelesen werden. Versuche es erneut."
    },
    "page": {
      "loading": "Seite {page} wird geladen",
      "error": "Diese Seite konnte nicht geladen werden",
      "alt": "Seite {page}"
    },
    "carousel": {
      "label": "Designseiten",
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "status": "Seite {page} von {count}"
    },
    "status": {
      "loading": "Lauf-Verlauf wird geladen",
      "running": "Raldo gestaltet das Design. Das dauert ein paar Sekunden.",
      "completed": "Das Design ist fertig.",
      "failed": "Das Design konnte nicht erstellt werden. {reason}",
      "reasons": {
        "design_run_enqueue_failed": "Es wurde nicht gestartet. Versuche es noch einmal.",
        "design_run_failed": "Etwas ist schiefgelaufen. Versuche es noch einmal.",
        "design_render_failed": "Die Seiten konnten nicht gezeichnet werden. Versuche es noch einmal.",
        "design_attach_failed": "Es konnte dem Beitrag nicht hinzugefügt werden. Versuche es noch einmal.",
        "run_timed_out": "Es hat zu lange gedauert. Versuche es noch einmal.",
        "unknown": "Versuche es noch einmal."
      }
    },
    "attachToPost": {
      "title": "An einen Beitrag anhängen",
      "description": "Wähle einen Entwurf, für den dieses Design zum Artwork werden soll.",
      "emptyTitle": "Noch keine Entwürfe",
      "emptyDescription": "Erstelle zuerst einen Entwurf und hänge dieses Design dann daran an.",
      "untitled": "Unbenannter Beitrag",
      "confirm": "Anhängen",
      "attaching": "Wird angehängt",
      "success": "Design an Beitrag angehängt"
    },
    "runBadge": {
      "running": "Wird erstellt",
      "failed": "Fehlgeschlagen"
    },
    "editor": {
      "errorTitle": "Das Design konnte nicht geöffnet werden",
      "frameTitle": "Seite {page}",
      "pages": {
        "summary": "{count} Seite · Hochformat 4:5 | {count} Seiten · Hochformat 4:5",
        "label": "Seiten",
        "item": "Seite {page}, {layout}",
        "moveUp": "Seite nach oben",
        "moveDown": "Seite nach unten",
        "duplicate": "Seite duplizieren",
        "delete": "Seite löschen",
        "add": "Seite hinzufügen"
      },
      "canvas": {
        "label": "Designseite",
        "page": "Seite {page}",
        "previous": "Vorherige Seite",
        "next": "Nächste Seite",
        "position": "{page} / {count}"
      },
      "inspector": {
        "page": "Seite {page}",
        "groups": {
          "argument": "Argumentations-Layout aus {template}",
          "announcement": "Ankündigungs-Layout aus {template}",
          "brand": "Marken-Layout aus {template}"
        },
        "editTitle": "Bearbeite alles auf der Seite",
        "editBody": "Klicke auf einen Text, ein Bild oder eine Form auf der Seite, um sie zu gestalten, zu verschieben oder zu ändern.",
        "copyTitle": "Dieses Design ist eine eigene Kopie",
        "copyBody": "Änderungen bleiben in diesem Design. Sie berühren nie deinen Markenstil oder die Vorlage.",
        "title": "Inspektor",
        "change": "Ändern",
        "pageColour": "Seitenfarbe",
        "designColours": "Design-Farben",
        "fonts": {
          "headings": "Schrift für Überschriften",
          "text": "Schrift für Text"
        },
        "text": "Text",
        "weight": "Stärke",
        "weights": {
          "w400": "Normal",
          "w500": "Mittel",
          "w600": "Halbfett",
          "w700": "Fett",
          "w800": "Extrafett"
        },
        "case": "Schreibweise",
        "cases": {
          "none": "Normal",
          "uppercase": "Großbuchstaben"
        },
        "colour": "Farbe",
        "picture": "Bild",
        "position": "Position",
        "x": "X",
        "y": "Y",
        "width": "Breite",
        "rotation": "Drehung",
        "appearance": "Aussehen",
        "opacity": "Deckkraft",
        "arrange": "Anordnen",
        "forward": "Nach vorn",
        "backward": "Nach hinten",
        "duplicate": "Duplizieren",
        "delete": "Löschen",
        "reset": "Auf das Layout zurücksetzen",
        "kind": {
          "slot": "Raldo hat das aus dem Beitrag geschrieben. Änderst du die Worte hier, ändert sich auch der Text des Beitrags. Wie du es gestaltest oder verschiebst, bleibt.",
          "part": "Teil des Layouts {template}. Gestalte es, verschiebe es oder entferne es; Raldo lässt es, wie du es eingestellt hast.",
          "free": "Du hast es hinzugefügt, nur auf dieser Seite. Raldo lässt es, wie du es eingestellt hast."
        },
        "slidesDiffer": "Der Beitrag und dieses Design haben unterschiedliche Slides."
      },
      "layouts": {
        "title": "Titel",
        "statement": "Aussage",
        "statement-2": "Aussage 2",
        "statement-3": "Aussage 3",
        "stat": "Kennzahl",
        "quote": "Zitat",
        "contrast": "Gegenüberstellung",
        "example": "Beispiel",
        "takeaway": "Fazit",
        "product": "Produkt",
        "features": "Funktionen",
        "service": "Leistung",
        "included": "Enthalten",
        "person": "Person",
        "event": "Event",
        "sign-off": "Abschluss"
      },
      "save": {
        "saved": "Gespeichert",
        "saving": "Wird gespeichert",
        "failed": "Speichern fehlgeschlagen",
        "stale": "Anderswo geändert",
        "reload": "Neu laden",
        "failedToast": "Das Design konnte nicht gespeichert werden",
        "staleToast": "Dieses Design wurde woanders geändert. Lade neu, um weiter zu bearbeiten.",
        "refused": {
          "invalid": "Die Designdatei ist ungültig.",
          "styles": "Die Stile des Designs lassen sich hier nicht ändern.",
          "editorRole": "Nur eine Editorin oder ein Editor kann dieses Design ändern."
        }
      },
      "history": {
        "undo": "Rückgängig",
        "redo": "Wiederholen"
      },
      "slots": {
        "eyebrow": "Überzeile",
        "headline": "Überschrift",
        "subhead": "Unterzeile",
        "bridge": "Überleitung",
        "cue": "Hinweis",
        "images": "Bild",
        "body": "Fließtext",
        "value": "Wert",
        "label": "Beschriftung",
        "quote": "Zitat",
        "attribution": "Quellenangabe",
        "before": "Vorher",
        "after": "Nachher",
        "close": "Schlusszeile",
        "next": "Nächster Schritt",
        "action": "Aktion",
        "name": "Name",
        "rows": "Liste",
        "role": "Rolle",
        "line": "Zeile",
        "date": "Datum",
        "place": "Ort",
        "what": "Was",
        "logo": "Logo",
        "brandName": "Markenname",
        "tagline": "Claim",
        "pageCounter": "Seitenzahl"
      },
      "parts": {
        "picture": "Bild",
        "text": "Text",
        "shape": "Form"
      },
      "toasts": {
        "undo": "Rückgängig",
        "slotRemoved": "{name} wurde von dieser Seite entfernt. Raldo schreibt es hier nicht wieder hin.",
        "duplicated": "Dupliziert. Die Kopie ist ein freies Element, Raldo füllt sie also nicht neu.",
        "layoutChanged": "Auf {layout} gewechselt. Die Texte sind in die passenden Felder gewandert; freie Änderungen auf dieser Seite blieben zurück.",
        "slotSaved": "Gespeichert. Der Text des Beitrags auf Seite {page} hat sich auch geändert.",
        "pageDeleted": "Seite gelöscht."
      },
      "panels": {
        "label": "Linkes Panel",
        "pages": "Seiten",
        "insert": "Einfügen"
      },
      "toolbar": {
        "label": "Seitenwerkzeuge",
        "typing": "Du tippst in {name}",
        "done": "Fertig",
        "insert": "Einfügen",
        "pageColour": "Seitenfarbe",
        "changeLayout": "Layout wechseln",
        "font": "Schrift",
        "size": "Größe",
        "textColour": "Textfarbe",
        "colour": "Farbe",
        "bold": "Fett",
        "capitals": "Großbuchstaben",
        "alignment": "Ausrichtung",
        "alignLeft": "Linksbündig",
        "alignCenter": "Zentriert",
        "alignRight": "Rechtsbündig",
        "replace": "Ersetzen",
        "askRaldo": "Raldo fragen"
      },
      "colours": {
        "accent": "Akzent",
        "ground": "Grund",
        "ink": "Tinte",
        "surface": "Fläche",
        "layout": "Farbe des Layouts nutzen"
      },
      "pictures": {
        "numbered": "Bild {number}",
        "none": "Dieses Design enthält noch keine Bilder."
      },
      "insert": {
        "label": "Einfügen",
        "text": "Text",
        "heading": "Überschrift",
        "subheading": "Zwischenüberschrift",
        "body": "Fließtext",
        "headingSample": "Überschrift",
        "subheadingSample": "Zwischenüberschrift",
        "bodySample": "Fließtext",
        "pieces": "Bausteine",
        "artwork": "Grafiken",
        "shapes": {
          "pointer": "Zeiger",
          "rectangle": "Rechteck",
          "circle": "Kreis",
          "line": "Linie",
          "tape": "Klebestreifen"
        },
        "icons": "Symbole",
        "pictures": "Bilder",
        "brand": "Marke",
        "logo": "Logo",
        "brandName": "Markenname"
      },
      "picker": {
        "addTitle": "Seite hinzufügen",
        "changeTitle": "Layout wechseln",
        "addDescription": "Wähle ein Layout. Die neue Seite kommt nach dieser.",
        "changeDescription": "Wähle ein Layout für diese Seite. Die Texte wandern in die passenden Felder.",
        "label": "Layouts",
        "card": "{layout}, {group}",
        "now": "Aktuell",
        "groups": {
          "argument": "Argumentation",
          "announcement": "Ankündigung",
          "brand": "Marke"
        }
      },
      "fit": {
        "count": "{n} Warnung | {n} Warnungen",
        "title": "Ein Element passt nicht | {n} Elemente passen nicht",
        "note": "Die Seite wird trotzdem gespeichert. Korrigiere es von Hand oder wähle es aus und bitte Raldo, es passend zu machen.",
        "hint": "Kürze den Text, verkleinere ihn, verschiebe ihn oder lass Raldo ihn anpassen.",
        "ask": "Raldo bitten, es anzupassen",
        "reasons": {
          "cut-off": "Der Text ist abgeschnitten",
          "footer": "Ragt in die Fußzeile",
          "overlap": "Überlappt {element}",
          "edge": "Ragt über den Seitenrand"
        }
      },
      "raldo": {
        "chipPage": "Seite {page}",
        "startFailed": "Raldo konnte die Änderung nicht starten",
        "stopFailed": "Die Änderung konnte nicht gestoppt werden",
        "undoFailed": "Die Änderung konnte nicht rückgängig gemacht werden",
        "refused": {
          "alreadyActive": "Raldo ändert dieses Design gerade schon.",
          "notReady": "Dieses Design ist noch nicht bereit für Änderungen.",
          "instructionEmpty": "Sag, was geändert werden soll.",
          "instructionTooLong": "Das ist zu lang. Halte es unter 1000 Zeichen.",
          "pageMissing": "Diese Seite gibt es nicht mehr.",
          "elementMissing": "Dieses Element ist nicht mehr auf der Seite.",
          "editorRole": "Nur Editoren können ein Design ändern.",
          "superseded": "Das Design wurde seitdem geändert. Diese Änderung lässt sich nicht mehr rückgängig machen.",
          "notUndoable": "Diese Änderung lässt sich nicht rückgängig machen.",
          "snapshotIncomplete": "Die Kopie von vor der Änderung ist unvollständig.",
          "snapshotUnavailable": "Die Kopie von vor der Änderung ist nicht verfügbar."
        },
        "lock": {
          "title": "Raldo bearbeitet Seite {page}",
          "note": "Der Editor wird wieder frei, sobald Raldo fertig ist.",
          "stop": "Stopp"
        },
        "steps": {
          "read": "Seite {page} wird gelesen",
          "edit": "{element} wird bearbeitet",
          "editPage": "Die Seite wird bearbeitet",
          "check": "Das Ergebnis wird geprüft"
        },
        "card": {
          "elementFallback": "Element",
          "undo": "Rückgängig",
          "undone": "Rückgängig gemacht",
          "undoSuperseded": "Eine spätere Änderung hat diese ersetzt.",
          "cancelled": "Gestoppt. Nichts wurde geändert.",
          "rejected": "Die Änderung hat die Prüfung nicht bestanden. Nichts wurde geändert.",
          "timedOut": "Die Änderung hat zu lange gedauert. Nichts wurde geändert.",
          "failed": "Die Änderung ist fehlgeschlagen. Nichts wurde geändert."
        }
      }
    },
    "brandStyle": {
      "make": "Markenstil erstellen",
      "building": {
        "label": "Stil wird erstellt · {done} von {total}",
        "title": "Wird noch erstellt",
        "body": "Raldo erstellt deinen Markenstil noch. {done} von {total} Layouts sind fertig. Arbeite weiter; du bekommst eine Nachricht im Posteingang, sobald er fertig ist.",
        "confirm": "Verstanden"
      },
      "review": {
        "action": "Markenstil prüfen",
        "title": "Neuer Markenstil",
        "description": "Gezeichnet nach {design}",
        "pass": "{done} von {total} bestehen die Prüfungen",
        "footer": "Der Text passt, die Ränder halten und die Farben sind auf jedem Layout lesbar.",
        "use": "Als Markenstil verwenden",
        "discard": "Verwerfen",
        "label": "Die Layouts des neuen Markenstils",
        "loading": "Der neue Markenstil wird geladen",
        "loadError": "Der neue Markenstil konnte nicht geladen werden"
      },
      "dialog": {
        "title": "Markenstil aus diesem Design erstellen",
        "description": "Raldo macht aus diesem Design die 16 Layouts, die deine Marke nutzt.",
        "confirm": "Im Hintergrund erstellen",
        "steps": {
          "read": "Raldo liest den Look: Farben, Schriften und deine Textstile.",
          "draw": "Es zeichnet die 16 Layouts im Hintergrund. Du kannst weiterarbeiten. Der Posteingang meldet, wann es fertig ist.",
          "check": "Jedes Layout wird zuerst geprüft: Der Text muss passen, die Ränder müssen halten, die Farben müssen lesbar sein."
        },
        "note": "Neue Designs nutzen den neuen Stil. Dieses Design und die Designs, die du schon gemacht hast, bleiben, wie sie sind."
      },
      "toast": {
        "started": "Raldo erstellt deinen Markenstil",
        "startedBody": "Du bekommst eine Nachricht im Posteingang, sobald er fertig ist.",
        "startFailed": "Der Markenstil konnte nicht gestartet werden",
        "use": "Markenstil aktualisiert",
        "useBody": "Neue Designs nutzen ihn. Deine bestehenden Designs bleiben, wie sie sind.",
        "discard": "Markenstil verworfen",
        "discardBody": "Dein aktueller Markenstil bleibt.",
        "decideFailed": "Deine Wahl konnte nicht gespeichert werden"
      },
      "refused": {
        "role": "Nur ein Inhaber oder Admin kann den Markenstil ändern.",
        "active": "Raldo erstellt bereits einen Markenstil.",
        "designNotReady": "Dieses Design ist noch nicht fertig.",
        "notPending": "Über diesen Markenstil wurde schon entschieden.",
        "candidateMissing": "Der neue Markenstil ist nicht mehr da. Erstelle ihn erneut."
      }
    }
  },
  "tabs": {
    "all": "Alle",
    "brandFacts": "Marken-Fakten",
    "customerProfile": "Kundenprofil",
    "account": "Konto",
    "billing": "Abrechnung",
    "rankings": "Rankings",
    "aiAnswers": "KI-Antworten",
    "socialMedia": "Social Media",
    "inbox": "Posteingang",
    "sent": "Gesendet",
    "archive": "Archiv"
  },
  "visibility": {
    "search": {
      "pages": {
        "title": "Deine Seiten bei Google",
        "source": "Aus dem monatlichen Suchlauf",
        "columns": {
          "page": "Seite",
          "visits": "Besuche/Monat",
          "keywords": "Keywords"
        },
        "topKeyword": "Top-Keyword: {keyword}",
        "emptyTitle": "Noch keine Seiten bei Google",
        "emptyBody": "Der monatliche Suchlauf listet die Seiten deiner Website, die Google rankt, mit den Besuchen jeder Seite."
      },
      "columns": {
        "status": "Status",
        "mainKeyword": "Haupt-Keyword"
      },
      "emptyTitle": "Noch keine geplanten Seiten",
      "emptyBody": "Sobald Raldo deine Seiten plant, stehen hier das Haupt-Keyword jeder Seite, seine Suchanfragen und dein Rang bei Google.",
      "openPlan": "Plan öffnen"
    },
    "keyword": {
      "why": "Warum du sie gewinnen kannst",
      "in": "in",
      "rankHistory": "Suchrang im Zeitverlauf",
      "weekly": "Wöchentlich",
      "volume": "Suchen im Monat",
      "volumeSource": "Letzte 12 Monate, von Google",
      "whoRanks": "Wer bei Google rankt",
      "aiOverview": "Wen Googles AI Overview zitiert",
      "checked": "Geprüft am {date}",
      "searchRun": "Suchlauf vom {date}"
    },
    "citeHelp": {
      "label": "Was zitiert und genannt bedeuten",
      "cited": "Zitiert",
      "citedBody": "Die Antwort verlinkt die Website als Quelle. Käufer können sie anklicken, und die KI-Suche wertet sie als Beleg.",
      "named": "Genannt",
      "namedBody": "Die Antwort nennt die Marke beim Namen, mit oder ohne Link. Das bringt dich ins Gedächtnis der Käufer, aber keinen Besuch."
    },
    "aiAnswers": {
      "figures": {
        "cited": "Prompts, in denen KI-Assistenten dich zitieren",
        "citeYou": "zitieren dich",
        "citeRival": "zitieren stattdessen einen Wettbewerber",
        "citeNone": "zitieren niemanden, den du verfolgst",
        "named": "Prompts, in denen sie dich nennen",
        "nameAndLink": "nennen und verlinken dich",
        "nameNoLink": "nennen dich ohne Link",
        "nameNone": "nennen dich nie",
        "overview": "Keywords, bei denen AI Overviews dich zitieren",
        "overviewCites": "zitieren dich",
        "overviewWithout": "antworten ohne dich",
        "overviewNone": "ohne AI Overview"
      },
      "prompt": "Prompt",
      "citedBy": "Zitiert von {engine}",
      "noAnswer": "Keine Antwort",
      "overviews": "Google AI Overviews",
      "overviewsMeta": "Keywords, bei denen die Overview dich oder einen Wettbewerber zitiert",
      "overviewsEmptyTitle": "Noch keine AI Overview zitiert dich oder einen Wettbewerber",
      "overviewsEmptyBody": "Sobald Googles AI Overview zu einem deiner Keywords dich oder einen verfolgten Wettbewerber zitiert, steht das Keyword hier.",
      "emptyTitle": "Noch keine KI-Antworten",
      "emptyBody": "Einmal im Monat stellt Raldo ChatGPT und Perplexity die Fragen, die deine Käufer stellen, geschrieben aus deinem Plan. Miss jetzt, um die ersten Antworten zu erhalten.",
      "run": {
        "working": "Raldo misst deine Sichtbarkeit in KI-Antworten.",
        "stages": {
          "prompts": "Raldo schreibt die Fragen, die deine Käufer KI-Assistenten stellen.",
          "answers": "Raldo fragt die KI-Assistenten und liest ihre Antworten.",
          "commit": "Raldo speichert die Antworten."
        },
        "completed": "Die KI-Antworten sind fertig.",
        "partial": "Die KI-Antworten sind fertig, aber einige sind nicht angekommen.",
        "cancelled": "Du hast die Messung abgebrochen.",
        "failed": "Die Messung ist stehen geblieben"
      },
      "measure": "Jetzt messen",
      "table": {
        "title": "Du und deine Rivalen in KI-Antworten",
        "meta": "Themen- und Kategorie-Prompts · {period}",
        "share": "Anteil der Verfolgten",
        "shareHint": "Anteil der Namen, die die KI-Antworten dir und deinen verfolgten Rivalen geben",
        "named": "Genannt",
        "cited": "Zitiert",
        "namedBy": "{engine} nannte",
        "citedBy": "{engine} zitierte",
        "answers": "{count} Antwort | {count} Antworten"
      },
      "rates": {
        "answers": "Antworten",
        "byTopic": "Nennquote nach Thema",
        "topicMeta": "Nur Themen-Prompts · {period}",
        "topic": "Thema",
        "byStage": "Nennquote nach Phase",
        "stageMeta": "Themen- und Kategorie-Prompts · {period}",
        "stage": "Phase"
      },
      "otherBrands": {
        "title": "Andere genannte Marken",
        "meta": "Von ChatGPT, Anteil seiner Antworten",
        "brand": "Marke",
        "share": "Anteil"
      },
      "domains": {
        "title": "Meistzitierte Domains",
        "topicTitle": "Meistzitierte Domains: {topic}",
        "meta": "Antworten, die die Website zitieren",
        "site": "Website"
      },
      "categoryPrompts": "Kategorie-Prompts",
      "brandPrompts": "Marken-Prompts",
      "brandMeta": "Deine eigene Website ist in {cited} von {answers} Antworten eine Quelle. Nicht in den Zahlen oben.",
      "promptCount": "{count} Prompt | {count} Prompts"
    },
    "prompt": {
      "asked": "· gefragt am {date}",
      "answerFrom": "Antwort von {engine}",
      "cites": "Zitiert",
      "webSearch": "{model} · Websuche",
      "noAnswer": "Diesmal keine Antwort. Raldo fragt im Lauf des nächsten Monats erneut.",
      "moreSources": "{domain} +{count}",
      "sources": "{count} Quelle | {count} Quellen",
      "mentions": "Wen die Antworten erwähnen",
      "mentionsCount": "{count} Website oder Marke | {count} Websites und Marken",
      "siteOrBrand": "Website oder Marke",
      "mentionsEmpty": "Keine der Antworten erwähnt eine Website oder Marke.",
      "you": "Du",
      "trackedRival": "{domain} · verfolgter Wettbewerber",
      "site": "Website, nicht verfolgt",
      "brand": "Marke, nicht verfolgt",
      "cited": "Zitiert",
      "named": "Genannt",
      "notFoundTitle": "Prompt nicht gefunden",
      "notFoundBody": "Er stammt vielleicht aus einem älteren Lauf, oder der Link ist veraltet.",
      "back": "Zurück zu den KI-Antworten",
      "writtenFrom": "Geschrieben von der Seite",
      "kind": {
        "category": "Kategorie-Prompt",
        "brand": "Marken-Prompt"
      }
    },
    "social": {
      "windowAria": "Zeitraum",
      "windowDays": "{days} Tage",
      "allTime": "Gesamter Zeitraum",
      "figures": {
        "impressions": "Impressionen",
        "impressionsSub": "Über {count} Beitrag | Über {count} Beiträge",
        "reach": "Reichweite",
        "reachSub": "Über alle Beiträge summiert",
        "engagement": "Durchschnittliche Engagement-Rate",
        "engagementSub": "Reaktionen, Kommentare und Shares im Verhältnis zu Impressionen",
        "published": "Veröffentlichte Beiträge",
        "publishedSub": "von {tracked} erfasst · {syncing} werden synchronisiert"
      },
      "weekly": {
        "title": "Impressionen pro Woche",
        "meta": "LinkedIn · im gewählten Zeitraum",
        "aria": "Impressionen pro Woche im gewählten Zeitraum"
      },
      "posts": {
        "title": "Veröffentlichte Beiträge",
        "meta": "Meistgesehene zuerst",
        "post": "Beitrag",
        "published": "Veröffentlicht",
        "impressions": "Impressionen",
        "reach": "Reichweite",
        "engagement": "Engagement",
        "clicks": "Klicks",
        "syncing": "Wird von LinkedIn synchronisiert",
        "emptyTitle": "In diesem Zeitraum nichts veröffentlicht",
        "emptyBody": "Wähle einen längeren Zeitraum, um ältere Beiträge zu sehen."
      },
      "emptyTitle": "Noch keine veröffentlichten Beiträge",
      "emptyBody": "Sobald ein Beitrag auf LinkedIn erscheint, synchronisiert Raldo alle sechs Stunden seine Impressionen, Reichweite und sein Engagement.",
      "emptyCta": "Board öffnen",
      "loadError": "Deine Social-Zahlen konnten nicht geladen werden"
    }
  },
  "calendar": {
    "view": {
      "board": "Board",
      "calendar": "Kalender",
      "aria": "Ansicht"
    },
    "columns": {
      "review": "Zu prüfen",
      "scheduled": "Geplant",
      "published": "Veröffentlicht",
      "reviewEmpty": "Nichts zu prüfen",
      "scheduledEmpty": "Nichts geplant",
      "publishedEmpty": "Nichts veröffentlicht",
      "lastDays": "Letzte {count} Tage",
      "writing": "Wird geschrieben",
      "showOlder": "Ältere anzeigen"
    },
    "card": {
      "post": "Beitrag",
      "postPages": "Beitrag · {count} Seite | Beitrag · {count} Seiten",
      "when": "{day} · {time}",
      "impressions": "Impressionen",
      "engagement": "Engagement",
      "writingAria": "Raldo schreibt diesen Beitrag",
      "actionsAria": "Aktionen für {title}"
    },
    "day": {
      "yesterday": "Gestern",
      "today": "Heute",
      "tomorrow": "Morgen"
    },
    "badge": {
      "writing": "Schreibt",
      "failed": "Fehlgeschlagen",
      "needsPerson": "Braucht eine Person"
    },
    "state": {
      "writing": "Schreibt",
      "failed": "Fehlgeschlagen",
      "published": "Veröffentlicht",
      "scheduled": "Geplant",
      "awaitingArtwork": "Wartet auf Design",
      "draft": "Entwurf",
      "needsPerson": "Braucht eine Person"
    },
    "measuring": "Wird gemessen",
    "editedByYou": "Von dir bearbeitet",
    "pages": "{count} Seite | {count} Seiten",
    "openSlot": "Freier Slot",
    "noDateTray": "Noch kein Datum · {count}",
    "nothingPlanned": "Nichts geplant",
    "dock": {
      "failed": "Fehlgeschlagen",
      "whatItArgues": "Was er vertritt",
      "topic": "Thema · {name}",
      "history": "Verlauf · {count} Version | Verlauf · {count} Versionen",
      "articleState": "Stand",
      "writing": "Raldo schreibt die Abschnitte.",
      "todo": "Zu tun · {count} | Zu tun · {count}",
      "more": "+ {count} weitere",
      "outline": "Gliederung",
      "verified": "Verifiziert am {date}",
      "openPublished": "Veröffentlichte Seite öffnen",
      "goesLive": "Eine Seite geht live, wenn du ihren veröffentlichten Link hinzufügst, nicht durch Planen.",
      "planning": "Raldo plant und recherchiert diese Seite.",
      "askArticlePlaceholder": "Frag Raldo zu dieser Seite…",
      "checked": "Raldo hat den Entwurf geprüft.",
      "needsPerson": "Braucht eine Person"
    },
    "toast": {
      "reconnectFirst": "Verbinde zuerst LinkedIn neu.",
      "writing": "Raldo schreibt diesen Beitrag noch. Es gibt noch keinen Text zum Planen.",
      "article": "Eine Seite geht live, wenn du ihren veröffentlichten Link hinzufügst, nicht durch Planen.",
      "neverPublishes": "Ziehen veröffentlicht nie. Öffne den Beitrag und nutze Jetzt veröffentlichen.",
      "publishedStays": "Ein veröffentlichter Beitrag bleibt veröffentlicht. LinkedIn erlaubt kein Bearbeiten oder Zurückziehen.",
      "noBody": "Dieser Beitrag hat noch keinen Text zum Planen.",
      "connectFirst": "Verbinde zuerst LinkedIn."
    },
    "notConnected": "LinkedIn ist nicht verbunden, geplante Beiträge können also nicht rausgehen."
  },
  "inbox": {
    "newNote": "Neue Notiz",
    "tabsAria": "Posteingangsansicht",
    "loading": "Dein Posteingang wird geladen",
    "listAria": "Einträge im Posteingang",
    "group": {
      "today": "Heute",
      "thisWeek": "Diese Woche",
      "earlier": "Früher"
    },
    "sender": {
      "raldo": "Raldo",
      "linkedin": "LinkedIn",
      "you": "Du"
    },
    "when": "{day}, {time}",
    "note": {
      "viaTelegram": "über Telegram",
      "editAria": "Diese Notiz bearbeiten"
    },
    "composer": {
      "title": "Neue Notiz",
      "add": "Notiz hinzufügen",
      "addLink": "Link hinzufügen",
      "addImage": "Bild hinzufügen",
      "linkPlaceholder": "Link einfügen und Enter drücken",
      "hint": "Raldo liest deine Notizen, wenn er plant und schreibt."
    },
    "error": {
      "publish_failed": "LinkedIn hat den Beitrag nicht angenommen.",
      "publish_partial": "Der Beitrag wurde auf einigen Kanälen veröffentlicht, aber nicht auf allen.",
      "linkedin_account_not_connected": "LinkedIn ist nicht verbunden.",
      "design_page_render_missing": "Eine Seite des Designs konnte nicht gerendert werden.",
      "unexpected_error": "Etwas Unerwartetes ist schiefgegangen.",
      "article_health_check_failed": "Der Artikel hat die Prüfung nicht bestanden.",
      "token_revoked": "Der LinkedIn-Zugriff wurde widerrufen. Verbinde das Konto erneut.",
      "unknown": "Etwas ist schiefgegangen.",
      "brand_style_enqueue_failed": "Der Markenstil konnte nicht gestartet werden.",
      "brand_style_failed": "Raldo konnte den Markenstil nicht zeichnen.",
      "brand_style_rejected": "Die Layouts haben die Prüfungen nicht bestanden.",
      "run_timed_out": "Der Lauf hat zu lange gedauert."
    },
    "toast": {
      "actionFailed": "Der Posteingang konnte nicht aktualisiert werden",
      "sent": "An Raldo gesendet.",
      "later": "Zurückgestellt. Die orange Zahl behält es."
    },
    "unread": "Ungelesen",
    "markAllRead": "Alle als gelesen markieren",
    "archive": "Archivieren",
    "unarchive": "Wiederherstellen",
    "deleted": "Dieser Eintrag wurde gelöscht",
    "empty": {
      "inbox": {
        "title": "Noch nichts hier.",
        "description": "Raldo schreibt, wenn ein Entwurf, eine Frage oder ein Ergebnis dich braucht."
      },
      "unread": {
        "title": "Du bist auf dem neuesten Stand."
      },
      "important": {
        "title": "Gerade nichts Wichtiges."
      },
      "sent": {
        "title": "Noch keine Notizen.",
        "description": "Alles, was Raldo wissen sollte, landet hier."
      },
      "archive": {
        "title": "Nichts archiviert.",
        "description": "Archivierte Nachrichten werden hier aufbewahrt."
      }
    },
    "researchKind": {
      "brandFacts": "Deine Marken-Fakten",
      "customerProfile": "Dein Kundenprofil",
      "contentStrategy": "Deine Content-Strategie",
      "competitors": "Deine Wettbewerbsanalyse",
      "visibility": "Deine Sichtbarkeitsprüfung",
      "aiAnswers": "Deine Prüfung der KI-Antworten",
      "documents": "Deine Dokumentenrecherche"
    },
    "selectPrompt": "Wähle eine Nachricht aus",
    "build": {
      "title": "Raldo baut deinen Plan",
      "steps": {
        "snapshot": {
          "title": "Such-Snapshot",
          "caption": "Du in der Suche und in KI-Antworten | Du und dein Wettbewerber in der Suche und in KI-Antworten | Du und deine {count} Wettbewerber in der Suche und in KI-Antworten"
        },
        "plan": {
          "title": "Content-Plan",
          "caption": "Die Seiten und Posts, die zuerst kommen"
        },
        "answers": {
          "title": "Prüfung der KI-Antworten",
          "caption": "Wo ChatGPT und Perplexity dich nennen"
        }
      }
    },
    "missing": "Diese Nachricht ist nicht mehr da",
    "subject": {
      "articleQuestions": "{count} Frage zu {page} | {count} Fragen zu {page}",
      "articleReady": {
        "completed": "{page} ist fertig",
        "partial": "{page} ist fertig, mit Lücken"
      },
      "planProposal": "Planänderungen zur Prüfung",
      "planTopics": "{count} Thema zur Prüfung | {count} Themen zur Prüfung",
      "planReminder": {
        "reviewTopics": "Noch offen: deine Themen",
        "reviewPlan": "Noch offen: dein Plan"
      },
      "planReady": {
        "completed": "Dein Plan ist fertig",
        "partial": "Dein Plan ist fertig, mit Lücken"
      },
      "postDraft": "Entwurf fertig: {title}",
      "postPublishFailed": "Veröffentlichung fehlgeschlagen: {title}",
      "postPublished": "Veröffentlicht: {title}",
      "postResults": "Ergebnisse: {title}",
      "runFailed": "{run} ist nicht fertig geworden",
      "accountDisconnected": "{platform} getrennt",
      "researchReady": "Fertig: {research}",
      "designReady": {
        "no": "Dein Design ist fertig",
        "yes": "Design fertig, Seiten fehlen"
      },
      "brandStyleReady": "Dein neuer Markenstil ist fertig",
      "brandStyleDecided": {
        "used": "Markenstil aktualisiert",
        "discarded": "Markenstil verworfen"
      }
    },
    "line": {
      "articleQuestions": "Eine kurze Frage, bevor ich weiterschreibe. | {count} kurze Fragen, bevor ich weiterschreibe.",
      "articleReady": {
        "completed": "Geschrieben, lektoriert und geprüft. Lies sie, wenn du kurz Zeit hast.",
        "partial": "Ein paar Abschnitte brauchen deinen Blick, bevor sie irgendwohin gehen."
      },
      "planProposal": "{changes}. Nichts bewegt sich, bis du es sagst.",
      "planTopics": "Behalte die Themen, die du besetzen willst. Nichts wird geplant, bevor du es sagst.",
      "planReminder": {
        "reviewTopics": "Ich habe vor 7 Tagen gefragt. Der Lauf wartet; verwirf ihn, wenn du ihn nicht mehr willst.",
        "reviewPlan": "Ich habe vor 7 Tagen gefragt. Der Lauf wartet; verwirf ihn, wenn du ihn nicht mehr willst."
      },
      "planReady": {
        "completed": "Jede Seite nach Thema, in der Reihenfolge, in der ich sie schreiben würde.",
        "partial": "Einige Teile fehlen. Sie sind markiert."
      },
      "postDraft": {
        "yes": "{hook}",
        "no": "Bereit zum Lesen."
      },
      "postPublishFailed": "{error}",
      "postPublished": "Auf LinkedIn live. In etwa einer Woche melde ich mich mit den Zahlen.",
      "postResults": "{impressions} Impressionen, {clicks} Klicks, {rate} Interaktion.",
      "runFailed": "{error}",
      "accountDisconnected": "Geplante Beiträge bleiben liegen, bis du dich wieder verbindest.",
      "researchReady": {
        "brandFacts": "Was ich über dein Unternehmen gelesen habe und wo ich es gelesen habe.",
        "customerProfile": "Für wen du schreibst, in seinen eigenen Worten.",
        "contentStrategy": "Wofür du stehst und worüber du schreibst.",
        "competitors": "Die anderen Namen, die deine Käufer in Betracht ziehen, und wie du im Vergleich abschneidest.",
        "visibility": "Wo Käufer dich diesen Monat finden und wo noch nicht.",
        "aiAnswers": "Wo ChatGPT und Perplexity dich nennen.",
        "documents": "Was ich aus deinen Dokumenten gezogen habe."
      },
      "designReady": {
        "no": "Am Beitrag angehängt. Öffne ihn zur Kontrolle.",
        "yes": "Einige Seiten ließen sich nicht an den Beitrag anhängen."
      },
      "brandStyleReady": "Gezeichnet aus {design}. Sechzehn Layouts zur Prüfung.",
      "brandStyleDecided": {
        "used": "Neue Designs nutzen ihn ab jetzt.",
        "discarded": "Dein Markenstil hat sich nicht geändert."
      }
    },
    "body": {
      "articleQuestions": [
        "Ich schreibe {page} und bin auf etwas gestoßen, das ich in deinen Quellen nicht finde. | Ich schreibe {page} und bin auf {count} Dinge gestoßen, die ich in deinen Quellen nicht finde.",
        "Antworte auf der Seite, dann mache ich dort weiter, wo ich aufgehört habe. Raten würde das Argument schwächen."
      ],
      "articleReady": {
        "completed": [
          "{page} ist geschrieben, lektoriert und geprüft. Öffne die Seite, lies sie durch und veröffentliche sie."
        ],
        "partial": [
          "Ich habe von {page} fertig gemacht, was ich konnte. Ein paar Abschnitte brauchen deinen Blick, bevor das irgendwohin geht. Sie sind markiert."
        ]
      },
      "planProposal": [
        "Die Suchen deiner Käufer haben sich verschoben, deshalb schlage ich Änderungen an deinem Plan vor: {changes}.",
        "Nichts ändert sich, bevor du es geprüft hast."
      ],
      "planTopics": [
        "Ich habe die Suchen gelesen, die deine Käufer eintippen, und schlage {count} Thema vor. | Ich habe die Suchen gelesen, die deine Käufer eintippen, und schlage {count} Themen vor.",
        "Behalte, benenne oder entferne jedes Thema, oder füge eigene hinzu. Nichts wird geplant, bevor du zustimmst."
      ],
      "planReminder": {
        "reviewTopics": [
          "Ich habe vor 7 Tagen gefragt. Der Lauf wartet; verwirf ihn, wenn du ihn nicht mehr willst."
        ],
        "reviewPlan": [
          "Ich habe vor 7 Tagen gefragt. Der Lauf wartet; verwirf ihn, wenn du ihn nicht mehr willst."
        ]
      },
      "planReady": {
        "completed": [
          "Dein Content-Plan steht: jede Seite nach Thema, in der Reihenfolge, in der ich sie schreiben würde. Wirf einen Blick darauf."
        ],
        "partial": [
          "Dein Content-Plan steht, aber ich konnte nicht jeden Teil fertigstellen. Die Lücken sind markiert."
        ]
      },
      "postDraft": {
        "yes": [
          "Dein Entwurf ist fertig. Er beginnt mit: „{hook}“",
          "Lies ihn einmal durch, dann plane ihn ein."
        ],
        "no": ["Dein Entwurf ist fertig.", "Lies ihn einmal durch, dann plane ihn ein."]
      },
      "postPublishFailed": [
        "LinkedIn hat „{title}“ nicht angenommen. {error}",
        "Behebe, was genannt wird, und versuche es erneut. Den Rest übernehme ich."
      ],
      "postPublished": [
        "„{title}“ ist auf LinkedIn live. Ich prüfe die Zahlen und melde mich in etwa einer Woche."
      ],
      "postResults": ["Eine Woche danach: So hat „{title}“ abgeschnitten."],
      "runFailed": [
        "{run} ist vor dem Ende stehen geblieben. {error}",
        "Starte den Lauf neu, wenn du bereit bist."
      ],
      "accountDisconnected": [
        "{platform} hat die Verbindung verloren. {error}",
        "Nichts geht raus, bis du es wieder verbindest. Zwei Klicks."
      ],
      "researchReady": {
        "brandFacts": [
          "Ich habe deine Website gelesen und aufgeschrieben, was über dein Unternehmen stimmt, samt der Seite, aus der jeder Fakt stammt. Prüf mich."
        ],
        "customerProfile": [
          "Ich habe die Person auf der anderen Seite deiner Beiträge aus dem gezeichnet, was Käufer sagen. Schau, ob du sie wiedererkennst."
        ],
        "contentStrategy": [
          "Deine Content-Strategie ist fertig: wofür du stehst und worüber du schreibst. Lies sie und bestätige sie."
        ],
        "competitors": [
          "Ich habe mir die Namen angesehen, gegen die deine Käufer dich abwägen, und wo du heraussticht. Wirf einen Blick darauf."
        ],
        "visibility": [
          "Die Prüfung dieses Monats ist da: wo Käufer dich in Google und in KI-Antworten finden und wo noch nicht."
        ],
        "aiAnswers": [
          "Ich habe ChatGPT und Perplexity die Fragen deiner Käufer gestellt und notiert, wo du auftauchst."
        ],
        "documents": [
          "Ich habe deine Dokumente gelesen und herausgezogen, was ich beim Schreiben nutzen kann."
        ]
      },
      "designReady": {
        "no": [
          "Dein Design ist gezeichnet und am Beitrag angehängt. Öffne es und prüfe es, bevor es rausgeht."
        ],
        "yes": [
          "Dein Design ist gezeichnet, aber ich konnte nicht jede Seite an den Beitrag anhängen. Öffne es, um zu sehen, welche."
        ]
      },
      "brandStyleReady": [
        "Ich habe aus {design} einen Markenstil gezeichnet: sechzehn Layouts in seinen Farben und seiner Schrift.",
        "Nutze ihn oder verwirf ihn. Neue Designs folgen ihm ab dann."
      ],
      "brandStyleDecided": {
        "used": [
          "Der neue Markenstil ist jetzt dein Markenstil. Neue Designs nutzen ihn ab jetzt."
        ],
        "discarded": [
          "Du hast den neuen Markenstil verworfen. Dein Markenstil hat sich nicht geändert."
        ]
      }
    },
    "verb": {
      "articleQuestions": "Auf der Seite antworten",
      "articleReady": "Seite öffnen",
      "planProposal": "Plan prüfen",
      "planTopics": "Themen prüfen",
      "planReminder": {
        "reviewTopics": "Themen prüfen",
        "reviewPlan": "Plan prüfen"
      },
      "planReady": "Plan öffnen",
      "postDraft": "Beitrag öffnen",
      "postPublishFailed": "Erneut versuchen",
      "postPublished": "Beitrag öffnen",
      "postResults": "Beitrag öffnen",
      "runFailed": "Öffnen",
      "accountDisconnected": "Neu verbinden",
      "researchReady": "Öffnen",
      "designReady": "Beitrag öffnen",
      "brandStyleReady": "Prüfen",
      "brandStyleDecided": "Öffnen",
      "note": "Bearbeiten"
    },
    "verbSecondary": {
      "postPublishFailed": "Beitrag öffnen"
    },
    "changes": {
      "topics": "{n} Thema geändert | {n} Themen geändert",
      "added": "{n} Seite hinzugefügt | {n} Seiten hinzugefügt",
      "removed": "{n} Seite entfernt | {n} Seiten entfernt",
      "changed": "{n} Seite geändert | {n} Seiten geändert"
    },
    "runName": {
      "article": "Der Artikel",
      "post": "Der Beitrag",
      "plan": "Der Plan",
      "design": "Das Design",
      "design-edit": "Die Design-Änderung",
      "brand-style": "Der Markenstil",
      "other": "Der Durchlauf"
    },
    "important": "Wichtig",
    "later": "Später",
    "more": "+{n} im Posteingang",
    "selected": "{n} ausgewählt",
    "markRead": "Als gelesen markieren",
    "count": "{n} Nachricht | {n} Nachrichten",
    "selectMessage": "Nachricht auswählen",
    "clearSelection": "Auswahl aufheben",
    "filter": {
      "aria": "Nachrichten filtern",
      "all": "Alle"
    },
    "toYou": "an dich",
    "toRaldo": "an Raldo",
    "earlierInThread": "Früher in diesem Verlauf",
    "position": "{n} / {total}",
    "markUnread": "Als ungelesen markieren",
    "moveToInbox": "In den Posteingang verschieben",
    "previous": "Vorherige Nachricht",
    "next": "Nächste Nachricht"
  },
  "pages": {
    "write": "Seite schreiben",
    "filterAria": "Seiten nach Status zeigen",
    "emptyFilter": {
      "planned": "Keine geplanten Seiten",
      "writing": "Keine Seiten in Arbeit",
      "live": "Keine Live-Seiten",
      "site": "Keine Seiten auf deiner Website"
    },
    "emptyFilterBody": "Wähle einen anderen Filter, um den Rest des Plans zu sehen.",
    "menu": {
      "aria": "Aktionen für {title}",
      "open": "Öffnen",
      "write": "Seite schreiben",
      "openAddress": "Adresse öffnen",
      "copyAddress": "Adresse kopieren",
      "copied": "Adresse kopiert"
    },
    "nextUp": "Als Nächstes",
    "topics": "Themen",
    "topicsMeta": "{count} Thema | {count} Themen",
    "next": "Als Nächstes: {question}",
    "everyPageWritten": "Jede Seite ist geschrieben",
    "backToPages": "Zurück zu den Seiten"
  },
  "posts": {
    "filterAria": "Beiträge nach Status zeigen",
    "emptyTitle": "Noch keine Beiträge",
    "emptyBody": "Raldo schreibt einen Beitrag aus deinen Argumenten und deiner Recherche.",
    "row": {
      "text": "Text",
      "pages": "{count} Seite | {count} Seiten"
    }
  }
}
